<template>
  <div class="content">
    <Header></Header>
    <div class="main" v-show="this.isApp == true ? false : true">
      <!-- <div class="main_left">
        <div class="index-buygift">
          <img src="../assets/index/btn-buygift-top.gif" alt="" />
          <a class="btn-buygift buy" href="">
            <img v-show="isbuyIconEn" src="../assets/index/buy_en.png" alt="" />
            <img v-show="isbuyIconZh" src="../assets/index/buy_zh.png" alt="" />
          </a>
        </div>
        <div class="index-transfer">
          <img src="../assets/index/btn-transfer-top.gif" alt="" />
          <a class="btn-transfer" href="">
            <img
              v-show="isbuyIconEn"
              src="../assets/index/gift_en.png"
              alt=""
            />
            <img
              v-show="isbuyIconZh"
              src="../assets/index/gift_zh.png"
              alt=""
            />
          </a>
        </div>

        <div class="side-info-wrap">
          <div class="side-info-gradient">
            <div class="dw-motion">
              <img src="../assets/index/yao.gif" alt="" />
            </div>
           <div class="xiazai">
              <div class="xia_left">
                <div class="">
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-ios.png"
                    />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank"
                    ><div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i></div
                  ></a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_center">
                    <img src="../assets/index/ma.png" alt="" />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_btm">
                    <img src="../assets/index/ma2.png" alt="" />
                  </a>
                </div>
              </div>
                <div class="xia_right subb">
                <div class="" @click="goDown">
                  <a class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-akp.png"
                    />
                  </a>
                  <a>
                    <div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i>
                    </div>
                  </a>
                  <a class="xia_left_center"
                    ><img src="../assets/index/apk.png" alt=""
                  /></a>
                </div>
              </div>
            </div>

            <div class="fbBtn_wrap" style="padding:0.2rem">
              <a href="https://t.me/Tiger777com" target="_blank">
                  <img src="../assets/index/liaotian.png" style="width:9.375rem;height:3.125rem" alt="">
                </a>
            </div>
          </div>
        </div>
      </div> -->
      <MainLeft></MainLeft>
      <div class="main_content">
        <div>
          <div class="navigation">
            {{ $t("teaching.home") }}>>{{ $t("agreement.user") }}
          </div>
          <div class="big_bod">
            <div class="small_bod">
              <div class="small_bod_small">
                <h1 class="useramt">{{ $t("agreement.user") }}</h1>
                <div class="changeamt subb">
                  <div
                    v-for="(item, index) in amtList"
                    :key="index"
                    :class="
                      active == index ? 'changeamt_item_sub' : 'changeamt_item'
                    "
                    @click="changColor(index)"
                  >
                    {{ item.title }}
                  </div>
                </div>
                <div v-show="isZh">
                  <div
                    id="privacy-wrap"
                    class="contract-wrap"
                    v-show="this.isShow==0? true:false"
                  >
<p>欢迎申请加入Tiger777（以下简称本公司）所属会员。请您完整浏览本信息后，再勾选【同意】来进行服务。请理解，当您勾选【同意】则表示您愿意以电子方式行使法律所赋予同意之权利，此行为并具有书面同意之效果。
本公司为确保会员之个人资料、隐私及消费者权益之保护，于未来将可能使用消费者之个人资料，谨依隐私权政策规定告知以下事项：</p>
<div class="title">一、搜集目的及方式</div>
<p>本公司之搜集目的在于进行客户管理、会员管理及营销与内部的统计调查与分析。搜集方式将透过会员填写电子或书面各项服务窗体等方式进行个人资料之搜集。</p>
<div class="title">二、搜集之个人资料类别</div>
<p>本公司于服务所搜集之个人资料，将包括下列事项：</p>
<div class="title">(一)必要搜集项目，所搜集之数据主要用于客户服务、营销与内部统计调查分析使用：</div>
<p>·登入时间</p>
<p>·登入位置</p>
<p>·装置机种、装置机码</p>
<p>·装置操作系统与版本</p>
<p>·使用社群账号登入者，将搜集社群账号ID，例如Facebook ID</p>
<div class="title">(二)非必要选填项目，所提供之数据得以佐证是否为账号持有者证明之一：</div>
<p>·辨识个人者：如姓名、地址、电话、相片、电子邮件等。</p>
<p>·政府资料中之辨识者：如身分证统一编号、护照号码等。</p>
<p>·个人描述：如年龄、性别、出生年月日等信息。</p>
<p>·执照或其他许可：如驾驶执照等。</p>
<p>·辨识财务者：如银行帐户之号码等。</p>
<p>·联络信息：如手机号码、住址等。</p>
<div class="title">三、利用期间、地区、对象及方式</div>
<div class="title">(一)期间：本公司营运期间。</div>
<div class="title">(二)地区：会员之个人资料将用于马来西亚地区。</div>
<div class="title">(三)利用对象及方式：会员之个人资料搜集除用于本公司之会员管理、客户管理之检索查询等功能外，将有以下利用方式：</div>
<p>1.实体物品领取：于交寄相关商品时，将利用于交付给相关物流、邮寄厂商用于物品寄送之目的。</p>
<p>2.游戏宣传营销：本公司将利用会员之地址及邮件、电话号码进行本公司或合作厂商商品之宣传营销。</p>
<p>3.当政府或主管机关为预防、调查、侦查或追诉犯罪或执行刑罚等目的需求时，依政府或主管机关要求配合提供所需信息。</p>
<p>4.本公司与会员间之其他因契约所产生之权利义务。</p>
<div class="title">四、会员个人资料之权利</div>
<p>会员交付本公司个人资料者，依个资法得行使以下权利（但法令另有规定外，不在此限）：</p>
<div class="title">(一) 查询或请求阅览。</div>
<div class="title">(二) 请求制作给予复制本。</div>
<div class="title">(三) 请求补充或更正。</div>
<div class="title">(四) 请求停止搜集、处理或利用。</div>
<div class="title">(五) 请求删除或停止使用。</div>
<div class="title">五、会员个人资料之保护</div>
<p>本公司处理个人资料之方式将具适当安全性，包括技术上及组织上之措施，以有效防止未经授权或非法之处理、遗失、破坏或损坏情形发生。</p>
<div class="title">六、会员为行使上开权利时，可径洽本公司客服进行申请，联络e-mail为admin@tiger777.com。本公司为保护所属会员权益，本公司有权要求会员填具申请表单并提示相关身分证明文件；若委托他人代理办理者，需请备妥委托书及双方身分证明文件。本公司得视状况酌收部分之行政费用。</div>
<div class="title">七、本公司为保护所属会员之权益，已采取合理及必要之防护措施，防止可能发生之个资泄漏、毁损、窜改及其他损害会员权益之情事发生。</div>
<div class="title">八、为避免发生会员权益之纠纷，敬请确实登载个人之资料；如未来因不实资料发生争议(例如伪冒身份)时，本公司将视状况而进行法律诉追。</div>
<div class="title">九、本公司为配合相关法令之异动，有权自行修订会员「个人资料保护政策」之内容。</div>
<div class="title">十、本政策将长期于本公司网站进行公告，须请会员自行密切注意；本政策进行修订时，亦将以公告或电子邮件方式通知所属全体会员。</div>

                  </div>
                  <div
                    id="contract-wrap"
                    class="contract-wrap"
                    style=""
                    v-show="this.isShow==1? true:false"
                  >
                  <p>欢迎来到Tiger777游戏平台（以下简称本游戏），为保障你的权益，请于注册成为【TIger777】会员并开始使用本游戏之服务前，详细阅读本使用合约书之所有内容。</p>
                  <p>提醒您，要先行审阅本契约三日以上，再按下【我同意】键。</p>
                  <p>立契约书人</p>
                  <p>消费者（以下简称「甲方」，请依会员注册流程填写）</p>
                  <p>企业经营者名称：Tiger777（以下简称「乙方」）</p>
                  <p>电子邮件：admin@tiger777.com</p>
                  <p>网址：www.tiger777.com</p>
                  <div class="title">第一条、法定代理人</div>
                  <p>甲方为限制行为能力人者，本契约订定时，应经甲方之法定代理人同意，本契约始生效力；甲方为无行为能力人者，本契约之订定，应由甲方之法定代理人代为之。</p>
                  <p>若有限制行为能力人未经同意或无行为能力人未由法定代理人代为付费购买点数致生法定代理人主张退费时，法定代理人得依官网公告流程，备妥证明文件并提出申请，经乙方确认后，退还甲方未使用之游戏费用。</p>
                  <p>乙方应于官网首页、游戏登入页面或购买页面以中文明显标示，若甲方为限制行为能力人或无行为能力人，除应符合第一项规定外，并应于甲方之法定代理人阅读、了解并同意本契约之所有内容后，方得使用本游戏服务，本契约条款变更时亦同。</p>
                  <div class="title">第二条、契约适用之范围</div>
                  <p>乙方提供甲方网络联机游戏服务及其他相关服务（以下简称本游戏服务），甲乙双方关于本游戏服务之权利义务，依本契约条款之约定定之。</p>
                  <div class="title">第三条、契约之内容</div>
                  <p>以下视为本契约之一部分，与本契约条款具有相同之效力：</p>
                  <p>(一) 乙方有关本游戏服务之广告或宣传内容。</p>
                  <p>(二) 计费制游戏之费率表及游戏管理规则。</p>
                  <p>本契约条款如有疑义时，应为甲方有利之解释。</p>
                  <div class="title">第四条、名词定义</div>
                  <p>本契约之名词定义如下：</p>
                  <p>(一) 网络联机游戏：系指甲方透过计算机、智能型装置或其他电子化载具，链接因特网至乙方指定之服务器所进行联机游戏。但不包括电子游戏场业管理条例所称电子游戏机、单纯区域联机或其他无需透过网络链接游戏服务器之游戏服务。</p>
                  <p>(二) 游戏网站：系指由乙方为提供本游戏服务所建置之网站。</p>
                  <p>(三) 游戏管理规则：系指由乙方订立，供为规范游戏进行方式之规则且不影响双方契约上之权利义务者。</p>
                  <p>(四) 游戏历程：系指自甲方登入本游戏起至注销本游戏时止，计算机系统对甲方游戏进行过程所为之纪录。</p>
                  <p>(五) 插件：系指非由乙方提供，以影响或改变乙方网络联机游戏运作为目的之程序。</p>
                  <div class="title">第五条、服务范围</div>
                  <p>本契约所提供之游戏服务，系由乙方指定之服务器，让甲方透过因特网联机登入使用本游戏服务。但不包括甲方向因特网接取服务业者申请接取因特网之服务，及提供上网所需之各项硬设备。</p>
                  <div class="title">第六条、游戏登录</div>
                  <p>甲方申请使用本游戏服务，应依申请流程，于游戏网站登录与身分证明文件相符之个人资料或其他必要信息。为确保甲方使用本游戏服务之权益，甲方提供之数据应可验证身分，若有不正确或已变更时，应立即通知乙方更新。</p>
                  <p>乙方若有为提供本游戏服务与甲方联络之必要，而甲方未提供正确之个人资料或原提供之数据不符合真实且未更新，乙方得于甲方提供真实数据或更新数据前，暂停甲方游戏进行及游戏历程查询之服务。但甲方能证明其为契约当事人者，不在此限。</p>
                  <div class="title">第七条、契约解除权规定</div>
                  <p>甲方得于开始游戏后七日内，以书面告知乙方解除本契约，甲方无需说明理由及负担任何费用。</p>
                  <p>前项情形，甲方得就未使用之付费购买点数向乙方请求退费。</p>
                  <div class="title">第八条、计费方式</div>
                  <p>本游戏服务之收费计算方式为免费制：</p>
                  <p>本游戏服务内（例如：游戏商城、在线商店等）有提供需甲方额外付费购买之点数、商品或其他服务（例如：虚拟货币或宝物、进阶道具等），乙方应在官网首页、游戏登入页面或购买页面公告载明付款方式及商品信息。</p>
                  <p>费率调整时，乙方应于预定调整生效日三十日前于官网首页、游戏登入页面或购买页面公告；若甲方于注册账号时已登录通讯数据者，并依甲方登录之通讯数据通知甲方。</p>
                  <p>费率如有调整时，应自调整生效日起按新费率计收；若新费率高于旧费率时，甲方在新费率生效日前已于官网中登录之付费购买点数或游戏费用应依旧费率计收。</p>
                  <div class="title">第九条、本游戏服务应载明之信息</div>
                  <p>乙方应于官网首页、游戏登入页面或购买页面及游戏套件包装上载明以下事项：</p>
                  <p>(一) 依游戏软件分级管理办法规定标示游戏分级级别及禁止或适合使用之年龄层。</p>
                  <p>(二) 进行本游戏服务之最低软硬件需求。</p>
                  <p>(三) 有提供安全装置者，其免费或付费信息。</p>
                  <p>(四) 有提供付费购买之机会中奖商品或活动，其活动内容、奖项及中奖等信息，并应记载「此为机会中奖商品，消费者购买或参与活动不代表即可获得特定商品」等提示。</p>
                  <div class="title">第十条、账号与密码之使用</div>
                  <p>甲方完成注册程序后取得之账号及密码，仅供甲方使用。前项之密码得依乙方提供之修改机制进行变更。乙方人员（含客服人员、游戏管理员）不得主动询问甲方之密码。乙方应于契约终止后三十日内，保留甲方之账号及附随于该账号之电磁纪录。</p>
                  <p>契约非因可归责甲方之事由而终止者，甲方于前项期间内办理续用后，有权继续使用账号及附随于该账号之电磁纪录。</p>
                  <p>第二项期间届满时，甲方仍未办理续用，乙方得删除该账号及附随于该账号之所有数据，但法令另有规定者不在此限。</p>
                  <div class="title">第十一条、账号密码遭非法使用之通知与处理</div>
                  <p>当事人一方如发现账号、密码被非法使用时，应立即通知对方并由乙方进行查证，经乙方确认有前述情事后，得暂停该组账号或密码之使用权，更换账号或密码予甲方，立即限制第三人就本游戏服务之使用权利，并将相关处理方式揭载于游戏管理规则。</p>
                  <p>乙方应于暂时限制游戏使用权利之时起，即刻以官网公告、简讯、电子邮件、推播或其他双方约定之方式通知前项第三人提出说明。如该第三人未于接获通知时起七日内提出说明，乙方应直接回复遭不当移转之电磁纪录予甲方，如不能回复时可采其他双方同意之相当补偿方式，并于回复后解除对第三人之限制。但乙方有提供免费安全装置（例如：防盗卡、电话锁等）而甲方不使用或有其他可归责于甲方之事由，乙方不负回复或补偿责任。</p>
                  <p>第一项之第三人不同意乙方前项之处理时，甲方得依报案程序，循司法途径处理。</p>
                  <p>乙方依第一项规定限制甲方或第三人之使用权时，在限制使用期间内，乙方不得向甲方或第三人收取费用。</p>
                  <p>甲方如有申告不实之情形致生乙方或第三人权利受损时，应负一切法律责任。</p>
                  <div class="title">第十三条、个人资料</div>
                  <p>关于个人资料之保护，依相关法律规定处理。</p>
                  <div class="title">第十四条、电磁纪录</div>
                  <p>本游戏之所有电磁纪录均属乙方所有，乙方并应维持甲方相关电磁纪录之完整。</p>
                  <p>甲方对于前项电磁纪录有使用支配之权利。但不包括本游戏服务范围外之移转、收益行为。</p>
                  <div class="title">第十五条、信息公开</div>
                  <p>乙方应于游戏网站上提供本游戏服务之服务器可容纳人数、同时上线人数与联机状况等相关信息，并定期更新。</p>
                  <div class="title">第十六条、联机质量</div>
                  <p>乙方为维护本游戏服务相关系统及软硬件设备而预先规划暂停本游戏服务之全部或一部时，应于七日前于官网首页、游戏登入页面或购买页面公告。但因临时性、急迫性或不可归责于乙方之事由者，不在此限。</p>
                  <p>因可归责乙方事由，致甲方不能联机使用本游戏服务时，乙方应立即更正或修复。对于甲方于无法使用期间遭扣除游戏费用或游戏内商品，乙方应返还游戏费用或商品，无法返还时则应提供其他合理之补偿。</p>
                  <div class="title">第十七条、企业经营者及消费者责任</div>
                  <p>乙方应依本契约之规定负有于提供本服务时，维护其自身计算机系统，符合当时科技或专业水平可合理期待之安全性。</p>
                  <p>计算机系统或电磁纪录受到破坏，或计算机系统运作异常时，乙方应于采取合理之措施后尽速予以回复。</p>
                  <p>乙方违反前二项规定或因游戏程序漏洞致生甲方损害时，应依甲方受损害情形，负损害赔偿责任。但乙方能证明其无过失者，得减轻其赔偿责任。</p>
                  <p>乙方计算机系统发生第二项所称情况时，于完成修复并正常运作之前，乙方不得向甲方收取费用。</p>
                  <p>甲方因共享账号、委托他人付费购买点数衍生与第三人间之纠纷，乙方得不予协助处理。</p>
                  <div class="title">第十八条、游戏管理规则</div>
                  <p>为规范游戏进行之方式，乙方应订立合理公平之游戏管理规则，甲方应遵守乙方公告之游戏管理规则。</p>
                  <p>游戏管理规则之变更应依第二十一条之程序为之。游戏管理规则有下列情形之一者，其规定无效：</p>
                  <p>(一) 抵触本契约之规定。</p>
                  <p>(二) 剥夺或限制甲方之契约上权利。但乙方依第十九条之规定处理者，不在此限。</p>
                  <div class="title">第十九条、违反游戏管理规则之处理</div>
                  <p>除本契约另有规定外，有事实足证甲方于本游戏服务中违反游戏管理规则时，乙方应于官网首页、游戏登入页面或购买页面公告，并依甲方登录之通讯数据通知甲方。</p>
                  <p>甲方第一次违反游戏管理规则，乙方应通知甲方于一定期间内改善。经乙方通知改善而未改善者，乙方得依游戏管理规则，按其情节轻重限制甲方之游戏使用权利。如甲方因同一事由再次违反游戏管理规则时，乙方得立即依游戏管理规则限制甲方进行游戏之权利。</p>
                  <p>乙方依游戏管理规则限制甲方进行游戏之权利，每次不得超过七日</p>
                  <div class="title">第二十条、申诉权利</div>
                  <p>甲方不满意乙方提供之联机质量、游戏管理、费用计费、其他相关之服务质量，或对乙方依游戏管理规则之处置不服时，得于收到通知之翌日起七日内至乙方之服务中心或以电子邮件或书面提出申诉，乙方应于接获申诉后，于十五日内回复处理之结果。</p>
                  <p>乙方应于官网或游戏管理规则中明定服务专线、电子邮件等相关联络信息与二十四小时申诉管道。</p>
                  <p>甲方反映第三人利用插件或其他影响游戏公平性之申诉，依第一项规定办理。</p>
                  <div class="title">第二十一条、契约之变更</div>
                  <p>乙方修改本契约时，应于官网首页、游戏登入页面或购买页面公告之，并依甲方登录之通讯数据通知甲方。</p>
                  <p>乙方未依前项进行公告及通知者，其契约之变更无效。甲方于第一项通知到达后十五日内：</p>
                  <p>(一) 甲方未为反对之表示者，乙方依契约变更后之内容继续提供本游戏服务。</p>
                  <p>(二) 甲方为反对之表示者，依甲方终止契约方式处理。</p>
                  <div class="title">第二十二条、契约之终止及退费</div>
                  <p>甲方得随时通知乙方终止本契约。</p>
                  <p>乙方得与甲方约定，若甲方逾一年未登入使用本游戏服务，乙方得定相当期限（不得少于三十日）通知甲方登入，如甲方届期仍未登入使用，则乙方得终止本契约。</p>
                  <p>甲方有下列重大情事之一者，乙方依甲方登录之通讯数据通知甲方后，得立即终止本契约：</p>
                  <p>(一) 利用任何系统或工具对乙方计算机系统之恶意攻击或破坏。</p>
                  <p>(二) 以利用插件、病毒程序、游戏程序漏洞或其他违反游戏常态设定或公平合理之方式进行游戏。</p>
                  <p>(三) 以冒名、诈骗或其他虚伪不正等方式付费购买点数或游戏内商品。</p>
                  <p>(四)因同一事由违反游戏管理规则达一定次数（不得少于三次）以上，经依第十九条第二项通知改善而未改善者。</p>
                  <p>(五) 经司法机关查获从事任何不法之行为。</p>
                  <p>乙方对前项事实认定产生错误或无法举证时，乙方应对甲方之损害负赔偿责任。契约终止时，乙方于扣除必要成本后，应于三十日内以现金、信用卡、汇票或挂号寄发支票方式退还甲方未使用之付费购买之点数或游戏费用，或依双方同意之方式处理前述点数或费用。</p>
                  <div class="title">第二十三条、停止营运</div>
                  <p>因乙方停止本游戏服务之营运而终止契约者，应于停止终止前三十日公告于官网首页、游戏登录页面或购买页面，并依甲方登录之通讯数据通知甲方。</p>
                  <p>乙方未依前项期间公告并通知，除应退还甲方未使用之付费购买点数或游戏费用且不得扣除必要成本外，并应提供其他合理之补偿。</p>
                  <div class="title">第二十四条、送达</div>
                  <p>有关本契约所有事项之通知，甲方同意乙方依甲方登录之通讯数据为送达。</p>
                  <p>前项登录通讯数据若有变更，甲方应即通知乙方。乙方应依变更后之通讯数据为送达。</p>
                  <p>乙方依甲方登录之通讯数据所为之通知发出后，以书面通知到达甲方，或电子邮件进入甲方之电子邮件服务器中，推定为已送达。</p>
                  <p>因甲方之故意或过失致乙方无法为送达者，乙方对甲方因无法送达所致之损害不负赔偿责任。</p>
                  <div class="title">第二十五条、准据法</div>
                  <p>本契约以台湾法律为准据法。</p>
                  <div class="title">第二十六条、管辖法院</div>
                  <p>因本契约而生之事件，双方合意以台湾中国地方法院为第一审管辖法院。</p>
                   </div>
                  <div
                    id="rules-wrap"
                    class="contract-wrap"
                    style=""
                     v-show="this.isShow==2? true:false"
                  >
                    <section>
                      <p>
                        出现下列违规行为者，经游戏管理员查明属实后，视违反情节，轻微者则强制驱离或禁言亦或停止发话及交易功能，情节重大者则以停权或契约终止。
                      </p>
                      <p>以下为管理与处罚事项：</p>
                      <table cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <th class="guizhe">游戏规章</th>
                            <th class="guizhe">处罚方式</th>
                          </tr>
                          <tr>
                            <td>
                              发言不当（例如：不实言论、不当煽动言论、涉及人身攻击）
                            </td>
                            <td>将【禁言】</td>
                          </tr>
                          <tr>
                            <td>
                              不当游戏行为，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权三日；第二次以上惩处停权七日。
                              情节严重者，将处以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777
                              】游戏平台买卖游戏币，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权三日；第二次惩处停权七日。
                              情节严重者，将处以【终止契约】处置或将【取消赠与服务】。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台买卖道具
                              (非本游戏内所正常使用)，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权三日；第二次惩处停权七日。
                              情节严重者，将处以【终止契约】处置或将【取消赠与服务】。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777
                              】游戏平台散布、宣传具商业广告、或刊登援交色情之资料、网站，或从事中介行为。
                            </td>
                            <td>将处以【终止契约】处置。</td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台买卖、收受、转让
                              游戏账号，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权七日；第二次将处以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777
                              】游戏平台散布、宣传法令所不允许之言论或引诱人犯罪之言论。
                              （例如：硬的、软的、男生、女生、买卖糖果…等所有贩毒的代名词。）。
                            </td>
                            <td>
                              第一次惩处停权七日；第二次将处以【终止契约】处置。
                              情节严重者，直接处以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              冒充官方人员利用【Tiger777
                              】游戏平台，冒用本公司游戏客服人员或游戏管理员之身分或申请容易造成误认为客服人员或游戏管理员之昵称，与玩家进行任何互动。
                            </td>
                            <td>将处以【终止契约】处置。</td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777
                              】游戏平台，涉及盗用、诈骗违反事实发生时管辖区域法令之行为。
                            </td>
                            <td>
                              将处以【暂时冻结】处置。
                              查证犯罪属实，其违法取得之游戏币、道具等则一并回收(含所有相关账号)。并以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              经司法机关查获或查证乙方疑似从事不法之行为。
                            </td>
                            <td>
                              将处以【暂时冻结】处置。经（检警或相关单位来函要求），其违法取得之游戏币、道具等将暂时冻结若事后查证犯罪属实则一并回收(含所有相关账号)。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用游戏之BUG或恶意透过游戏网站程序漏洞，使用插件或擅自修改所获取之不当游戏币及道具。
                            </td>
                            <td>
                              将处以【暂时冻结】处置。回收并删除因利用BUG所得之不当得利及角色数据等纪录。且本公司将采取法律途径处理。(含所有相关账号)
                            </td>
                          </tr>
                          <tr>
                            <td>
                              大量注册账号利用游戏取得不当得益，重大过失不知、明知道具、游戏币违法或不当取得仍为收受之行为。
                            </td>
                            <td>
                              将处以【终止契约】处置。
                              回收所得之不当得利，且本公司将采取法律途径处理。(含所有相关账号)。
                            </td>
                          </tr>
                          <tr>
                            <td>大量新申请账号破坏游戏秩序者。</td>
                            <td>将处以【使用者禁登】或【终止契约】处置。</td>
                          </tr>
                          <tr>
                            <td>
                              恶意申诉回报、辱骂，影响客服人员及客服中心作业，本公司将采取法律途径处理。
                            </td>
                            <td>
                              第一次，惩处停权三日；第二次以上，惩处停权七日。情节严重者，将处以【终止契约】处置。
                              包含Tiger777
                              游戏所有服务平台、游戏公开频道或密频频道。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              使用不当头像图片者（使用未经许可之他人照片、色情猥亵及含煽情淫秽图、人身攻击字样图、不雅字句图、违反社会道德性质、泛政治化、具争议性、商标图、盗用版权图者）
                            </td>
                            <td>
                              第一次惩处锁定头像24小时并强制解除该图片；第二次再违规惩处锁定头像七日并强制解除该图片；第三次违规者直接永久锁定其功能处置并强制解除该图片。
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" class="txt-deep-red">
                              注：以上部份管理与处罚事项，于下方【罚则说明】、【违规事项说明】内详述。
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                    <section>
                      <div class="big-title">罚则说明</div>
                      <p>
                        对于触犯本游戏规范的会员，本公司将视情节轻重适度施以以下处分：
                      </p>
                      <p class="txt-indent">
                        (一)【强制脱机】：藉由系统操作强制使违规者离开游戏。
                      </p>
                      <p class="txt-indent">
                        (二)【禁言】：使违规者在一定时间内无法使用任何方式发言。
                      </p>
                      <p class="txt-indent">
                        (三)【强制关闭频道】：藉由系统操作强制关闭私人创设之频道。
                      </p>
                      <p class="txt-indent">
                        (四)【暂时冻结】：在一定时间内暂时停权违规者对其账号的使用权。
                      </p>
                      <p class="txt-indent">
                        (五)【终止契约】：终止违规者对其账号的使用权利，或将该使用者列为本公司的拒绝往来户，永久停止该账号的使用权及本公司的任何服务。处以终止契约者，同时将游戏内游戏战绩或虚拟物品全数归零。
                      </p>
                      <p class="txt-indent">
                        (六)【使用者禁登】：同一使用者禁止登入Tiger777游戏。
                      </p>
                      <p class="txt-indent">
                        (七)【停权】：同一使用者禁止登入Tiger777游戏。若使用者账号违反上列游戏管理规章遭停权累计达第【三】次者，本公司有权立即终止使用者契约，永久停止该账号的使用权及本公司的任何服务，同时将该使用者账号内于【Tiger777】内之全部虚拟物品及游戏币归零。并列为本公司的拒绝往来户
                      </p>
                    </section>
                    <section>
                      <div class="big-title">违规事项说明</div>
                      <div class="title">不当游戏行为</div>
                      <p>
                        若查明属实确定有以不当方式来进行游戏、使用本公司服务或藉由本公司服务从事非法行为者，造成其他玩家在线虚拟财产（如游戏币）损失或竞赛不公，本公司得于通知本服务使用人，由本公司按其情节轻重限制其游戏使用权利，以维护其他会员权益与【Tiger777】 游戏环境。
                        游戏中禁止贩卖、购买游戏点数卡、虚拟物品。
                        除此之外，所有参与或协助违反本游戏管理规范行为之使用者账号，本公司亦将以相同条例处理之。禁止从事不当游戏行为与违反本公司相关规范，何谓不当游戏行为：
                      </p>
                      <p class="txt-indent">
                        (一)
                        恶意透过游戏系统的漏洞(BUG)，或以任何形式之非游戏所附程序（如：侵入、拦截、破坏、修改游戏数据、封包值）
                        或任何更改原始程序及系统上的锁定与解除锁定系统设定…等不正当方式，来取得游戏中不当游戏战绩、影响游戏公平性者。
                      </p>
                      <p class="txt-indent">
                        (二)
                        以他人账号进行交易、利用游戏获取不当得益或其他违反公平合理之方式使用本服务者。
                      </p>
                      <p class="txt-indent">
                        (三) 利用【Tiger777】游戏平台上或平台上各款游戏中的机制，刻意造成游戏币等游戏资产不当流向。
                      </p>
                      <p class="txt-indent">
                        (四)
                        于游戏中进行买卖游戏币、游戏点数卡或其他相关虚拟物品；【Tiger777】平台提供虚拟游戏币及物品互相赠与功能，但仅提供转换机制正常，不允许买卖的交易行为，且用户不得私下以私下交易结果要求本公司取消已完成转换之虚拟物品、游戏币。
                      </p>
                      <p class="txt-indent">
                        (五) 疑似利用在线储值的方式盗买点数者。
                      </p>
                      <p class="txt-indent">
                        (六) 利用【Tiger777】游戏平台散布、宣传具商业广告或刊登援交色情之资料、网站，或从事中介行为。
                      </p>
                      <p class="txt-indent">
                        (七)
                        从事伤及第三人权益与隐私之行为。（违反个人资料保护法）
                      </p>
                      <p class="txt-indent">
                        (八)
                        干扰游戏或活动进行，且经线上管理人员劝告仍不听从改善。
                      </p>
                      <p class="txt-indent">
                        (九)
                        冒用本公司客服人员或游戏管理员之身分或申请易造成误认为客服人员或游戏管理员之昵称，与玩家进行任何互动。
                      </p>
                      <p class="txt-indent">
                        (十) 利用【Tiger777】游戏平台中的发话机制，以辱骂、诽谤、人身攻击、威胁，或以含淫秽之意（含音似者）、种族歧视之言语攻击其他会员。将【禁言】。
                      </p>
                      (十一) 于游戏大厅中恶意洗频，经【Tiger777】游戏平台会员，拍照检举查询属实。将【禁言】。
                    </section>
                    <section>
                      <div class="title">
                        不当言论 (含游戏内言词、网站平台上留言)
                      </div>
                      <p>
                        为保持游戏的善良风气及所有玩家都可正常观看与使用游戏频道，请大家遵守网络规矩，以维持干净单纯的游戏空间。玩家于Tiger777游戏平台的发言中，包含利用『直接、间接、影射、方言、俚语、错字(注音文)、数字或图形等代替一般的脏话、谐音、解剖学名辞、污辱及这类相关字词的正、反向书写等方式，与文字组合后具有下述定义的字眼与内容皆为不被允许情形』。Tiger777游戏平台上若有以下状况，本公司有权在无事先告知的情况，依各式情形直接进行处分，若于频道上所发表之言论是不被允许，但未被列于以下限制说明，将依道德社会观念之公正认定进行裁决，将【禁言】：
                      </p>
                      <p class="txt-indent">
                        (一) 玩家于【Tiger777】游戏平台上，公开频道中发送含有低级、亵渎、粗鲁、辱骂、诽谤、人身攻击、威胁、挑衅、种族与性别歧视、不雅文字、猥亵及含煽情淫秽、具有色情内容或含意、有违社会善良风俗的惯用词汇之言词内容，影响其他玩家进行游戏之观感。
                      </p>
                      <p class="txt-indent">
                        (二) 玩家于【Tiger777】游戏平台，游戏言词内容假冒官方人员，或是自称官方代表、游戏管理者等。
                      </p>
                      <p class="txt-indent">
                        (三) 蓄意妨碍、辱骂或欺骗官方人员。
                      </p>
                      <p class="txt-indent">
                        (四) 于【Tiger777】游戏平台散布对于公司未经证实或无具体事实根据的不实言论。(包含公开或未公开之讯息(恶意以文字或图片形式)，或是纯属玩家个人揣测等)。企图影响其他玩家进行游戏之观感，若因此造成本公司损害，本公司并保留一切法律追诉之权利。
                      </p>
                      <p class="txt-indent">
                        (五) 于【Tiger777】游戏平台公开频道洗频或重复发言多次，造成玩家无法正常观看频道之情形，例如持续发言无意义的内容(如英数字、乱码、符号、表情、指令、系统默认文字)，
                        或使用相同循环之文字进行重复且有频率的方式发言，皆构成洗频
                        (两人以上即是公开频道) 。
                      </p>
                      <p class="txt-indent">
                        (六)
                        玩家于公开频道上处理私人纠纷或是互相谩骂，以及试图散布并影响其他玩家加入纷争，干扰其他玩家进行游戏。
                      </p>
                      <p class="txt-indent">
                        (七) 于【Tiger777】游戏平台上，违反个人隐私资料的保护，例如：透露其他玩家之Tiger777会员数据。
                      </p>
                      <p class="txt-indent">
                        (八) 于【Tiger777】游戏平台上进行商业广告之行为与内容(如兜售与非游戏相关商品、涉及现实有价物交易之广告行为)。
                      </p>
                      <p class="txt-indent">
                        (九) 于【Tiger777】游戏平台上进行贩卖毒品、枪械等不法物品或涉及刊登援交、色情等不法广告。
                      </p>
                      <p class="txt-indent">
                        (十) 于【Tiger777】游戏平台上散布具有犯罪行为或是教唆犯罪之内容。
                      </p>
                      <p class="txt-indent">
                        (十一) 于【Tiger777】游戏平台上散布、宣传法律所定之不法行为诱人犯罪（例如：言词中含以贩毒之黑话例如：硬的、软的、男生、女生、买卖糖果...等所有贩毒的代名词）。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        不当名称(含游戏内名称、网站平台上昵称)
                      </div>
                      <p>
                        游戏内的角色名称及频道名称为玩家创立时自行输入，角色及频道名称一经设定后将无法任意变更，请玩家妥善为自己心爱的角色及频道命名。
                        玩家角色及频道名称，有违反命名规定的不当名称将在无事先告知的情况下遭到锁定、删除、解散或者变更名称的处置。若有以下状况，本公司有权在无事先告知的情况，依各式情形直接进行处分，但未被列于以下限制说明，将依道德社会观念之公正认定进行裁决。
                      </p>
                      <p class="txt-indent">
                        (一)
                        网站及各式名称/图片不得与官方工作人员名称类似、假冒本公司相关组织名称，以及与工作人员名称混淆之名称，包含中间仅以普通玩家可能无法辨识之特殊字形区隔之以上类似组合。例如：客服、Tiger777、GM等皆属本公司官方人员。
                      </p>
                      <p class="txt-indent">
                        (二)
                        有影射、亵渎、粗鲁、辱骂、诽谤、人身攻击、威胁、挑衅Tiger777游戏公司或从业人员含意之玩家昵称或图片。例如：烂金好运、白痴客服…等。
                      </p>
                      <p class="txt-indent">
                        (三)
                        游戏角色名称/图片含有种族与性别歧视、不雅文字、猥亵及含煽情淫秽、具有色情内容或含意、有违社会善良风俗的惯用词汇之言词。例如：
                        谁要一夜情、援交妹。
                      </p>
                      <p class="txt-indent">
                        (四)
                        游戏角色名称/图片含法律所定之不法行为诱人犯罪文字。例如：硬的、软的、男生、女生、买卖糖果…等所有贩毒的代名词。
                      </p>
                      <p>
                        注：文字(包含全/半型文字、大/小写文字、谐音等皆于限制当中)
                      </p>
                    </section>
                    <section>
                      <div class="title">利用BUG进行游戏(含宣传、散播消息)</div>
                      <p>
                        玩家不可利用游戏中非自然或非刻意之错误BUG或以违反公平合理之方式、手段进行游戏
                        (未公告BUG之部份将以本公司认定为主)或游戏漏洞，甚至造成服务器负担加重或当机等，让自己受惠及利用他人，导致游戏失衡之行为，玩家在发现游戏的BUG后，应及时向游戏管理人员反映。如玩家利用游戏程序的BUG、漏洞或规则不尽完善之处以及其他任何非正常方式，而取得之不当利益暴增等等，导致游戏造成不平衡等损失，与影响其他玩家权益及造成不属于原先设计范围效果，所有关系者经查证属实后之一切数据，处理方式如下：<br />本公司将采取游戏账号【暂时冻结】方式，并回收玩家利用BUG进行游戏而直接、间接获得之非法利益，但若发生之情形过于重大而有无法正确回收非法利益，或该非法利益可能连带产生其他无法回溯之情况，本公司以书面或电子邮件告知后，将暂停其游戏使用权直至用户账号数据修正为止，并且将回溯至正常数据之前的备文件数据。
                      </p>
                    </section>
                    <section>
                      <div class="title">恶意篡改游戏程序</div>
                      <p>
                        用户不得侵入、拦截、破坏游戏程序，或对游戏进行修改、编译、修改游戏程序内存编码或解除游戏程序加密，或以任何方式篡改、复制更改封包及数值…等，来变更游戏程序内容数据，而取得之不当利益暴增等等，而导致游戏造成不平衡等损失，与影响其他玩家权益及造成不属于原先设计范围效果，所有关系者经查证属实后之一切数据，处理方式如下：<br />官方经查证属实者，将回收玩家恶意篡改游戏程序进行游戏而直接、间接获得之非法利益，本公司有权在无事先告知的情况，立即对会员终止契约，其非法所得之游戏币、道具等将一并回收，且本公司将保留法律追溯权。(含所有相关账号)。
                      </p>
                    </section>
                    <section>
                      <div class="title">举发『黑客』、『舞弊』</div>
                      <p>
                        为落实维护游戏公平性与协助本公司取缔可能用『黑客』和『舞弊』行为玩家，您同意Tiger777程序无须对您通知即可从您的计算机及其组件中包括，但不限于获得某些信息，包括您的键盘、鼠标、显示适配器、网络卡、CPU、RAM、IP地址等相关信息，其中包含是否同时有与Tiger777同时运行之『未经许可的第三方程式』。
                      </p>
                      <p class="txt-deep-blue">
                        注：上述信息仅用于保护玩家、维护游戏质量及找出恶意不当或违法行为之玩家等，追溯资料。
                      </p>
                      <p class="txt-deep-blue">
                        注：本文中所称的『未经许可的第三方程式』系指未经本公司同意使用之程序。其他包括但不限于本公司独自判定(1)能进行或提供任何舞弊；(2)能让游戏client端程序修改或侵入游戏接口、环境；(3)拦截、挖掘或以其他方式或通过游戏收集信息的任何第三方软件。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        优质愉快的游戏环境需要大家共同监督维护，若发现任何本公司禁止之违规行为，我们需要您的协力检举、立即回报。
                      </div>
                      <p class="txt-indent">
                        (一) 径行举发<br />为消弭游戏中游戏不公现象，游戏管理员每日针对前一日游戏成绩与相关游戏资产之数额进行安全检查。凡游戏历程有作弊嫌疑或相关游戏资产数量不正常增加之会员，都将列入考核名单，经查证属实，本公司得于通知本服务使用人，立即终止本合约。
                      </p>
                      <p class="txt-indent">
                        (二) 回报／检举告发<br />若有发现疑似违反本游戏规范者，可向官方进行回报或检举告发。<br />官方接获通知后，将立即查明。如查证属实，本公司得于通知本服务使用人，公布Tiger777游戏官网。
                      </p>
                      <ol>
                        <li>
                          进行回报与检举，请附上：
                          <ul>
                            <li>
                              您的昵称（若为检举，请同时附上：您要检举的会员昵称）
                            </li>
                            <li>事由</li>
                            <li>事发时间、地点（游戏区或单元或活动名称）</li>
                            <li>
                              拍下的完整图片或其他可左证之数据
                              请注意：若为检举，受理期限以事发当月起算一个月内，逾时恕不受理。
                            </li>
                          </ul>
                        </li>
                        <li>
                          进行回报与检举方式如下：
                          <ul>
                            <li>
                              Tiger777客户服务信箱（需附加图片者适用）
                            </li>
                            <li>游戏内的『问题回报』</li>
                          </ul>
                        </li>
                      </ol>
                      <p class="txt-indent">
                        (三) 处分申诉<br />请玩家依照申请会员时所签署之「使用者合约」中，「申诉权利」之内容为依据。请至游戏内问题回报或来信<a
                          href='"admin@tiger777.com"'
                          >admin@tiger777.com</a
                        >，我们将于收到留言或来信后尽速与申诉会员联络。
                      </p>
                    </section>
                    <section>
                      <div class="title">虚拟物品相关规定</div>
                      <p class="txt-indent">
                        (一)
                        游戏中开放使用者账号以点数兑换虚拟物品或游戏币，惟使用者须同意，完成兑换流程后，即不再具有任何实质价值。
                      </p>
                      <p class="txt-indent">
                        (二)
                        游戏中开放使用者账号以点数兑换虚拟物品或游戏币时，Tiger777只提供单向兑换的媒介，无法将其转换成真实点数，若用户账号私下有其他交易行为
                        而造成个人损失，本公司将不负责赔偿或其他法律责任。
                      </p>
                      <p class="txt-indent">
                        (三)
                        游戏中所颁发的虚拟物品，只针对特殊活动与单一账号进行发放，使用者账号不得要求本公司将真实身分中所有的账号与个别虚拟物品集中或转移到特定账号。
                      </p>
                      <p class="txt-indent">
                        (四) Tiger777提供虚拟游戏币及物品相互交易功能，但仅提供转换机制，严禁有买卖游戏币之行为，
                        且用户不得以私下交易的结果要求本公司取消已完成转换之虚拟物品、游戏币。
                      </p>
                      <p class="txt-indent">
                        (五)
                        使用者账号若于现实生活中于本游戏之道具、人物及其他各项电磁记录，与他人交易或互易行为，因此而产生的纠纷与本公司无关。
                      </p>
                      <p class="txt-indent">
                        (六)
                        因天灾、不可抗力或其他非人为因素而导致用户游戏数据的损失，本公司不负赔偿责任。
                      </p>
                      <p class="txt-indent">
                        (七)
                        使用者所购买的点数卡，一经储值后，即表示用户已经确认系统下各项服务之消费；存入使用者账号的游戏点数，将无法转让给第三者。
                      </p>
                      <p class="txt-indent">
                        (八)
                        使用者发现游戏账号遭人非法使用或有任何异常破坏使用安全的情形时，应立即通知本公司；若因可归责于用户而导致账号、密码、游戏数据遭他人非法使用所造成之损失，本公司将不负责处理相关纠纷及赔偿。（请当事者本人循司法程序向盗用者求偿）。
                      </p>
                      <p class="txt-indent">
                        (九)
                        因游戏版本更新，造成部分使用者出现游戏版本不正确或任何因使用者账号个人因素，无法继续进行游戏（同时段内非所有的使用者账号无法登入Tiger777游戏服务器），则本公司将尽力提供咨询服务，协助使用者账号继续使用本公司之服务，但该处理时段内因用户账号个人计算机设备问题或自身、其他第三方或相关电信业者网络系统软硬件设备之故障或失灵造成无法游戏的损失，本公司将不负损害赔偿责任。
                      </p>
                      <p class="txt-indent">
                        (十) 除了Tiger777举办之活动与游戏程序本身之问题外，使用者账号间任何私下交易的结果皆与本公司无关。
                      </p>
                      <p class="txt-indent">
                        (十一)
                        使用者于付费购买本应用程式及／或应用程式套件（包含储值点数、虚拟游戏币或虚拟商品或其组合套件）后7日内，得持未使用之储值序号与购买凭证，向原购买处请求退费，如原购买处不予退费，得洽本公司办理退费。如使用者係于平台业者付费购买/下载本应用程式及／或应用程式套件，应依平台业者规定办理退费。
                      </p>
                    </section>
                    <section>
                      <div class="title">竞赛活动规范</div>
                      <p>
                        举凡本公司与有奖竞赛相关的各活动，无论为常态或不定期举办，会员一旦经由游戏管理员查明属实，确有在各项竞赛活动中从事本游戏管理规范中所明订禁止之行为，或其他未列举而影响游戏公平性的非正当游戏方式，本公司都将按照本规范从严处置，并且判定丧失继续参赛与获奖资格。
                      </p>
                      <p>
                        各竞赛活动若有其他未在本规范订定范围内之条文，将在各竞赛活动之相关网页中另行订定，并自其公告日起生效实施。
                      </p>
                    </section>
                    <section>
                      <div class="title">其他特殊活动办法与管理</div>
                      <p>
                        举凡本公司因功能需求或针对不同主题所举办之特殊活动，本公司会提供该项功能／活动的使用说明与规范，若会员对于新增的服务内容或游戏活动比赛方式有不同意之处，请勿使用该项功能或参与该项活动比赛。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        本公司之客服及游戏管理员(GM)不予受理之事情
                      </div>
                      <p class="txt-indent">
                        (一)
                        在特定活动或竞赛的相关规定期限后，逾期询问虚拟或实体赠品、奖品之兑奖领奖事宜。
                      </p>
                      <p class="txt-indent">
                        (二)
                        点数卡开卡储值后，要求本公司进行回复、转让、更改配点设定。
                      </p>
                      <p class="txt-indent">
                        (三) 本公司禁止会员利用Tiger777会员服务进行任何商业行为。若会员之间有任何私下交易，
                        不得以结果或纠纷要求本公司取消或回复已完成之虚拟游戏币转汇。惟会员违反使用者合约时，本公司将按照合约内容进行处理。
                      </p>
                      <p class="txt-indent">
                        (四)
                        会员之间若于游戏有特殊玩法设定，除了涉及以违反公平合理之方式或手段进行游戏之外，本公司不介入处理。
                      </p>
                      <p class="txt-indent">
                        (五)
                        会员之间私人恩怨、纠纷，本公司不介入处理，但不得于公开频道发送（低级、亵渎、粗鲁、辱骂、诽谤、人身攻击、威胁、挑衅、
                        种族与性别歧视、不雅文字、猥亵及含煽情淫秽、具有色情内容或含意、有违社会善良风俗的惯用词汇之言词内容，影响其他玩家进行游戏之观感。）将【禁言】
                      </p>
                      <p class="txt-indent">
                        (六)
                        询问关于公司内部、系统方面、游戏内部数值设定或是GM私人问题与其他玩家的个人资料等非相关游戏进行的问题，为保守公司内部机密信息公司运作之机密数据，以及保持高质量的服务并保障所有玩家的权益，我们将不受理玩家询问，请玩家配合。
                      </p>
                    </section>
                    <section>
                      <div class="title">本公司不进行损失补偿之情形</div>
                      <p class="txt-indent">
                        (一)
                        会员若因本身网络服务业者网络断线、或自动脱机、或计算机程序错误，发生断线情形，而造成游戏数据，如战绩与点数有所损失。
                      </p>
                      <p class="txt-indent">
                        (一)
                        会员若因本身网络服务业者网络断线、或自动脱机、或计算机程序错误，发生断线情形，而造成游戏数据，如战绩与点数有所损失。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        相关风险与责任，由会员自行负担之情形
                      </div>
                      <p class="txt-indent">
                        (一) 本公司之各项会员服务可能发生下列情形：
                      </p>
                      <ol>
                        <li>网站设备进行必要之保养。</li>
                        <li>
                          自身、其他第三方或相关电信业者网络系统软硬件设备之故障或失灵。
                        </li>
                        <li>
                          因人为操作上之疏失而造成中断、暂时无法使用、迟延、数据传输或储存上之错误。
                        </li>
                        <li>遭第三人侵入系统篡改或伪造变造数据</li>
                        <li>
                          因战争、天灾、其他不可抗力因素或其他非人为因素，致使本公司设备无法正常运作。
                        </li>
                      </ol>
                      <p>
                        就以上情形，本公司不担保各项服务之正确、完整、安全、可靠、合适、时效、稳定、不会断线及出错。
                        会员需明白使用本服务之所有风险及可能致生之任何损害，不得因此而要求任何补偿或赔偿，并且同意对于会员所传送之电子邮件、档案及其他数据做备份。若因传送过程而造成电子邮件、档案及其他数据之遗失，本公司不负任何担保责任。
                      </p>
                      <p class="txt-indent">
                        (二)
                        会员在本公司网站上传之数据（如谈话、指令等），其内容限制如下：
                      </p>
                      <ol>
                        <li>
                          禁止侵犯任何第三者的知识产权，版权或公众／私人权利。
                        </li>
                        <li>禁止违反任何法律或善良风俗。</li>
                        <li>
                          禁止任何毁谤他人，性骚扰，种族歧视或对孩童有不良影响的内容。
                        </li>
                      </ol>
                      <p>
                        以上均属于会员的个人行为，一旦发生，会员须自行负担相关法律责任。
                      </p>
                      <p class="txt-indent">
                        (三) 交易或购买使用非法储值序号：<br />在线购买来路不明的游戏序号是不安全的，会员不得与他人私下进行游戏点数交易，若因而购买到利用在线付费机制（如信用卡、电信账号代为支付）盗刷而得的游戏储值序号，本公司将对该会员施以暂时冻结处分，直到该会员完成付款动作后，始予以复权。而在线付费机制盗刷的相关法律责任也将由该账号之使用会员自行担负，本公司亦会配合司法单位进行调查。
                      </p>
                      <p class="txt-indent">
                        (四) 本公司禁止会员利用Tiger777会员服务进行任何商业行为。若会员之间有任何私下交易，其结果或纠纷本公司一概不负责任。
                      </p>
                      <p class="txt-indent">
                        (五)会员有义务妥善保管在Tiger777之账号与密码，不泄露、出借、转让，或提供予第三人知悉。
                        若发现账号或密码遭人偷盗、非法使用或有任何异常破坏使用安全之情形，应立即通知本公司，以利本公司采取相关措施。但不得将本公司所采取之措施解释为本公司对你有明示或默示担保或赔偿责任。<br />对于你的账号及密码遭人非法使用，本公司不负任何赔偿责任，但可申请游戏历程至事实发生时管辖区域警政单位报案，依照法律程序起诉处理。本公司将依法提供相关资料，配合案件之协助调查。
                      </p>
                    </section>
                    <section>
                      <div class="title">条款变更权利声明</div>
                      <p>
                        于首页进因应法律之变动或提供游戏服务之必要，本公司保留新增、修改或删除本管理规章之全部或局部条文之权利，并于修改时行公告，不再另行个别通知，
                        玩家不得因此而要求任何补偿或赔偿，并且自该修订条文于本网站公告之时起受其约束。玩家一旦于公告后继续使用本公司各项服务，即视为已经同意该修订条款。
                      </p>
                    </section>
                    <section>
                      <div class="title">网络犯罪报案协助</div>
                      <p>
                        依个人资料保护法规定，本公司在政府司法单位没有介入调查并来函通知配合后续处理前，依法不能涉入该纠纷及做协助或处置，若遇到疑似诈骗或盗取玩家账号等事件，需由事实发生时管辖区域警政单位协助您进行处理。目前针对网络游戏上玩家遭盗用或疑似诈骗事件时，司法单位在实行网络犯罪报案程序时会要求提供游戏历程、账号持有证明等报案必备数据。
                      </p>
                      <p>
                        本公司依法恕不能主动为您提出网络犯罪相关的控诉，由于大部分的行为是诱骗玩家以交易方式达成目的，以达到留下银货两讫的确认交换动作，在官方以记录判断的立场上难以处理双方各说各话的纠纷，更无法依照单方面说词而强制取回财物，或者告知对方数据，因此无法对此类问题予以裁夺，请玩家特别注意。
                      </p>
                      <p>
                        如玩家不幸发生诈欺事件，因上述行为产生涉及法律行为之纠纷，被害者可尽快与客服联系依循流程申请后，取得相关报案必备资料，至邻近县市警察局报案，当本公司收到相关机关发送协助调查的公文时，本公司将依法提供司法单位所需之数据数据，以供查询左证，尽力协助警方侦办，将不肖玩家于现实社会中绳之以法。
                      </p>
                    </section>
                    <section>
                      <div class="title">玩家申请游戏历程说明与注意事项</div>
                      <p>
                        玩家账号遭盗用或游戏中被诈骗欲报警处理的玩家，需由本公司提供游戏历程，事实发生时管辖区域警政单位才会受理。报案流程如下：
                      </p>
                      <p class="txt-indent">
                        (一)
                        请您至官方网站→【客服专区】→【问题回报】→【留言内容】→载明您欲申请游戏历程的缘由。
                      </p>
                      <p class="txt-indent">
                        (二)
                        本公司在收到您的留言，核对身分资料及审核内容皆无误后，即会通知付费，申请游戏历程所需之服务费用需自行汇款至客服中心所提供的银行账号内，待付费完成后，与客服专员确认完毕后，即转交相关部门为您调阅历程。将于七个工作天（不含例假日）内，以挂号或电子邮件寄出
                        『游戏历程』、『账号证明书』给您，并在数据寄出后由客服专员以联络方式通知。
                      </p>
                      <p class="txt-indent">
                        (三)
                        请您持『游戏历程』、『账号证明书』至事实发生时管辖区域警政单位报案，完成报案程序后，本公司将在警方来函后提供详细资料配合检调侦查，故请在完成报案流程后，向警方侦办单位确认办案进度。
                      </p>
                      <p class="txt-indent">
                        (四)
                        提醒玩家注意！若提出的申诉案件中，涉及玩家账号遭盗用，或涉及私人之间的诈欺、纠纷等计算机犯罪事件时，依据隐私权政策，本公司在政府司法单位没有介入调查并来函通知本公司配合后续处理前，依法不能涉入该件纠纷及协助或处置。
                      </p>
                      <p class="txt-indent">
                        (五)
                        受限于电磁数据保管义务，每份历程仅提供最多一个月的记录，账号申请调阅之记录仅提供查询申请日起算的前３个月。<span
                          class="txt-deep-blue"
                          >(注：若账号要申请近三个月的游戏历程记录，则必须申请三份游戏历程。) </span
                        >请尽早申请方便作业，超过受理期限，恕不接受办理，敬请注意。
                      </p>
                      <p class="txt-indent">
                        (六)
                        申请游戏历程前，请确定您登录于本公司会员数据库中的个人资料，本公司只能让于会员数据库中该账号数据中之原始登录人查询所属账号内之数据，非本人则不提供查询。
                      </p>
                      <p class="txt-indent">
                        (七)
                        申请【游戏历程】仅受理查询单组账号之游戏历程纪录，超过一组或多组游戏账号申请时，请分别填写申请书提出申请。
                      </p>
                    </section>
                    <section>
                      <div class="title">案例倡导</div>
                      <p>
                        下面有些网络游戏中较常发生的案例，提醒您多多留意，保护您及其他玩家的权利：
                      </p>
                      <p class="txt-indent">
                        (一)
                        小明在游戏进行时，看到有其他玩家在公开频道广播要便宜卖出大量游戏币，小明一见机不可失，马上密语对方表示要购买。之后小明依对方指示购买游戏点数卡，并告知对方点数卡的序号密码。没想到之后对方人间蒸发，小明不但没有收到约定好的游戏币，点数卡序号也被使用，才惊觉受骗。
                        <br />
                        <span class="txt-deep-blue"
                          >※小提醒：网络诈骗多，请记得不要随意与陌生的玩家进行交易，避免造成损失。</span
                        >
                      </p>
                      <p class="txt-indent">
                        (二)
                        小伟与阿亮是一起玩在线游戏的好友。有一天，小伟出国，将账号密码交给阿亮，交待阿亮在他出国期间帮忙参加游戏举办的活动。之后阿亮果然幸运的帮小伟获得活动奖励，但阿亮一时心生贪念，把虚拟宝物移转到自己的账号占为己有。
                        <br />
                        <span class="txt-deep-blue"
                          >※小提醒：为了自己的权益，及避免之后求偿的困难，请记得不要将账号密码告知或交由任何人使用喔。</span
                        >
                      </p>
                      <p class="txt-indent">
                        (三)
                        小君與小高是大學室友，有天小君經過小高位置時看到了鍵盤下壓著記錄遊戲帳號密碼的紙條，想到小高整天吹噓自己遊戲角色多厲害，一時好奇心起，偷偷登入了小高帳號查看角色裝備屬性，但並未加以移轉或做任何動作。
                      </p>
                    </section>
                    <section>
                      <div class="title">条款变更权利声明</div>
                      <p>
                        因应法律之变动或提供游戏服务之必要，本公司保留新增、修改或删除本管理规范之全部或局部条文之权利，并于修改时于首页进行公告，且不另行个别通知，玩家不得因此而要求任何补偿或赔偿，并且自该修订条文于本网站公告之时起受其约束。玩家一旦于公告后继续使用本公司各项服务，即视为已经同意该修订条款。
                      </p>
                    </section>
                  </div>
                  <div
                    id="policy-wrap"
                    class="contract-wrap"
                    style=""
                    v-show="this.isShow==3? true:false"
                  >
                    <section>
                      <div class="title">
                        ※有关您在【Tiger777】的隐私权
                      </div>
                      <p>
                        Tiger777重视你在网络上的隐私权。为了让你更了解当你使用本产品各项服务时，
                        关于我们在搜集、管理你个人信息方面的
                        作法及你享有之权利，在此提供 你以下说明，
                        请仔细阅读。若你无法同意我们的做法，请暂时不要使用我们网站上的服务或活动，
                        我们竭诚欢迎你与我们的客服人员联络，作进一步询问或者告诉我们你的想法。
                      </p>
                    </section>
                    <section>
                      <div class="title">※隐私权保护政策适用范围</div>
                      <p>
                        一、本隐私权保护政策内容： <br /><span
                          >本隐私权保护政策内容，包括本产品如何管理在用户使用网站
                          服务时收集到的身份识别数据，也包括本产品如何管理在商业伙伴与本产品合作时分享的任何身份识别资料。</span
                        >
                      </p>
                      <p>
                        二、不适用范围： <br /><span
                          >隐私权保护政策不适用于本产品以外的公司，也不适用于非本产品所雇用或管理的人员。</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        ※【Tiger777】如何搜集您的资料
                      </div>
                      <p>
                        一、由你提供： <br /><span
                          >你要加入会员时、使用本公司的产品或服务、浏览产品网页、参加宣传活动或赠奖游戏时，我们会依需求请你填写一些必须的个人资料。</span
                        >
                      </p>
                      <p>
                        二、记录保留： <br /><span
                          >本产品也自动保留你浏览器上的服务器数值，包括互联网协议地址
                          (IP Address)
                          、本产品Cookie中的数据及你要求取用的网页纪录。</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        ※【Tiger777】搜集之个人资料类别
                      </div>
                      <p>本公司于服务所搜集之个人资料，将包括下列事项：</p>
                      <p>
                        一、必要搜集项目，所搜集之数据主要用于客户服务、营销与内部统计调查分析使用：
                      </p>
                      <ul>
                        <li>登入时间</li>
                        <li>IP登入位置</li>
                        <li>装置机种、装置机码</li>
                        <li>装置操作系统与版本</li>
                        <li>使用Facebook账号登入者，将搜集Facebook ID</li>
                      </ul>
                      <p>
                        二、非必要选填项目，所提供之数据得以左证是否为账号持有者证明之一：
                      </p>
                      <ul>
                        <li>
                          辨识个人者：如姓名、地址、电话、相片、电子邮件等。
                        </li>
                        <li>
                          政府资料中之辨识者：如身分证统一编号、护照号码等。
                        </li>
                        <li>个人描述：如年龄、性别、出生年月日等信息。</li>
                        <li>执照或其他许可：如驾驶执照等。</li>
                        <li>辨识财务者：如银行帐户之号码等。</li>
                        <li>联络信息：如手机号码、住址等。</li>
                      </ul>
                    </section>
                    <section>
                      <div class="title">
                        ※【Tiger777】对个人资料之使用
                      </div>
                      <p>一、揭露、租借或转售：</p>
                      <p class="txt-indent">
                        （一）对于你个人资料之使用，仅在搜集之特定目的及相关法令规定之范围内为之。除非经由你的同意或其他法令之特别规定，绝不会将你所登录的个人信息揭露、
                        租借或转售给第三者，或是将你的数据使用于未事先告知你的其他用途。
                        为遵守上述规定，本产品可在以下情况或本隐私政策所述的其他情况，与他方共享关于您的数据：
                        <br /><span
                          >與代表本公司進行工作而需取用該等資料的我方員工、附屬機構、關係企業、賣方、顧問和第三方服務供應商共享關於您的資料（包括：例如，付款處理商、網站主機服務，或資料存儲及處理服務供應商）。</span
                        >
                        <br /><span
                          >在遵照適用法律、規則或規例的規定或在其規定必須披露資料的情況下，回應法律程序或索取資料的要求（包括：例如，政府或管制機構、執法機構或法庭）。</span
                        >
                        <br /><span>在您同意或指示下。</span>
                      </p>
                      <p class="txt-indent">
                        （二）虽已向你作上述之保证，绝不在未经你同意的状况下将你的个人信息任意揭露，但在以下（但不限于）状况下，我们将无法再提供你前述保证：
                        <br /><span
                          >当你在本网站的行为，违反产品的服务条款或可能损害或妨碍产品权益或导致任何人遭受损害，而我们相信揭露你的个人资料是为了辨识、联络或采取法律行动之必要。</span
                        >
                        <br /><span
                          >司法单位或其他有权机关因公众安全，要求本公司公开特定个人资料时，本公司需在司法单位合法正式的程序，及对产品所有用户安全之考虑下，做可能必要的配合。</span
                        >
                        <br /><span
                          >基于善意相信揭露你的个人资料为法律所需要。</span
                        >
                      </p>
                      <p>二、数据提供之事前说明：</p>
                      <p>
                        若为了提供你其他服务或优惠权益，需要与提供该服务或优惠之第三者共享你的数据时，一定会在活动进行前给予你充分的说明，让你有机会了解并决定是否接受该特定服务或优惠。
                        如因上述需要有必要提供第三者你的数据时时，本公司亦会严格要求其遵守保密义务，并且采取必要检查程序以确定其将确实遵守。
                      </p>
                      <p>三、数据搜集目的及使用：</p>
                      <p class="txt-indent">
                        （一）数据搜集目的在于进行客户管理、会员管理、会员联系、客户满意调查及营销与内部的统计调查与分析。搜集方式其一将于玩家第一次登入游戏主动显示其相关搜集条款内容，并在玩家确认同意后，由产品游戏进行搜集．其二将透过会员填写电子或书面各项服务窗体等方式进行个人资料之搜集。
                      </p>
                      <p class="txt-indent">
                        （二）本产品可接受其他人代为提供分析服务，在我们的服务范围内提供广告。该等公司可运用技术自动收集有关您所用装置和使用我们服务的数据，包括IP地址、装置标识符，以及在我们服务内的网页的浏览时间长短和曾点击的连结。本产品和其他人可用这些数据来（其中包括）维持、提升和分析我们的服务功能，提供您可能感兴趣的与网页内容有关联或针对性的广告。这些第三方使用您数据的行为将受其各自隐私政策的规限，且我们不对第三方隐私惯例进行控制或对其负责。
                      </p>
                      <p class="txt-indent">
                        （三）经您事先同意，本公司某些服务将参与游戏和分析信息与从本游戏以及其他第三方来源的游戏结合起来，用于分析游戏和货币化趋势，创建各类别玩家的个人资料以及新游戏和服务，并进行其他分析服务。本公司还使用某些从我们的游戏中收集的信息，在游戏外进行广告宣传。这包含藉由结合您的数据和我们广告合作伙伴的信息，以建立玩家类型的配置文件、将该数据提供给我们广告公司和广告平台，以在此游戏外进行我们的定向广告，以及进行其他广告分析和作为效能标准。
                      </p>
                    </section>
                    <section>
                      <div class="title">※个人资料的修改与删除</div>
                      <p>
                        当你在本产品加入游戏后，你可以联系我们协助更改你原先提供的任何数据（地址、电话、电子邮件信箱等等…）。
                        不过，你所能修改的数据，并不包括你以往在本网站之服务内容记录。
                        另外，当你账号停权后，你曾参与过的各项服务之活动纪录并不会随着账号的停权而一并消失。
                      </p>
                    </section>
                    <section>
                      <div class="title">※连结网页的使用</div>
                      <p>
                        当你使用本产品各项服务时，可能会需要使用网页超链接功能。例如：当你使用某项由第三者所提供的服务，或阅读某则本产品所提供的信息，而该项信息包括其他网页的链接功能时，
                        很抱歉将无法继续提供你连结至其他网站后的隐私权保护，但我们诚挚提醒你，在你离开本产品、进入其他网站时，请记得先阅读该网站所提供的隐私权条款，再决定你是否继续接受该网站的服务。
                      </p>
                    </section>
                    <section>
                      <div class="title">※关于Cookie的使用</div>
                      <p>
                        「Cookies」是一种小小的记录软件，当你拜访设有「Cookies」装置的网站时，该网站的Server便会自动送出「Cookies」至你的计算机中。
                        「Cookies」的功能是，
                        帮助网站区别到访者的身份，记录并储存到访者的使用习惯或选择等等...，并且撷取到访者的IP地址。
                        一般采会员制的网站，会利用「Cookies」来储存用户的ID名称与密码、
                        个人网页、并记录到访者所参观过的网页等，好为每位会员建立一份上网参观或
                        购物的历史清单。但网站并不能利用「Cookies」修改任何到访者本身的计算机内容。
                        在此提醒你，大部分的浏览器会自动接受「Cookies」的储存，然而你若不愿于浏览过的网站上留下痕迹，现有多数浏览器的设计均允许你变更
                        「Cookies」功能。
                        若你关闭你浏览器的「Cookies」功能，仍能阅读产品网页的内容；但若你是会员，使用Cookies将对你在拜访产品时增加许多使用上的便利；换句话说，
                        若你关闭「Cookies」的功能，则往后你每次拜访产品时我们将无法认出你来，可能便因此失去提供你更多贴心服务的机会。
                      </p>
                    </section>
                    <section>
                      <div class="title">※隐私权之自我保护措施</div>
                      <p>
                        在本公司对你的隐私权提供上述保护时，也要在此提醒你，请妥善保管自己的账号密码及或任何个人资料，勿将它们，尤其是密码，提供给任何人。
                        在你完成交易、使用个人服务等程序后，务必记得注销。若你与他人共享计算机或使用公共计算机，也别忘记关闭浏览器窗口，以防止他人读取你的个人资料或信件。
                      </p>
                    </section>
                    <section>
                      <div class="title">※隐私权保护政策之修正</div>
                      <p>
                        Tiger777隐私权保护政策将因应需求随时进行修正，以落实保障你隐私权之立意。修正后的条款将刊登于本产品官网上供您前往点选阅读。
                      </p>
                    </section>
                  </div>
                </div>
                <div v-show="isEn">
                  <div
                    id="privacy-wrap"
                    v-show="this.isShowEn == 0 ? true:false"
                    class="contract-wrap"
                    style="display: block"
                  >
                    <!-- <h3>個人資料保護政策</h3> -->
                    <p>
                      Thank you for applying for the membership of Tiger777 (hereinafter referred to as the Company). Please read
                      the entire message and select [Agree] to access the
                      service. Please be advised that by clicking [Agree], you
                      shall be deemed as having agreed to exercise your right to
                      indicate consent via electronic messages according to the
                      law. This action shall be equally binding as written
                      consent.
                    </p>
                    <p>
                      In order to ensure that personal information and privacy
                      of the members and consumer rights are protected, the
                      Company may use the personal information in the future and
                      hereby discloses the following information in accordance
                      with the Privacy Policy:
                    </p>
                    <section>
                      <div class="title">
                        1. Purpose and method of data collection
                      </div>
                      <p>
                        The Company collects data for the purposes of customer
                        management, membership management and marketing, and
                        internal data collection and analysis. Personal
                        information will be collected via electronic or print
                        forms completed by members.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        2. Types of personal information to be collected
                      </div>
                      <p>
                        The personal information to be collected by the Company
                        in the service will include the following:
                      </p>
                      <p class="txt-indent">
                        (1)Necessary items for which information collected is
                        mainly used for providing services to customers,
                        marketing, and internal statistical analysis:
                      </p>
                      <ul>
                        <li>Login time</li>
                        <li>Login IP</li>
                        <li>Device type and device serial number</li>
                        <li>Device operating system and version</li>
                        <li>
                          Social media account ID such as Facebook ID of users
                          that log in with social media accounts
                        </li>
                      </ul>
                      <p class="txt-indent">
                        (2)Optional items for which information provided is used
                        to prove whether the user is the owner of the account:
                      </p>
                      <ul>
                        <li>
                          Information that identifies an individual: e.g. name,
                          address, telephone, photo, email.
                        </li>
                        <li>
                          Identification by government data: e.g. ID, Serial
                          Number of ID Card, passport number.
                        </li>
                        <li>
                          Personal description: e.g. age, sex, date of birth.
                        </li>
                        <li>
                          Licenses or other permits: e.g. driver's license.
                        </li>
                        <li>
                          Information that identifies personal finance: e.g.
                          bank account number.
                        </li>
                        <li>
                          Contact Information: e.g. mobile phone number and
                          address.
                        </li>
                      </ul>
                    </section>
                    <section>
                      <div class="title">
                        3. Period, region, counterparty, and method of
                        utilization
                      </div>
                      <p class="txt-indent">
                        (1) Period: For as long as the Company continues to
                        operate.
                      </p>
                      <p class="txt-indent">
                        (2) Area: Personal information of the members will be
                        used in Taiwan and Malaysia.
                      </p>
                      <p class="txt-indent">
                        (3) Counterparty and method: In addition to enquiries
                        for membership management and customer management
                        purposes, members' personal information that is
                        collected will be used in the following ways:
                      </p>
                      <ol>
                        <li>
                          Collecting physical items: When a product is entrusted
                          to be delivered, the information will be given to the
                          logistics and mailing services providers to complete
                          the delivery.
                        </li>
                        <li>
                          Promoting games: The Company will use the addresses,
                          email addresses, and telephone numbers for marketing
                          purposes on behalf of the Company or its partners.
                        </li>
                        <li>
                          When the government or competent authorities request
                          information for the prevention, investigation,
                          detection, or prosecution of crimes or to implement
                          criminal penalties, the Company shall provide
                          information in accordance with such requests.
                        </li>
                        <li>
                          Rights and obligations arising from other contracts
                          between the Company and its members.
                        </li>
                      </ol>
                    </section>
                    <section>
                      <div class="title">
                        4. Member rights regarding personal information
                      </div>
                      <p>
                        Members may exercise the following rights regarding
                        their own personal information submitted to the Company
                        (unless otherwise specified by the law):
                      </p>
                      <p class="txt-indent">(1) Enquire or request to view.</p>
                      <p class="txt-indent">(2) Request for a copy.</p>
                      <p class="txt-indent">
                        (3) Request to make supplement or correction.
                      </p>
                      <p class="txt-indent">
                        (4) Request to stop collecting, processing, or accessing
                        information.
                      </p>
                      <p class="txt-indent">
                        (5) Request to delete or cease the use of information.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        5. Protection of personal information of members
                      </div>
                      <p>
                        The Company shall take appropriate security measures
                        including technical and organizational measures to
                        process personal information to effectively prevent
                        unauthorized or illegal processing, loss, destruction,
                        or damage to personal information.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        6. An application may be submitted to the Company's
                        customer services if a member wishes to exercise any of
                        the aforementioned rights. The e-mail is
                        admin@tiger777.com. In order to protect member
                        rights, the Company shall be entitled to require members
                        to complete applications and provide relevant
                        identification. If a third party is appointed as an
                        agent, the appropriate proxy form and identifications
                        for both individuals shall be presented. The Company may
                        charge an administrative fee if needed.
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        7. The Company has taken reasonable and necessary
                        preventive measures to protect the rights of its members
                        in order to prevent potential unauthorized disclosure,
                        damage, and alteration of personal information and other
                        situations that may damage member rights.
                      </div>
                    </section>

                    <section>
                      <div class="title">
                        8. In order to avoid future disputes over member rights,
                        please enter correct personal information. Should any
                        dispute arise from incorrect information (e.g. identity
                        theft) in the future, the Company shall pursue legal
                        actions as needed.
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        9. The Company is entitled to unilaterally amend the
                        Privacy Policy in response to applicable legislation
                        changes.
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        10. This policy shall be disclosed permanently on the
                        Company's website, and the members shall have the
                        responsibility to stay informed. Any amendment to this
                        policy shall also be disclosed publicly or be sent to
                        all members via email.
                      </div>
                    </section>
                  </div>
                  <div
                    id="contract-wrap"
                    v-show="this.isShowEn ==1 ? true:false"
                    class="contract-wrap"
                    style="display: block"
                  >
                    <section>
                      <p>
                        Welcome to the ARC PLAY LTD CO. [Tiger777] game
                        platform (henceforth referred to as the Game). To
                        protect your interests, please register as a [Tiger777] member and carefully read all contents of the
                        User Contract before using the services of the Game.。
                      </p>
                      <p>
                        We remind you to review the Contract for more than three
                        days before clicking the [I agree] button.
                      </p>
                      <br />
                      <p>
                        Parties to the Contract<br />
                        The consumer (henceforth referred to as Party A; please
                        fill out information in accordance with the member
                        registration procedures)<br />
                      </p>
                      <br />
                      <p>
                        Name of corporate operator: ARC PLAY LTD CO. (henceforth
                        referred to as Party B)<br />Representative: Chiang Po
                        Wei<br />E-mail：<a
                          href='"admin@tiger777.com"'
                          >admin@tiger777.com</a
                        ><br />URL：<a href='"www.tiger777.com"'
                          >www.tiger777.com</a
                        >
                      </p>
                    </section>
                    <br />
                    <section>
                      <div class="title">Article I. Legal representative</div>
                      <p>
                        If Party A is limited in his/her capacity to carry out
                        juridical acts, Party A shall be required to obtain
                        approval from his/her legal representative before the
                        Contract is effected; If Party A is an individual with
                        no capacity, the establishment of the Contract shall be
                        performed by Party A's legal representative on his/her
                        behalf.
                      </p>
                      <p>
                        Where an individual with limited capacity to carry out
                        juridical acts purchases points without the legal
                        representative's approval or where an individual with no
                        capacity fails to purchases points through a legal
                        representative who acts on his/her behalf and the legal
                        representative claims a refund, the legal representative
                        may prepare related certification documents and file an
                        application in accordance with procedures announced on
                        the official website. After Party B's confirmation, it
                        shall refund fees for the game that are unused by Party
                        A.
                      </p>
                      <p>
                        Party B shall provide clear statements on the home page
                        of the official website, game login page, or purchase
                        page in Chinese. If Party A is limited in his/her
                        capacity to carry out juridical acts or an individual
                        with no capacity, it shall meet conditions specified in
                        Paragraph 1 and Party A may only use Game Services after
                        Party A's legal representative reads, understands, and
                        agrees to all terms of the Contract. The same shall
                        apply for changes to the terms of the Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article II. Applicable scope of the Contract
                      </div>
                      <p>
                        Party B shall provide Party A with online game services
                        and other related services (henceforth referred to as
                        Game Services). The parties' rights and obligations
                        related to the Game Services shall be specified in
                        accordance with the terms of the Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article III. Contents of the Contract
                      </div>
                      <p>
                        The following items shall be regarded as integral parts
                        of the Contract and shall have the same validity as the
                        Contract:
                      </p>
                      <p class="txt-indent">
                        (1) Advertisement or announcements regarding the Game
                        Services provided by Party B.
                      </p>
                      <p class="txt-indent">
                        (2) Rates for paid games and management guidelines.
                      </p>
                      <p>
                        Any ambiguity regarding the terms of the Contract shall
                        be construed in favor of Party A.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article IV. Terms and definitions</div>
                      <p>
                        The terms used in the Contract are defined as follows:
                      </p>
                      <p class="txt-indent">
                        (1) Online game: An online game refers to Party A's
                        connection to Party B's server for online gaming through
                        the Internet with computers, smart devices, or other
                        digital devices. It does not include electronic game
                        machines specified in the Electronic Game Arcade
                        Business Regulation Act, simple regional connections, or
                        other Game Services that do not require Internet
                        connection to a game server.
                      </p>
                      <p class="txt-indent">
                        (2) Game website: The game website refers to the website
                        established by Party B to provide the Game Service.
                      </p>
                      <p class="txt-indent">
                        (3) Management guidelines: The management guidelines
                        refer to rules established by Party B that govern the
                        progression of the Game and do not affect the rights and
                        obligations of the parties in the Contract.
                      </p>
                      <p class="txt-indent">
                        (4) Game log: The game log refers to the records of
                        Party A's gaming from logging into the game and logging
                        out of the game that are kept by the computer system.
                      </p>
                      <p class="txt-indent">
                        (5) Plug-ins: A plug-in refers to programs that are not
                        provided by Party B and are designed for the purpose of
                        affecting or changing Party B's online game operations.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article V. Scope of services</div>
                      <p>
                        The Game Services provided in the Contract refers to the
                        use of Game Services by Party A by a connection via the
                        Internet for logging into Party B's designated servers.
                        However, it does not include the Internet access service
                        that Party A applies for with the Internet service
                        provider or the hardware equipment required for Internet
                        access.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article VI. Game login</div>
                      <p>
                        Party A shall register personal information or other
                        necessary information on the game website in accordance
                        with the application procedures to apply for the use of
                        the Game Services. To ensure that Party A's rights and
                        interest in the use of the Game Services, information
                        provided by Party A shall be used to verify Party A's
                        identity. If it is incorrect or if it is changed, Party
                        A shall notify Party B to update such information
                        immediately.
                      </p>
                      <p>
                        Where Party B deems it necessary to contact Party A for
                        providing the Game Services and Party A fails to provide
                        correct personal information or where the information
                        previously provided is not factual and is not updated,
                        Party B may suspend Party A's progression of the game
                        and game log inquiry services before Party A provides
                        valid information or updates the information. However,
                        such conditions shall not apply if Party A can prove
                        that it is the party to this Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article VII. Contract termination rights
                      </div>
                      <p>
                        Party A may notify Party B in writing to terminate the
                        Contract within seven days of commencing the game
                        without the needs to explain the reason or bear any
                        cost.
                      </p>
                      <p>
                        Under such conditions, Party A may request a refund for
                        unused points it purchased from Party B.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article VIII. Payment calculation method
                      </div>
                      <p>
                        The payment calculation method for the Game Services is
                        free of charge:
                      </p>
                      <p>
                        Where Party A is required to pay additional fees for
                        points, products, or other services (e.g. virtual
                        currencies, precious items, or advanced items) in the
                        Game Services (e.g. game mall or online game stores),
                        Party B shall announce the payment method and product
                        information on the homepage of the official website or
                        the game login page.
                      </p>
                      <p>
                        Where the rate is adjusted, Party B shall make the
                        announcement thirty days before the scheduled adjustment
                        date on the home page of the official website, game
                        login page, or purchase page. Where Party A has
                        registered contact information when it registered its
                        account, Party B shall notify Party A based on the
                        contact information registered by Party A.
                      </p>
                      <p>
                        In the event of an adjustment of the rate, it shall
                        apply on the date the adjustment becomes valid; if the
                        new rate is higher than the old rate, the points or game
                        fees paid for by Party A before the effective date of
                        the new rate shall be calculated based on the old rate.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article IX. Information to be specified in the Game
                        Services
                      </div>
                      <p>
                        Party B shall specify the following items on the
                        homepage of the official website, game login page,
                        purchase page, and the game packaging:
                      </p>
                      <p class="txt-indent">
                        (1) The restricted or suitable age group for the game
                        rating based on the Game Software Rating Regulations.
                      </p>
                      <p class="txt-indent">
                        (2) Minimum software and hardware requirements for the
                        use of the Game Service.
                      </p>
                      <p class="txt-indent">
                        (3) Free usage or payment information if safety devices
                        are provided.
                      </p>
                      <p class="txt-indent">
                        (4) Where lucky draw prizes or events are provided for
                        paid purchases the event content, prizes, and award
                        information shall be provided. Party B shall also
                        specify reminders such as "This is an opportunity for
                        winning an item. Consumers' purchase or participation in
                        the event does not guarantee the award of a specific
                        item."
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article X. Use of accounts and passwords
                      </div>
                      <p>
                        The account and password obtained by Party A after
                        completing registration procedures shall be provided for
                        Party A's use only. The password in the preceding
                        paragraph may be changed in accordance with the
                        mechanisms for changes provided by Party B. Party B's
                        personnel (including customer service personnel and game
                        administrators) may not actively inquire Party A's
                        password. Party B shall retain Party A's account and the
                        electromagnetic recording of account for thirty days
                        after the termination of the Contract.
                      </p>
                      <p>
                        Where the Contract is terminated for reasons
                        unattributable to Party A and Party A applies for
                        renewed application of the Contract within the preceding
                        period, it shall retain the right to continue its use of
                        the account and the electromagnetic recording of
                        account.
                      </p>
                      <p>
                        However, where Party A fails to renew the Contract upon
                        the expiry of the period in Paragraph 2, Party B may
                        delete the account and all information associated with
                        the account. However, that this rule shall not apply if
                        otherwise specified in laws and regulations.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XI. Notification and procedures for illegal use
                        of account and password
                      </div>
                      <p>
                        Once a party discovers illegal use of an account or
                        password, it shall notify the other party immediately
                        and Party A shall verify such use. Once Party B verifies
                        of the occurrence of such incident, Party B may suspend
                        the usage rights of the account or password provide a
                        new account or password to Party A. It shall immediately
                        restrict the third party's usage rights for the Game
                        Services and disclose related processing methods in the
                        management guidelines.
                      </p>
                      <p>
                        Party B shall use announcements on the official website,
                        SMS, email, push notifications, or other methods agreed
                        by the parties to notify the third party specified in
                        the preceding paragraph to provide an explanation. Where
                        the third party fails to provide an explanation within
                        seven days of receiving the notice, Party B shall
                        directly restore the electromagnetic recording that was
                        illegally transferred to Party A. If the electromagnetic
                        recording cannot be restored, other equivalent
                        compensation methods agreed by both parties may be
                        adopted and restrictions implemented on the third party
                        shall be lifted after the restoration. However, where
                        Party B has provided a free security device (e.g.
                        anti-theft card or telephone lock) and Party A does not
                        use such device or where there are other reasons
                        attributable to Party A, Party B shall not be
                        responsible for restoration or compensation.
                      </p>
                      <p>
                        If the third party described in Paragraph 1 does not
                        agree to Party B's processing procedures described in
                        the preceding paragraph, Party A may seek legal
                        resolution in accordance with legal procedures.
                      </p>
                      <p>
                        When Party B restricts Party A or a third party's usage
                        rights in accordance with terms in Paragraph 1, Party B
                        may not collect fees from Party A or the third party in
                        the restriction period.
                      </p>
                      <p>
                        Party A shall be liable for all legal responsibilities
                        if it makes false reports and causes damage to the
                        rights of Party B or a third party.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XII. Game log retention and inquiries
                      </div>
                      <p>
                        Party B shall retain Party A's personal game log for
                        thirty days for Party A's inquiry.
                      </p>
                      <p>
                        Party A may apply for its personal game logs by filing
                        applications in writing or online or visiting Party B's
                        service center. Party A shall provide personal
                        information that meets its identification certificates
                        for verification. The fees for the inquiries shall be
                        borne by Party A.
                      </p>
                      <p>
                        After Party B receives Party A's inquiry application, it
                        shall provide Party A's personal game logs listed in
                        Item 1 and provide information in storage media, in
                        writing, or through email within seven days.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XIII. Personal information
                      </div>
                      <p>
                        The protection of personal information shall be
                        processed in accordance with related laws.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XIV. Electromagnetic recording
                      </div>
                      <p>
                        All electromagnetic recording of the Game belongs to
                        Party B. Party B shall also maintain the integrity of
                        Party A's related electromagnetic recordings.
                      </p>
                      <p>
                        Party A retains the right to control the electromagnetic
                        recording specified in the preceding paragraph. Such
                        rights do not include transfers or profitable actions
                        outside the scope of the Game Services.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XV. Information disclosure
                      </div>
                      <p>
                        Party B shall provide information on the number of
                        people that can be supported by the server of the Game
                        Services on the game website. In addition, the number of
                        people online, connection status, and related
                        information shall also be provided and regularly
                        updated.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XVI. Connection quality</div>
                      <p>
                        Party B shall announce planned suspensions of all or a
                        part of the Game Services for the maintenance of related
                        system and hardware/software equipment related to the
                        Game Services on the homepage of the official website,
                        game login page, or purchase page seven days in advance.
                        However, this restriction shall not apply to temporary
                        or emergency conditions or reasons unattributable to
                        Party B.
                      </p>
                      <p>
                        Party B shall immediately rectify or conduct repairs if
                        Party A is prevented from connection to and usage of the
                        Game Services due to reasons attributable to Party B.
                        Where Party A is deducted of gaming fees or items in the
                        game due to the period in which it cannot use the Game
                        Services, Party B shall return gaming fees or products;
                        where they cannot be returned, Party B shall provide
                        other reasonable compensation.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XVII. Responsibilities of the corporate operator
                        and consumers
                      </div>
                      <p>
                        Party B shall be responsible for the maintenance of its
                        computer system when providing the Service based on the
                        terms of the Contract and maintain reasonably expected
                        security levels based on prevailing technology and
                        professional standards.
                      </p>
                      <p>
                        If the computer system or electromagnetic recording is
                        damaged or if the computer system malfunctions, Party B
                        shall take appropriate measures and respond as quickly
                        as possible.
                      </p>
                      <p>
                        If Party B violates the terms in the two preceding
                        paragraphs or if a loophole in the game program and
                        causes damage to Party A, Party B shall be liable for
                        compensation based on the damage suffered by Party A.
                        However, Party B's liabilities for compensation may be
                        reduced if it could prove that it is not at fault.
                      </p>
                      <p>
                        In the event that Party B's computer systems exhibit
                        conditions specified in Paragraph 2, Party B may not
                        collect fees from Party A before restoration is
                        completed and normal operations are resumed.
                      </p>
                      <p>
                        Party B shall not be required to assist in processing
                        disputes between Party A and third parties derived from
                        the shared use of an account or requests for others to
                        purchase points.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XVIII. Management guidelines
                      </div>
                      <p>
                        Party B shall establish reasonable and fair management
                        guidelines to ensure the ongoing management of the Game.
                        Party A shall comply with the management guidelines
                        announced by Party B.
                      </p>
                      <p>
                        Changes to the management guidelines shall be
                        implemented in accordance with procedures set forth in
                        Article XXI. The management guidelines shall be voided
                        under any of the following conditions:
                      </p>
                      <p class="txt-indent">
                        (1) Where they conflict with the terms of this Contract.
                      </p>
                      <p class="txt-indent">
                        (2) Where they deprive Party A of its rights in the
                        Contract or restrict such rights. However, this rule
                        does not apply if Party B implements procedures in
                        accordance with Article XIX.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XIX. Breach of management guidelines
                      </div>
                      <p>
                        Except otherwise specified in the Contract, where there
                        is sufficient proof of Party A's violation of the
                        management guidelines in the Game Services, Party B
                        shall issue announcements on the home page of the
                        official website, game login page, or purchase page and
                        notify Party A based on the contact information
                        registered by Party A.
                      </p>
                      <p>
                        Where Party A violates the management guidelines for the
                        first time, Party B shall notify Party A to make
                        improvements within a certain period of time. Where
                        Party A fails to make improvements after Party B's
                        notice, Party B may, pursuant to the management
                        guidelines, restrict Party A's usage rights for the Game
                        based on the severity of the violation. Where Party A
                        commits the same violation of the management guidelines,
                        Party B may immediately restrict Party A's right to the
                        Game in accordance with the management guidelines.
                      </p>
                      <p>
                        Party B's restriction of Party A's rights to the Game in
                        accordance with the management guidelines shall not
                        exceed seven days in each penalty.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XX Right to complaint</div>
                      <p>
                        In the event that Party A is dissatisfied with the
                        connection quality, game management, payment
                        calculation, or the quality of other related services
                        provided by Party B, or if Party A objects to Party B's
                        methods for processing issues based on the management
                        guidelines, it may file a complaint to Party B's service
                        center or submit a complaint through email or in writing
                        within seven days immediately following the date the
                        notice was received. Party B shall provide a response to
                        the processing of the complaint within fifteen days of
                        receiving the complaint.
                      </p>
                      <p>
                        Party B shall specify the service hotline, email, and
                        other related contact information and 24-hour complaint
                        channels on the official website or management
                        guidelines.
                      </p>
                      <p>
                        Party A's complaints regarding third parties' use of
                        plug-ins or other actions that affects the fairness of
                        the Game shall be processed in accordance with Paragraph
                        1.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XXI. Contract amendment</div>
                      <p>
                        Party B shall announce amendments of the Contract on the
                        home page of the official website, game login page, or
                        purchase page and notify Party A based on the contact
                        information registered by Party A.
                      </p>
                      <p>
                        The amendments to the Contract shall not be valid if
                        Party B fails to issue an announcement or notification
                        in accordance with the preceding paragraph. Party A's
                        actions within fifteen days of the delivery of the
                        notification specified in Paragraph 1:
                      </p>
                      <p class="txt-indent">
                        (1) If Party A does not object, Party B shall continue
                        to provide Game Services in accordance with the amended
                        Contract.
                      </p>
                      <p class="txt-indent">
                        (2) If Party A objects, the objection shall be processed
                        as Party A's termination of the Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XXII. Contract termination and refund
                      </div>
                      <p>
                        Party A may notify Party B to terminate the Contract at
                        any time.
                      </p>
                      <p>
                        Party B may enter an agreement with Party A to specify
                        that if Party A fails to log in and use the Game
                        Services for more than one year, Party B may specify a
                        certain period (no less than thirty days) to notify
                        Party A to log in. If Party A fails to log in before the
                        specified period, Party A may terminate the Contract.
                      </p>
                      <p>
                        Party B may terminate the Contract immediately with the
                        contact information registered by Party A if Party A is
                        found to be in any of the following material
                        circumstances:
                      </p>
                      <p class="txt-indent">
                        (1) Use of any system or tool to conduct malicious
                        attacks or destruction of Party B's computer system;
                      </p>
                      <p class="txt-indent">
                        (2) Use plug-ins, viruses, game program loopholes, other
                        actions that affect the normal settings of the Game, or
                        unfair or unreasonable methods to progress the game;
                      </p>
                      <p class="txt-indent">
                        (3) Impersonation of others or use of fraud or other
                        false and illegitimate methods for purchasing points or
                        products in the Game.
                      </p>
                      <p class="txt-indent">
                        (4) Where Party A violates the management guidelines
                        over a certain number of times (no less than three
                        times) for the same reason and fails to make
                        improvements pursuant to notices for improvements issued
                        in accordance with Article XIX, Paragraph 2.
                      </p>
                      <p class="txt-indent">
                        (5) Found by judicial authorities to be conducting any
                        illegal activity.
                      </p>
                      <p>
                        If Party B makes an error in the determination of the
                        aforementioned facts or fails to provide evidence, Party
                        B shall be liable for compensation for the damage caused
                        to Party A.
                      </p>
                      <p>
                        Upon the termination of the Contract, Party B shall
                        deduct necessary costs and use cash, credit card, wire
                        transfer, or a mailed check to return unused points or
                        game fees paid by Party A within thirty days or process
                        the aforementioned points or fees with methods agreed by
                        the parties.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XXIII. Suspension of operations
                      </div>
                      <p>
                        Where the Contract is terminated due to Party B's
                        suspension of its operations in the Game Services, it
                        shall announce the suspension of operations on the home
                        page of the official website, game login page, or
                        purchase page and notify Party A based on the contact
                        information registered by Party A.
                      </p>
                      <p>
                        Where Party B fails to issue announcements within the
                        aforementioned period based on the preceding paragraph,
                        it shall refund Party A the unused points or game fees
                        paid by Party A and it may not deduct the necessary
                        costs. It shall also provide other reasonable
                        compensation.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XXIV. Delivery</div>
                      <p>
                        Party A agrees that notices regarding all items in the
                        Contract shall be deemed as delivered if Party B
                        delivers the notices with the contact information
                        registered by Party A.
                      </p>
                      <p>
                        Party A shall immediately notify Party B of changes in
                        the aforementioned registered contact information. Party
                        B shall deliver notices based on the changed contact
                        information.
                      </p>
                      <p>
                        Notices issued by Party B based on the contact
                        information registered by Party A shall be deemed as
                        delivered once a written notice is delivered to Party A
                        or once an email enters Party A's email server.
                      </p>
                      <p>
                        Where the delivery fails due to Party A's deliberate or
                        negligent actions, Party B shall not be liable for
                        compensating the losses incurred for a failed delivery.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XXV. Governing law</div>
                      <p>
                        The Contract shall be governed by the laws of Taiwan.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XXVI. Court with jurisdiction
                      </div>
                      <p>
                        The parties herein agree that disputes arising from this
                        Contract shall be submitted to the jurisdiction of
                        Taiwan Taipei District Court which shall serve as the
                        court of first instance.
                      </p>
                    </section>
                  </div>
                  <div
                    id="rules-wrap"
                    v-show="this.isShowEn == 2 ? true:false"
                    class="contract-wrap"
                    style=""
                  >
                    <section>
                      <p>
                        In the event of the following violation that is
                        investigated and verified by the gamemaster, violators
                        shall be punished based on the severity of the
                        violation. Users with minor violations shall be removed,
                        banned, or subject to suspension of their communication
                        and transaction functions; users with gross violations
                        shall be suspended or subject to contract termination.
                      </p>
                      <p>The management items and penalties are as follows:</p>
                      <table cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <th>Game Rules</th>
                            <th>Penalties</th>
                          </tr>
                          <tr>
                            <td>
                              Inappropriate comments (Examples include: false
                              statements, inappropriate inflammatory speech, or
                              personal attacks)
                            </td>
                            <td>Violators shall be [banned]</td>
                          </tr>
                          <tr>
                            <td>
                              Inappropriate gaming actions including actions
                              conducted through the use of the Company's
                              services or with the Company's services.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation and
                              each subsequent violation. For gross violations,
                              the violator shall be subject to [contract
                              termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              purchase or sell game coins including actions
                              conducted through the use of the Company's
                              services or with the Company's services.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation. For
                              gross violations, the violator shall be subject to
                              [contract termination] or [cancellation of the
                              gift service].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              purchase or sell items (those that are outside the
                              scope of normal use in the game) including actions
                              conducted through the use of the Company's
                              services or with the Company's services.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation. For
                              gross violations, the violator shall be subject to
                              [contract termination] or [cancellation of the
                              gift service].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              disseminate or publish commercial ads, publish
                              prostitution or pornographic information or
                              websites, or conduct intermediary actions for the
                              above.
                            </td>
                            <td>
                              The violator shall be subject to [contract
                              termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              purchase, sell, accept, or transfer game accounts
                              including actions conducted through the use of the
                              Company's services or with the Company's services.
                            </td>
                            <td>
                              A seven-day suspension for the first violation.
                              the violator shall be subject to [contract
                              termination] for the second violation.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              disseminate or publish comments that are not
                              permissible by the laws or comments that incite
                              criminal activities. (Examples include: hard,
                              soft, boy, girl, sales of candy, and other
                              synonyms for drug trafficking.).
                            </td>
                            <td>
                              A seven-day suspension for the first violation.
                              the violator shall be subject to [contract
                              termination] for the second violation. For gross
                              violations, the violator shall be subject to
                              direct [contract termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Posing as official personnel by using the
                              [Tiger777] gaming platform to pose as the
                              Company's customer service personnel or gamemaster
                              or applying for nicknames that may cause others to
                              believe that the violator is a customer service
                              staff member or gamemaster and conducting any
                              interactions with players.
                            </td>
                            <td>
                              The violator shall be subject to [contract
                              termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform for
                              actions that involve illegal use or fraud
                              <span class="txt-deep-blue"
                                >which violate the laws of the jurisdiction when
                                they occurred.</span
                              >
                            </td>
                            <td>
                              The violator shall be subject to [temporary
                              freeze]. Once the crime is verified, the game
                              coins and items illegally obtained by the violator
                              shall be confiscated (including all related
                              accounts). The violator shall also be subject to
                              [contract termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Party B is verified or investigated by judicial
                              authorities for suspected illegal activities.
                            </td>
                            <td>
                              The violator shall be subject to [temporary
                              freeze]. Once a claim is verified (letter of
                              request from the prosecutorial, police, or related
                              unit), the game coins and items illegally obtained
                              by the violator shall be temporarily frozen; if
                              criminal activities are verified in subsequent
                              investigations, they shall be confiscated
                              (including all related accounts).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of a bug in the game or malicious abuse of a
                              loophole in the game website by using plug-ins or
                              correction of game coins and items that are
                              inappropriately obtained.
                            </td>
                            <td>
                              The violator shall be subject to [temporary
                              freeze]. The Company shall confiscate and delete
                              unjust enrichment and character information
                              obtained through the use of bugs and other
                              records. In addition, the Company shall take legal
                              actions against such violations (including all
                              related accounts).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Registration of large numbers of accounts and
                              using the game to obtain unjust profits or gross
                              negligence or deliberate negligence in accepting
                              items or game coins known to be illegal or
                              inappropriate.
                            </td>
                            <td>
                              The violator shall be subject to [contract
                              termination]. Unjust profits shall be confiscated
                              and the Company shall take legal actions against
                              such violations. (including all related accounts).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Creation of large numbers of accounts and damage
                              the order in the game.
                            </td>
                            <td>
                              The violator shall be subject to [user login ban]
                              or [contract termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              The Company shall take legal actions against
                              malicious reports, insults, or affecting the
                              operations of customer service and the customer
                              service center.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation and
                              each subsequent violation. For gross violations,
                              the violator shall be subject to [contract
                              termination]. The scope of penalties includes all
                              service platforms of the Tiger777 game,
                              open game channels, and private channels.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of inappropriate profile image (unauthorized
                              use of others' images, pornographic, obscene, or
                              erotic images, images that contain personal
                              attacks or obscene phrases, images that violate
                              social morals, overtly political, controversial,
                              trademarks, or copyright violations).
                            </td>
                            <td>
                              The penalty for the first violation shall include
                              locking the profile image for 24 hours and forced
                              removal of the image; the penalty for the second
                              violation shall include locking the profile image
                              for 7 days and forced removal of the image; the
                              penalty for the third violation shall include
                              locking the profile image permanently and forced
                              removal of the image.
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" class="txt-deep-red">
                              Note: The aforementioned management items and
                              penalties are described in the [Description of
                              Penalties] and [Description of Violations] below.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                    <section>
                      <div class="big-title">Description of Penalties</div>
                      <p>
                        The Company shall implement the following penalties for
                        members that violate the Game Rules in accordance with
                        the severity of their violations:
                      </p>
                      <p class="txt-indent">
                        (1) [Compulsory logout]: Use of system operations to
                        force the violator out of the game.
                      </p>
                      <p class="txt-indent">
                        (2) [Ban]: Ban the violator from posting any message in
                        any form for a certain amount of time.
                      </p>
                      <p class="txt-indent">
                        (3) [Compulsory channel closure]: Use of system
                        operations to force the closure of a privately-created
                        channel.
                      </p>
                      <p class="txt-indent">
                        (4) [Temporary freeze]: Suspend the violator's right to
                        use its account for a certain amount of time.
                      </p>
                      <p class="txt-indent">
                        (5) [Contract termination] Terminate the violator's
                        right to use its account or blacklist the user.
                        Permanently suspend the usage right of the account and
                        all services provided by the Company. All gaming records
                        or virtual items of users that are subject to contract
                        termination shall be deleted.
                      </p>
                      <p class="txt-indent">
                        (6) [User login ban]: The user is prohibited from
                        logging into the Tiger777 game.
                      </p>
                      <p class="txt-indent">
                        (7) [Suspension]: The user shall be prohibited from
                        logging into the Tiger777 game.If the user's
                        account violates the aforementioned Game Rules and is
                        suspended for the [third] time, the Company has the
                        right to immediately terminate the user contract,
                        permanently suspend the usage right of the account and
                        all services provided by the Company and delete all
                        virtual items and game coins of the user account in
                        [Tiger777]. The user shall also be blacklisted
                        by the Company.
                      </p>
                    </section>
                    <section>
                      <div class="big-title">Description of Violations</div>
                      <div class="title">Inappropriate actions in games</div>
                      <p>
                        Where a user is verified to be playing the game through
                        inappropriate means or engaging in illegal actions
                        through the use of the Company's services or with the
                        Company's services, thereby causing damage of other
                        players' online virtual property (e.g. game coins) or
                        unfair competition, the Company shall notify the user of
                        the service and the Company shall restrict the user's
                        right to the game based on the severity of the violation
                        to protect the rights and interest of other members and
                        the gaming environment of [Tiger777]. It is
                        prohibited to sell or purchase game point cards or
                        virtual items in the game. In addition, the Company
                        shall also apply the same penalties to all user accounts
                        that participate or assist in the violation of the Game
                        Rules. It is prohibited to engage in inappropriate
                        actions in games and violate the Company's related
                        regulations. Inappropriate actions in games are defined
                        as follows:
                      </p>
                      <p class="txt-indent">
                        (1) Malicious exploitation of a bug in the gaming system
                        or use of any form of program not included in the game
                        (e.g. invasion, interception, destruction, or
                        modification of game information or package value), any
                        modification of original programs, locking and unlocking
                        of system settings, or other inappropriate methods to
                        obtain inappropriate gaming records and affect the
                        fairness of the game.
                      </p>
                      <p class="txt-indent">
                        (2) Use of others' accounts for transactions, abuse of
                        the game to gain unjust profits, or other unfair or
                        unreasonable methods in the game.
                      </p>
                      <p class="txt-indent">
                        (3) Use of mechanisms on the [Tiger777] gaming
                        platform or other games on the platform to deliberately
                        cause inappropriate flow of game coins and other game
                        assets.
                      </p>
                      <p class="txt-indent">
                        (4) Sales or purchase of game coins, game point cards,
                        or other related virtual items in the game; The
                        [Tiger777] platform provides functions for
                        gifting virtual game coins and items but it only
                        provides conversion mechanisms for regular transactions
                        and does not allow sales or purchase transactions. Users
                        may not request the Company to cancel converted virtual
                        items or game coins in private based on the results of
                        private transactions.
                      </p>
                      <p class="txt-indent">
                        (5) Actions that are suspected to involve using online
                        purchases to buy points illegally.
                      </p>
                      <p class="txt-indent">
                        (6) Use of the [Tiger777] gaming platform to
                        disseminate or publish commercial ads, publish
                        prostitution or pornographic information or website, or
                        conduct intermediary actions for the above.
                      </p>
                      <p class="txt-indent">
                        (7) Actions that harm the rights, interest, or privacy
                        of a third party (violation of the Personal Information
                        Protection Act).
                      </p>
                      <p class="txt-indent">
                        (8) Interference with the progression of the game or an
                        event and failure to make improvements after receiving
                        warning from online management personnel.
                      </p>
                      <p class="txt-indent">
                        (9) Pose as the Company's customer service personnel or
                        gamemaster or applying for nicknames that may cause
                        others to believe that the violator is a customer
                        service staff member or gamemaster and conducting any
                        interactions with players.
                      </p>
                      <p class="txt-indent">
                        (10) Use of the speaking function on the [Tiger777] gaming platform for insults, slandering,
                        personal attacks, threats, or use language with obscene
                        (or obscene-sounding) meaning or racist language to
                        attack other members. Violators shall be [banned].
                      </p>
                      (11) Malicious spams in the game lobby that is
                      photographed by a member of the [Tiger777] gaming
                      platform and verified. Violators shall be [banned].
                    </section>
                    <section>
                      <div class="title">
                        Inappropriate comments (including comments made in the
                        game and messages posted on the website platform)
                      </div>
                      <p>
                        To maintain a healthy atmosphere in the game and allow
                        all players to watch and use the game channels normally,
                        please abide by Internet etiquette and maintain a clean
                        and simple game space. If the player uses direct
                        indirect, allusive, dialectic, slang, erroneous words
                        (Zhuyin Fuhao), numbers, or images in place of regular
                        curse words, or homonyms, anatomical terms, or insult or
                        the direct or reverse writing of such terms to form word
                        combinations with the following specific meanings on the
                        Tiger777 gaming platform, such usage shall not
                        be permitted. Under the following conditions on the
                        Tiger777 gaming platform, the Company has the
                        right to implement direct penalties without prior
                        notice. If a comment posted on a channel is not
                        permitted but not listed in the following description of
                        restrictions, the comment shall be processed in
                        accordance with social morals in a just manner and the
                        violator shall be [banned]:
                      </p>
                      <p class="txt-indent">
                        (1) Where the player posts comments with low-class,
                        obscene, rude, insulting, slandering, personal attacks,
                        threatening, provocative, racial or gender
                        discrimination, profanity, lewd, erotic, pornographic
                        contents or meanings, or phrases on the [Tiger777] gaming platform that violate good social morals
                        and affect the gaming experience of other players;
                      </p>
                      <p class="txt-indent">
                        (2) Where the player uses phrases in the game to pose as
                        official personnel on the [Tiger777] gaming
                        platform or claims to be an official representative or
                        gamemaster;
                      </p>
                      <p class="txt-indent">
                        (3) Where the player deliberately obstructs the actions
                        of official personnel or insults or deceives official
                        personnel;
                      </p>
                      <p class="txt-indent">
                        (4) Where the player uses [Tiger777] gaming
                        platform to disseminate or publish comments about the
                        Company that have not been verified or have no factual
                        basis (including information that has been publicly
                        disclosed or not public disclosed (malicious use of text
                        or image format) or mere speculations by the player,
                        etc.); Where the player attempts to affect the gaming
                        experience of other players; where such actions causes
                        damage to the Company, the Company shall retain all
                        rights for legal prosecution for such violations;
                      </p>
                      <p class="txt-indent">
                        (5) Where the player spams public channels or speaks
                        repeatedly on public channels on the [Tiger777]
                        gaming platform and prevents players from viewing
                        channels normally; examples include continuous posts
                        with meaningless content (e.g. English or numerals,
                        garbled code, symbols, emojis, expressions, commands, or
                        system default text) or posting text with the same cycle
                        at a certain frequency, it shall constitute spamming (a
                        channel with more than two persons shall be deemed as an
                        open channel);
                      </p>
                      <p class="txt-indent">
                        (6) Where the player processes personal disputes or
                        where players slander each other on open channels and
                        attempt to disseminate information and cause other
                        players to join the dispute, thereby affecting the
                        gaming experience of other players;
                      </p>
                      <p class="txt-indent">
                        (7) Where the player violates regulations on the
                        protection of personal private information on the
                        [Tiger777] gaming platform; examples include:
                        disclosing membership information of other Tiger777 players;
                      </p>
                      <p class="txt-indent">
                        (8) Where the player uses the [Tiger777] gaming
                        platform for commercial advertisement in terms of
                        actions or providing content (e.g. selling products
                        unrelated to the game or advertisement for transactions
                        of physical products);
                      </p>
                      <p class="txt-indent">
                        (9) Where the player uses the [Tiger777] gaming
                        platform for selling drugs, guns, or other illegal items
                        or publishing illegal ads for prostitution or
                        pornography;
                      </p>
                      <p class="txt-indent">
                        (10) Where the player uses the [Tiger777] gaming
                        platform to disseminate information that involves
                        criminal activities or incites crimes;
                      </p>
                      <p class="txt-indent">
                        (11) Where the player uses the [Tiger777] gaming
                        platform to disseminate or publish comments that are
                        deemed by the laws as illegal or those that incite
                        crimes (e.g. using gangster terms for drug trafficking
                        such as hard, soft, boy, girl, sales of candy, and other
                        synonyms).
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Inappropriate names (including names used in the game
                        and nicknames on the website platform)
                      </div>
                      <p>
                        The names of avatars and channels are entered by the
                        player when they are created. Once the names of avatars
                        and channels are entered, they cannot be changed. The
                        player should exercise proper care for naming their
                        cherished avatars and channels. In the event that the
                        name of a player's avatar or channel contains an
                        inappropriate name that violates the regulations, the
                        avatar or channel shall be blocked, deleted, dissolved,
                        or changed without prior notice. Under the following
                        conditions, the Company has the right to implement
                        direct penalties without prior notice. However, if an
                        item is not listed in the following description of
                        restrictions, the item shall be processed in accordance
                        with social morals in a just manner.
                      </p>
                      <p class="txt-indent">
                        (1) The user may not use names and images the website
                        that are similar to the official personnel, adopt a name
                        of the Company's related organization, or use names that
                        may be confused with staff members including using
                        special characters that may not be distinguished by
                        regular players to separate the aforementioned
                        combinations. Examples include: customer service,
                        Tiger777, and GM shall be restricted to official
                        personnel of the Company.
                      </p>
                      <p class="txt-indent">
                        (2) Nicknames or images with allusive, obscene, rude,
                        insulting, slandering, personal attacks, threatening, or
                        provocative against the Tiger777 game company or
                        its employees. Examples include: " Tiger777
                        sucks", "idiot customer service", etc.
                      </p>
                      <p class="txt-indent">
                        (3) A name/image of an avatar in the game that contains
                        racial or gender discrimination, profanity, lewd,
                        erotic, pornographic contents or meanings, or phrases
                        that violate good social morals. Examples include: "Who
                        wants a one night stand" or "prostitute".
                      </p>
                      <p class="txt-indent">
                        (4) A name/image of an avatar in the game that is deemed
                        by the laws as illegal or those that incite crimes.
                        Examples include: hard, soft, boy, girl, sales of candy,
                        and other synonyms for drug trafficking.
                      </p>
                      <p>
                        Note: Text (full/half-size text, uppercase/lowercase
                        text, and homonyms are all restricted).
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Using bugs to play the game (including for advertising
                        and dissemination of information)
                      </div>
                      <p>
                        The player may not use unnatural or unintentional errors
                        or bugs in the game, methods or means that violate the
                        principles of fairness and reasonableness for gaming
                        (unpublished bugs shall be determined by the Company),
                        or loopholes in the game to increase the load of the
                        server, crash the server, create benefits for the
                        player, use others, and cause imbalances in the game.
                        The player shall immediately report to the gamemaster if
                        the player discovers a bug in the game. If the player
                        uses a bug or loophole in the game, imperfection in the
                        rules, or any other irregular method to obtain
                        exponentially unlawful interest, cause imbalances in the
                        game or other losses, affect the rights and interest of
                        other players, and cause effects beyond the scope of the
                        original design, all information of all related parties
                        shall be processed as follows after verification:
                        <br />The Company shall implement a [temporary freeze]
                        on the game accounts and confiscate the illegal interest
                        directly and indirectly obtained by the player through
                        the bug. However, where the conditions are severe and
                        the illegal interest cannot be correctly confiscated or
                        where the illegal interest may cause other irreversible
                        conditions, the Company shall issue a notice in written
                        format or email and suspend the player's usage rights of
                        the game till the data in the user account is corrected.
                        The account shall be restored based on the backup data
                        under normal conditions.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Malicious alteration of the game program
                      </div>
                      <p>
                        The user may not invade, intercept, or damage the game
                        program, modify or compile the game, modify the game
                        program memory code, remove the encryption of the game
                        program, or use any method to alter, duplicate, or
                        change the packages and values, etc. to change the
                        contents and data of the game program to obtain
                        exponentially unlawful interest. If such actions cause
                        imbalances in the game or other losses, affect the
                        rights and interest of other players, and cause effects
                        beyond the scope of the original design, all information
                        of all related parties shall be processed as follows
                        after verification:<br />Once such actions are verified
                        by the Company, the Company shall confiscate the illegal
                        interests directly or indirectly obtained through the
                        player's malicious alteration of the game program. The
                        Company has the right to immediately terminate the
                        contract with the player and confiscate all game coins
                        and items the player has illegally obtained without
                        notice. The Company shall also retain the right to take
                        legal actions (including all related accounts).
                      </p>
                    </section>
                    <section>
                      <div class="title">Reporting "hackers" and "frauds"</div>
                      <p>
                        To implement and maintain the fairness in the game and
                        assist the Company in cracking down on players suspected
                        of using "hacking" and "fraud", you agree that the
                        Tiger777 program may obtain certain information
                        including related information from your computer and its
                        components including but not limited to your keyboard,
                        mouse, graphics card, network card, CPU, RAM, and IP
                        address without prior notice. Such information shall
                        include whether there are "unauthorized third-party
                        programs" that operate simultaneously with Tiger777.
                      </p>
                      <p class="txt-deep-blue">
                        Note: The aforementioned information shall only be used
                        to protect players, maintain the quality of the game,
                        uncover players who conduct malicious, inappropriate, or
                        legal actions, and trace data.
                      </p>
                      <p class="txt-deep-blue">
                        Note: The "unauthorized third-party programs" refers to
                        programs used without the approval of the Company.
                        Others include without limitation those that can be
                        independently determined by the Company as (1) able to
                        facilitate or provide any fraud; (2) allow the game
                        client program to modify or invade the game interface
                        and environment; (3) third-party software that
                        intercepts, uncovers, or uses other methods to collect
                        information from the game.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        We need you to supervise and maintain a high-quality and
                        happy gaming environment. If you discover any violation
                        prohibited by the Company, we need you to help us and
                        report the violation immediately.
                      </div>
                      <p class="txt-indent">
                        (1) Direct reports<br />To eliminate unfairness in the
                        game, the gamemaster conducts a daily security
                        inspection on the scores of the game and amounts of
                        related game assets on the previous day. All members
                        suspected of cheating and those with irregular increase
                        in the amount of related game assets shall be listed in
                        the evaluation list. Once verified, the Company may
                        immediately terminate the contract with a notice to the
                        service user.
                      </p>
                      <p class="txt-indent">
                        (2) Report/complaint<br />A player may file a report or
                        complaint if the player discovers a suspected violation
                        of the Game Rules.<br />The Company shall immediately
                        conduct investigations after receiving notice. Once
                        verified, the Company may notify the service user and
                        publish the violation on the Tiger777 game
                        website.
                      </p>
                      <ol>
                        <li>
                          To file a report or complaint, please include:
                          <ul>
                            <li>
                              Your nickname (for complaints, please also include
                              the member nickname for your complaint)
                            </li>
                            <li>Reason</li>
                            <li>
                              Time and place of occurrence (Game zone or area or
                              activity name)
                            </li>
                            <li>
                              The full image(s) taken or other information that
                              can be used as evidence. Attention: Complaints
                              shall be accepted within one month of the month of
                              occurrence. Overdue complaints shall not be
                              accepted.
                            </li>
                          </ul>
                        </li>
                        <li>
                          Methods for filing a report or complaint:
                          <ul>
                            <li>
                              Tiger777 Customer Service Mailbox
                              (Applicable for cases where images are provided)
                            </li>
                            <li>The "Feedback" function in the game.</li>
                          </ul>
                        </li>
                      </ol>
                      <p class="txt-indent">
                        (3) Appeals against penalties<br />The player's rights
                        shall be the contents under "right of appeal" in the
                        "User Contract" signed by the player for the membership
                        application. Please report an issue in the game or send
                        a letter to
                        <a href='"mailto:admin@tiger777.com"'
                          >admin@tiger777.com</a
                        >，We shall contact the member as quickly as possible
                        after receiving the message or email.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Related regulations on virtual items
                      </div>
                      <p class="txt-indent">
                        (1) The game allows user accounts to use points to
                        exchange for virtual items or game coins. The user's
                        approval is required and the credit points will lose all
                        substantive value after the exchange procedures are
                        completed.
                      </p>
                      <p class="txt-indent">
                        (2) The game allows user accounts to use points to
                        exchange for virtual items or game coins. Tiger777 only provides a medium for one-way exchange and
                        cannot convert the items into actual points. If other
                        transactions conducted in private with user accounts
                        cause losses to individuals, the Company shall not be
                        responsible for compensation or bear other legal
                        liabilities.
                      </p>
                      <p class="txt-indent">
                        (3) The virtual items given in the game are only
                        distributed for special events and individual accounts.
                        User accounts may not request the Company to concentrate
                        or transfer all accounts and individual virtual items of
                        a user's true identity to a specific account.
                      </p>
                      <p class="txt-indent">
                        (4) Tiger777 provides functions for exchanging
                        virtual game coins and items but it only provides
                        conversion mechanisms for regular transactions and
                        strictly prohibits sales or purchase of game coins.
                        Users may not request the Company to cancel converted
                        virtual items or game coins in private based on the
                        results of private transactions.
                      </p>
                      <p class="txt-indent">
                        (5) The Company shall not be involved in disputes
                        derived from transactions or acts of transactions of
                        items and characters in the game and other
                        electromagnetic recording between user accounts and
                        other individuals in real life.
                      </p>
                      <p class="txt-indent">
                        (6) The Company shall not be liable for compensation of
                        any damage of the user's game data caused by natural
                        disasters, force majeure factors, or other non-human
                        factors.
                      </p>
                      <p class="txt-indent">
                        (7) Once the value in the point cards purchased by the
                        user is stored, the user shall be deemed as having
                        confirmed the purchase of various services in the
                        system. Game points stored in a user account may not be
                        transferred to a third party.
                      </p>
                      <p class="txt-indent">
                        (8) Where the user discovers illegal use or any
                        irregular damage in the secure use of its game account,
                        it shall notify the Company immediately. The Company
                        shall not be responsible for processing related disputes
                        or compensation for losses caused by illegal use of the
                        account, password, or game data by others for reasons
                        attributable to the user (the user is requested to claim
                        compensation from the illegal user through judicial
                        procedures).
                      </p>
                      <p class="txt-indent">
                        (9) Where an update of the game causes incorrect
                        versions of the game for certain users or where a user
                        cannot continue the game due to personal factors of user
                        accounts (where not all user accounts can log into the
                        Tiger777 game server at the same time), the
                        Company shall endeavor to provide consulting services to
                        the best of its abilities and help user accounts
                        continue the use of the Company's services. However, the
                        Company shall not be responsible for losses due to the
                        inability to access the game that are caused by issues
                        of the user's personal computer or failure or
                        malfunction of the software/hardware equipment of the
                        user, other suppliers, or related telecom operators.
                      </p>
                      <p class="txt-indent">
                        (10) Except for events organized by Tiger777 and
                        issues in the game program itself, the Company shall not
                        be involved in results of any private transactions
                        between user accounts.
                      </p>
                      <p class="txt-indent">
                        (11) When player purchased our APP or application
                        Package (Includes game points, game coins or other game
                        merchandise and package). Within 7 days, players can
                        provide the purchased receipt and refund it from the
                        place they purchased. If the purchased place won’t
                        refund it, you can also contact our company for a
                        refund. If player purchased/ downloaded our APP/ or
                        application package from the platform, then they should
                        follow the platform’s rule for a refund.
                      </p>
                    </section>
                    <section>
                      <div class="title">Contest regulations</div>
                      <p>
                        In events organized by the Company that involve prizes
                        and contests, regardless of whether they are organized
                        on a regular or irregular basis, once a member is
                        verified by the gamemaster to have conducted actions
                        expressly prohibited in the Game Rules in the contest
                        events or conduct other irregular gaming actions that
                        are unspecified but affect the fairness of the game, the
                        Company shall strictly enforce the Game Rules and
                        disqualify the member from continuing participation and
                        cancel award-winning qualifications.
                      </p>
                      <p>
                        Terms and conditions that are not established within the
                        scope of the Regulations shall be specified separately
                        in related webpages of the contests and they shall be
                        effected and implemented on the date of announcement.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Guidelines and management of other special events
                      </div>
                      <p>
                        The Company shall provide guidelines and regulations for
                        functions and special events organized for functional
                        requirements or different themes. If the member
                        disagrees with the new service content or the methods of
                        contest events, please do not use the function or
                        participate in the contest event.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Items not accepted by the Company's customer service and
                        gamemaster (GM)
                      </div>
                      <p class="txt-indent">
                        (1) Questions regarding the collection of virtual or
                        physical gifts and prizes raised after the prescribed
                        deadline specified in related regulations for specific
                        events or contests.
                      </p>
                      <p class="txt-indent">
                        (2) Requests for the Company to restore, transfer, or
                        reassign point allocation settings after the point cards
                        are used and the value is stored.
                      </p>
                      <p class="txt-indent">
                        (3) The Company prohibits members from using Tiger777 member services for any commercial activity. The
                        members may not request the Company to cancel or restore
                        completed virtual coin exchanges for any private
                        transaction based on the results thereof or disputes.
                        However, the Company shall process members' violation of
                        the User Contract in accordance with the Contract.
                      </p>
                      <p class="txt-indent">
                        (4) Except for the use of unfair or unreasonable methods
                        or means for gaming, the Company shall not intervene in
                        other special gaming rules established between members
                        for the game.
                      </p>
                      <p class="txt-indent">
                        (5) The Company shall not be involved in personal
                        grievances or disputes between members. However, members
                        may not post comments on public channels (that contain
                        low-class, obscene, rude, insulting, slandering,
                        personal attacks, threatening, provocative, racial or
                        gender discrimination, profanity, lewd, erotic,
                        pornographic contents or meanings, or phrases that
                        violate good social morals and affect the gaming
                        experience of other players). Violators shall be
                        [banned]
                      </p>
                      <p class="txt-indent">
                        (6) To protect the Company's internal confidential
                        information and the Company's operations for maintaining
                        high-quality services and protecting the interests of
                        all players, we shall not accept questions regarding the
                        internal configuration of the Company, system, and game,
                        personal questions regarding GMs or other players, and
                        other questions unrelated to the game. Players are
                        requested to cooperate.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Conditions for which the Company does not provide
                        compensation for losses
                      </div>
                      <p class="txt-indent">
                        (1) Where a member's Internet connection is interrupted
                        due to an interruption, automatic logout, or computer
                        programming error in the network of its Internet service
                        provider that causes losses in gaming data such as
                        records and points;
                      </p>
                      <p class="txt-indent">
                        (1) Where a member's Internet connection is interrupted
                        due to an interruption, automatic logout, or computer
                        programming error in the network of its Internet service
                        provider that causes losses in gaming data such as
                        records and points;
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Related risks and liabilities to be borne solely by the
                        member
                      </div>
                      <p class="txt-indent">
                        (1) The Company's member services may be subject to the
                        following conditions:
                      </p>
                      <ol>
                        <li>Necessary maintenance for website equipment.</li>
                        <li>
                          Failure or malfunction of the software/hardware
                          equipment of the user, other suppliers, or related
                          telecom operators.
                        </li>
                        <li>
                          Interruption, temporary unavailability, delay, errors
                          in data transmission or storage caused by negligence
                          in human operations.
                        </li>
                        <li>
                          Third-party invasion of the system that results in
                          alteration, forgery, or falsification of data.
                        </li>
                        <li>
                          War, natural disasters, other force majeure factors,
                          or other non-human factors that prevent the Company's
                          equipment from normal operations.
                        </li>
                      </ol>
                      <p>
                        Under the aforementioned conditions, the Company shall
                        not guarantee the accuracy, integrity, security,
                        reliability, appropriateness, timeliness, stability, and
                        free of disconnections or errors in its services. The
                        member is required to understand all risks and all
                        possible damage that may be caused by the use of the
                        service and the member may not seek any compensation or
                        reparation. The member also agrees to the use of emails,
                        files, and other data transmitted by the member as
                        backup data. The Company shall not be liable for the
                        loss of emails, files, and other data in the
                        transmission process.
                      </p>
                      <p class="txt-indent">
                        (2) The following restrictions shall apply to
                        information uploaded by the member (such as discussions
                        and instructions) to the Company's website:
                      </p>
                      <ol>
                        <li>
                          The member is not allowed to infringe on the
                          intellectual property rights or copyright of any third
                          party or the rights of the public or individuals.
                        </li>
                        <li>
                          The member is not allowed to violate any laws or moral
                          standards.
                        </li>
                        <li>
                          The member is not allowed to slander others or publish
                          contents that involve sexual harassment, racial
                          discrimination, or negative effects on children.
                        </li>
                      </ol>
                      <p>
                        The above items are personal actions of members and the
                        member shall be required to bear related legal
                        responsibilities when they occur.
                      </p>
                      <p class="txt-indent">
                        (3) Trade or purchase of illegal value storage serial
                        numbers: <br />It is not safe to purchase game serial
                        numbers from unknown sources online. Members may not
                        conduct transactions in game points with others in
                        private. The Company shall implement a temporary freeze
                        on a member that uses game value storage serial numbers
                        purchased through illegal use of online payment
                        mechanisms (e.g. payment through credit cards and
                        telecommunication accounts). The member's rights shall
                        only be restored after the member completes the payment.
                        The related legal liabilities for illegal use of online
                        payment mechanisms shall also be borne by the member who
                        uses the account. The Company shall also cooperate with
                        judicial agencies in investigations.
                      </p>
                      <p class="txt-indent">
                        (4) The Company prohibits members from using Tiger777 member services for any commercial activity. The
                        Company shall bear no responsibility for the results or
                        disputes in any personal transaction between members.
                      </p>
                      <p class="txt-indent">
                        (5) Members are obligated to safely store their accounts
                        and passwords on Tiger777 and they may not
                        disclose, loan, transfer or provide them to a third
                        party. Where the member discovers illegal use or any
                        irregular damage in the secure use of its account, it
                        shall notify the Company immediately for the Company to
                        take related response measures. However, the measures
                        taken by the Company shall not be construed as the
                        Company's explicit or implicit guarantee or
                        responsibility for compensation.<br />The Company shall
                        not be liable for compensation for illegal use of your
                        account and password. However, you may request a game
                        log and report to the police unit in the jurisdiction
                        <span class="txt-deep-blue"
                          >where such violation occurred
                        </span>
                        and file a suit in accordance with legal procedures. The
                        Company shall provide related information in accordance
                        with laws and assist in the investigation of the case.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Statement of rights for amendments of the terms
                      </div>
                      <p>
                        The Company reserves the right to add, alter, or delete
                        all or part of the terms in the Management Regulations
                        to respond to changes in laws or necessities for provide
                        gaming services. The amendments shall be announced and
                        the Company shall not issue individual notices. The
                        player not seek any compensation or reparation and shall
                        be bound by the amended terms after they are announced
                        on the Company's website. By continuing to use the
                        Company's services after the announcements, the player
                        shall be deemed as having agreed to the amended terms.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Assistance in reporting online crimes
                      </div>
                      <p>
                        According to the Personal Information Protection Act,
                        the Company may not be involved in disputes, provide
                        assistance, or implement measures before the government
                        or judicial authorities intervene in the investigation
                        and issues an official letter to the Company to
                        cooperate in the procedures. In the event of suspected
                        fraud or theft of players' accounts, you must ask the
                        police unit in the jurisdiction
                        <span class="txt-deep-blue"
                          >where such violation occurred</span
                        >
                        for assistance. Judicial authorities currently request
                        the provision of game logs, certification of ownership
                        of accounts, and other necessary information for the
                        online crime report procedures when they investigate
                        theft or suspected fraud of players in online games.
                      </p>
                      <p>
                        The Company is prevented by law to actively provide you
                        with related information for filing suits against online
                        crimes. As most actions are conducted by deceiving
                        players to complete transactions to confirm the item and
                        payment transaction, it is difficult for the Company to
                        process disputes that involve different claims from two
                        parties based on its records. The Company also cannot
                        enforce the forceful retrieval of property based on
                        unilateral claims or provide a party with the other
                        party's information. Therefore, the Company cannot
                        render judgments on such issues and players are advised
                        to pay attention to such transactions.
                      </p>
                      <p>
                        In the event of an unfortunate case of fraud that
                        involves the player and legal disputes derived from such
                        actions, the victim is advised to contact customer
                        service and file an application in accordance with
                        procedures to obtain the information necessary for
                        filing a police report. The victim should report to a
                        nearby county or city police department. When the
                        Company receives an official letter issued by a related
                        authority to request assistance, the Company shall
                        provide the judicial authority with all data required
                        for use as evidence. The Company shall assist the police
                        in investigations and bring unlawful players to justice
                        in the real world.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Instructions for players' application of game logs
                      </div>
                      <p>
                        A player whose account is stolen or subject to fraud in
                        the game and wishes to call the police shall be required
                        to obtain game logs from the Company before the police
                        unit
                        <span class="txt-deep-blue"
                          >in the jurisdiction where such violation
                          occurred</span
                        >
                        would accept the report. The procedures for reporting a
                        case are as follows:
                      </p>
                      <p class="txt-indent">
                        (1) Please proceed to the official website → [Customer
                        Service] → [Feedback] →[Message] → and specify the
                        reason for your application of the game log.
                      </p>
                      <p class="txt-indent">
                        (2) After the Company receives your message and verifies
                        the identity information and assesses the content, it
                        shall issue a notice for payment. You must pay the
                        required service fees for the application of the game
                        log to the bank account provided by the customer service
                        center. After you complete the payment and completes the
                        confirmation with the customer service specialist, your
                        application shall be transferred to the related
                        department which shall provide you with the game log.
                        The Company shall mail the "game log" and "account
                        certification statement" via registered mail or email
                        within seven working days (excluding holidays). The
                        customer service specialist shall notify you based on
                        your contact method after the information is mailed.
                      </p>
                      <p class="txt-indent">
                        (3) Please use the "game log" and "account certification
                        statement" to report to the police unit
                        <span class="txt-deep-blue"
                          >in the jurisdiction where such violation
                          occurred</span
                        >
                        and complete report procedures, the Company shall
                        provide detailed information based on the official
                        letter from the police and cooperate with the
                        prosecution and investigation. Please confirm the case
                        progress with the police investigation unit after you
                        complete case report procedures.
                      </p>
                      <p class="txt-indent">
                        (4) Warning to players! If a complaint filed by the
                        player involves the illegal use of the player's account
                        or fraud, disputes, or other computer crimes, the
                        Company is prevented by law to be involved in disputes,
                        provide assistance, or implement measures before the
                        government or judicial authorities intervene in the
                        investigation and issues an official letter to the
                        Company to cooperate in the procedures.
                      </p>
                      <p class="txt-indent">
                        (5) Based on the Company's obligation for safeguarding
                        electromagnetic recording, the Company can only provide
                        up to one month of records for each game log. The
                        records provided for account applications only includes
                        the three months preceding the application date.<span
                          class="txt-deep-blue"
                        >
                          (Note: If you wish to apply for game records for the
                          past three months, you must file three game log
                          applications.)</span
                        >Please begin application procedures in advance. Please
                        note that applications filed past the acceptance date
                        will not be processed.
                      </p>
                      <p class="txt-indent">
                        (6) Before Applying for the game log, please confirm
                        your person information registered in the Company's
                        member database. The Company only provides account
                        information in the member database to the original
                        registrant and no information shall be provided to
                        individuals that do not own the accounts.
                      </p>
                      <p class="txt-indent">
                        (7) The Company only accepts applications for game logs
                        of one account in each [game log] application. If you
                        wish to apply for game logs of more than one account,
                        please fill out the application form to apply.
                      </p>
                    </section>
                    <section>
                      <div class="title">Examples of cases</div>
                      <p>
                        The following are common cases that occur in online
                        games. Please pay attention to such cases to protect
                        your rights and those of other players:
                      </p>
                      <p class="txt-indent">
                        (1) Hsiao-Ming saw another player broadcasting on public
                        channels to sell massive amounts of game coins at low
                        cost. Hsiao-Ming took the opportunity and sent a private
                        message to the player for a purchase. Hsiao-Ming later
                        followed the other party's instructions and purchased a
                        game point card. He informed the other party of the
                        serial number of the game point card. The other party
                        unexpected disappeared. Hsiao-Ming did not receive the
                        agreed game coins and the serial number of the point
                        card was also used. He then discovered that he was
                        defrauded.
                        <br />
                        <span class="txt-deep-blue"
                          >※Reminder: Online fraud occurs often. To prevent
                          losses, do not conduct transactions with players you
                          do not know.</span
                        >
                      </p>
                      <p class="txt-indent">
                        (2) Hsiao-Wei and Ah-Liang are good friends and they
                        play online games together. One day, Hsiao-Wei went
                        abroad and gave his account and password to Ah-Liang and
                        instructed Ah-Liang to help him participate in an event
                        organized in the game when he was abroad. Ah-Liang was
                        later lucky enough to win an event reward for Hsiao-Wei
                        but he became greedy and transferred the virtual item to
                        his own account for his personal use.
                        <br />
                        <span class="txt-deep-blue"
                          >※Reminder: To protect your interest and avoid
                          difficulties in claiming compensation, do not tell
                          anyone your account and password or give them to
                          anyone for use.</span
                        >
                      </p>
                      <p class="txt-indent">
                        (3) Hsiao-Chun and Hsiao-Kao are roommates in a
                        university. One day, Hsiao-Chun passes by Hsiao-Kao's
                        desk and saw a note under the keyboard that contained
                        the account and password for the game. He recalled how
                        Hsiao-Kao has always boasted how great his game
                        character is and became consumed by curiosity. He
                        secretly logged into Hsiao-Kao's account to inspect the
                        character's equipment and attributes but did not
                        transfer anything or perform any action.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Statement of rights for amendments of the terms
                      </div>
                      <p>
                        The Company reserves the right to add, alter, or delete
                        all or part of the terms in the Management Regulations
                        to respond to changes in laws or necessities for provide
                        gaming services. The amendments shall be announced and
                        the Company shall not issue individual notices. The
                        player not seek any compensation or reparation and shall
                        be bound by the amended terms after they are announced
                        on the Company's website. By continuing to use the
                        Company's services after the announcements, the player
                        shall be deemed as having agreed to the amended terms.
                      </p>
                    </section>
                  </div>
                  <div
                    id="policy-wrap"
                   v-show="this.isShowEn == 3 ? true:false"
                    class="contract-wrap"
                    style=""
                  >
                    <section>
                      <div class="title">※About your privacy in JINJINJIN</div>
                      <p>
                        ARC PLAY LTD CO., Ltd. (JINJINJIN) values your privacy
                        on the internet. In order to provide services with this
                        product, we would like to provide this privacy policy to
                        inform you how we collect and manage your personal
                        information and the rights you deserve. Please take a
                        moment reading it. If you do not agree to any of these
                        terms, please do not use the services and events. Your
                        contact is welcomed to leave some feedback and
                        suggestions.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Application</div>
                      <p>
                        I. Our privacy policy applies to: <br /><span
                          >How this product manages any identification collected
                          as user using our services and how we share
                          identification to our business partners.</span
                        >
                      </p>
                      <p>
                        II. Our privacy policy does not apply to: <br /><span
                          >Any other company or individual which this product
                          does not corporate with or hire.</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">※How we collect your information</div>
                      <p>
                        I. Information you give us: <br /><span
                          >Before playing, using services, browsing website or
                          applying for event of JINJINJIN, we will ask you to
                          register and fill out personal information.</span
                        >
                      </p>
                      <p>
                        II. Information we get from your use of our services:
                        <br /><span
                          >JINJINJIN may automatically collect log information,
                          IP address, cookies and data caches.</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">※Collected Information</div>
                      <p>
                        The personal data collected by the company will include
                        the following:
                      </p>
                      <p>
                        I. It is necessary to collect this information, the
                        collected information is mainly used for customer
                        service, marketing and internal statistical analysis.
                      </p>
                      <ul>
                        <li>Login Time</li>
                        <li>IP Login Location</li>
                        <li>Device model and code</li>
                        <li>Device operating system and version</li>
                        <li>
                          If you are using Facebook account login, will collect
                          Facebook ID
                        </li>
                      </ul>
                      <p>
                        II. Optional information, the information provided is
                        evidence of whether it is proof of the account holder.
                      </p>
                      <ul>
                        <li>
                          Identify individuals: such as name, address, phone
                          number, photo, email, etc.
                        </li>
                        <li>
                          The identifier in the government data: such as the ID
                          card number, passport number, etc.
                        </li>
                        <li>
                          Personal description: such as age, gender, date of
                          birth, etc.
                        </li>
                        <li>License: such as a driver's license.</li>
                        <li>
                          Financial identification: such as the number of the
                          bank account.
                        </li>
                        <li>
                          Contact information: such as mobile phone number,
                          address, etc.
                        </li>
                      </ul>
                    </section>
                    <section>
                      <div class="title">※Use of Personal Data</div>
                      <p>I. Reveal, Rent or Sell:</p>
                      <p class="txt-indent">
                        (1) JINJINJIN use your information only on specific
                        purpose. Your personal information will not be revealed,
                        rented or sold to third party unless you agree to. In
                        addition, we will not use your information on any other
                        purpose without informing you in advance. To comply with
                        the above, we may share information about you with
                        others in the following situations or other
                        circumstances described in this Privacy Policy:
                        <br /><span
                          >Share information about you with our employees,
                          affiliates, related companies, sellers, consultants,
                          and third-party service providers who work on behalf
                          of the company (including, for example, payment
                          dealer, web hosting services and or services
                          supplier).</span
                        >
                        <br /><span
                          >Respond to legal proceedings or requests for
                          information (including, for example, government or
                          regulatory agencies, law enforcement agencies or
                          courts) in compliance with applicable laws, rules or
                          regulations or where disclosure is required.</span
                        >
                        <br /><span>Subject to your consent or direction.</span>
                      </p>
                      <p class="txt-indent">
                        (2) Regarding to the content above, JINJINJIN will not
                        reveal your personal information without your agreement.
                        However, we are not able to guarantee under the
                        conditions below: <br /><span
                          >When your behavior violates the terms of service or
                          may influence the rights of JINJINJIN to damage any
                          individual, we believe that it is required to reveal
                          your personal information for recognition, contact or
                          legal pursue.</span
                        >
                        <br /><span
                          >Due to public safety, if government organization asks
                          JINJINJIN to reveal certain personal information,
                          JINJINJIN will follow legal procedure to
                          corporate.</span
                        >
                        <br /><span
                          >JINJINJIN believes it is required to reveal your
                          personal information for legal purpose based on
                          goodwill.</span
                        >
                      </p>
                      <p>II. Before using our services:</p>
                      <p>
                        JINJINJIN will offer full description of our services
                        and how we use your information. You may decide to agree
                        or disagree before using our services. If it is
                        necessary to offer your information to third party,
                        JINJINJIN will request for non-disclosure agreement on
                        your information and make sure the third party execute
                        certainly.
                      </p>
                      <p>III. Data collection purpose and use:</p>
                      <p class="txt-indent">
                        (1) The purpose of data collection is to conduct
                        customer management, membership management, membership
                        contact, customer satisfaction survey and marketing and
                        internal statistical investigation and analysis. The
                        collection method will firstly display the content of
                        the relevant collection terms when the player first logs
                        in to the game, after the player confirms the consent it
                        will start collecting. The second is to collect personal
                        data by means of members filling out electronic or
                        written service forms.
                      </p>
                      <p class="txt-indent">
                        (2) This product is acceptable for others to provide
                        analytical services and to provide advertising within
                        our services. These companies can use technology to
                        automatically collect information about your device and
                        the use of our services, including the IP address,
                        device identification number, and the length of time and
                        clicks on the pages of our services. This product and
                        others may use this information to maintain, enhance and
                        analyze our service features, and to provide
                        advertisements that may be of interest or relevance to
                        the content of the webpage that may be of interest to
                        you. The use of your materials by these third parties
                        will be subject to their respective privacy policies and
                        we will not control or be responsible for third party
                        privacy practices.
                      </p>
                      <p class="txt-indent">
                        (3) With your prior consent, certain services of the
                        company will participate in game and analysis
                        information combined with games from this game and other
                        third-party sources to analyze game and monetization
                        trends, create profiles for each category of players, as
                        well as new games and services, and also perform other
                        analysis services. The company also uses some of the
                        information we collect from our games to advertise
                        outside the game. This includes creating a player-type
                        profile by combining your profile with our advertising
                        partners, providing this information to our advertising
                        agencies and advertising platforms to conduct our
                        targeted advertising outside of this game, as well as
                        other ad analysis and as a performance standard.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        ※Edit or delete personal information
                      </div>
                      <p>
                        When playing games of JINJINJIN, feel free to contact us
                        for assistance in editing your personal information
                        (address, phone number, email…etc). The information that
                        you may edit does not include the records of using our
                        services. Moreover, although your account has been
                        banned, your records of using our services will still be
                        reserved.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Links</div>
                      <p>
                        When using our services, other site links may be
                        activated. For instance, while using the services from
                        the third party or reading an information providing by
                        JINJINJIN, there might be other site links. JINJINJIN
                        cannot guarantee your privacy on other sites. Therefore,
                        it is recommended to read privacy policy on other sites
                        before leaving JINJINJIN games.
                      </p>
                    </section>
                    <section>
                      <div class="title">※About Cookies</div>
                      <p>
                        Cookie is a small file of letters and numbers downloaded
                        on to your computer when you access certain websites.
                        When you use your browser to visit a website, cookies
                        will keep track of your movements, habits or selection
                        within the site and IP address. Websites with membership
                        usually use cookies to store user ID, password, personal
                        websites and browsing history. With all this data,
                        websites can build a list of shopping and browsing of
                        every user but they can not modify any content of
                        visitor’s computer. Please notice that most of browsers
                        automatically accept cookies. If you are not willing to
                        store your data on the website you browsed, you may
                        change the setting about cookies on most of browsers.
                        While disabling cookies, you can still using JINJINJIN
                        services. If you are a member of JINJINJIN, enabling
                        cookies will bring you much more convenience. Therefore,
                        while disabling cookies, we are not able to recognize
                        you on your every visit and bring you more services.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Self-protection</div>
                      <p>
                        With all the protection above, we would like to remind
                        you of keeping your account, password and any other
                        personal information safe. Please do not reveal to any
                        individual. After completing any online transaction or
                        services on other sites, make sure you log out. If you
                        share the computer with someone else or use public
                        computer, please close browsing windows after using to
                        avoid others loading your personal information or
                        emails.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Changes</div>
                      <p>
                        JINJINJIN Privacy Policy may change from time to time.
                        We will post revised privacy policy on official website
                        page of each product and welcome your visiting.
                      </p>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h5-content" v-show="this.isApp == false ? false : true">
               
            <div class="small_bod">
              <div class="small_bod_small">
                <h1 class="useramt">{{ $t("agreement.user") }}</h1>
                <div class="isapp_changeamt subb">
                  <div
                    v-for="(item, index) in amtList"
                    :key="index"
                    :class="
                      active == index ? 'isapp_changeamt_item_sub' : 'isapp_changeamt_item'
                    "
                    @click="changColor(index)"
                  >
                    {{ item.title }}
                  </div>
                </div>
                <div v-show="isZh">
                  <div
                    id="privacy-wrap"
                    class="contract-wrap"
                    v-show="this.isShow==0? true:false"
                  >
                    <!-- <h3>個人資料保護政策</h3> -->
                    <p>
                      欢迎申请加入Tiger777（以下简称本公司）所属会员。请您完整浏览本信息后，再勾选【同意】来进行服务。请理解，当您勾选【同意】则表示您愿意以电子方式行使法律所赋予同意之权利，此行为并具有书面同意之效果。
                    </p>
                    <p>
                      本公司为确保会员之个人资料、隐私及消费者权益之保护，于未来将可能使用消费者之个人资料，谨依隐私权政策规定告知以下事项：
                    </p>
                    <section>
                      <div class="title">一、搜集目的及方式</div>
                      <p>
                        本公司之搜集目的在于进行客户管理、会员管理及营销与内部的统计调查与分析。搜集方式将透过会员填写电子或书面各项服务窗体等方式进行个人资料之搜集。
                      </p>
                    </section>
                    <section>
                      <div class="title">二、搜集之个人资料类别</div>
                      <p>本公司于服务所搜集之个人资料，将包括下列事项：</p>
                      <p class="txt-indent">
                        (一)必要搜集项目，所搜集之数据主要用于客户服务、营销与内部统计调查分析使用：
                      </p>
                      <ul>
                        <li>登入时间</li>
                        <li>IP登入位置</li>
                        <li>装置机种、装置机码</li>
                        <li>装置操作系统与版本</li>
                        <li>
                          使用社群账号登入者，将搜集社群账号ID，例如Facebook ID
                        </li>
                      </ul>
                      <p class="txt-indent">
                        (二)非必要选填项目，所提供之数据得以左证是否为账号持有者证明之一：
                      </p>
                      <ul>
                        <li>
                          辨识个人者：如姓名、地址、电话、相片、电子邮件等。
                        </li>
                        <li>
                          政府资料中之辨识者：如身分证统一编号、护照号码等。
                        </li>
                        <li>个人描述：如年龄、性别、出生年月日等信息。</li>
                        <li>执照或其他许可：如驾驶执照等。</li>
                        <li>辨识财务者：如银行帐户之号码等。</li>
                        <li>联络信息：如手机号码、住址等。</li>
                      </ul>
                    </section>
                    <section>
                      <div class="title">三、利用期间、地区、对象及方式</div>
                      <p class="txt-indent">(一)期间：本公司营运期间。</p>
                      <p class="txt-indent">
                        (二)地区：会员之个人资料将用于台湾及马来西亚地区。
                      </p>
                      <p class="txt-indent">
                        (三)利用对象及方式：会员之个人资料搜集除用于本公司之会员管理、客户管理之检索查询等功能外，将有以下利用方式：
                      </p>
                      <ol>
                        <li>
                          实体物品领取：于交寄相关商品时，将利用于交付给相关物流、邮寄厂商用于物品寄送之目的。
                        </li>
                        <li>
                          游戏宣传营销：本公司将利用会员之地址及邮件、电话号码进行本公司或合作厂商商品之宣传营销。
                        </li>
                        <li>
                          当政府或主管机关为预防、调查、侦查或追诉犯罪或执行刑罚等目的需求时，依政府或主管机关要求配合提供所需信息。
                        </li>
                        <li>本公司与会员间之其他因契约所产生之权利义务。</li>
                      </ol>
                    </section>
                    <section>
                      <div class="title">四、会员个人资料之权利</div>
                      <p>
                        会员交付本公司个人资料者，依个资法得行使以下权利（但法令另有规定外，不在此限）：
                      </p>
                      <p class="txt-indent">(一) 查询或请求阅览。</p>
                      <p class="txt-indent">(二) 请求制作给予复制本。</p>
                      <p class="txt-indent">(三) 请求补充或更正。</p>
                      <p class="txt-indent">(四) 请求停止搜集、处理或利用。</p>
                      <p class="txt-indent">(五) 请求删除或停止使用。</p>
                    </section>
                    <section>
                      <div class="title">五、会员个人资料之保护</div>
                      <p>
                        本公司处理个人资料之方式将具适当安全性，包括技术上及组织上之措施，以有效防止未经授权或非法之处理、遗失、破坏或损坏情形发生。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        六、会员为行使上开权利时，可径洽本公司客服进行申请，联络e-mail为admin@tiger777.com。本公司为保护所属会员权益，本公司有权要求会员填具申请表单并提示相关身分证明文件；若委托他人代理办理者，需请备妥委托书及双方身分证明文件。本公司得视状况酌收部分之行政费用。
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        七、本公司为保护所属会员之权益，已采取合理及必要之防护措施，防止可能发生之个资泄漏、毁损、窜改及其他损害会员权益之情事发生。
                      </div>
                    </section>

                    <section>
                      <div class="title">
                        八、为避免发生会员权益之纠纷，敬请确实登载个人之资料；如未来因不实资料发生争议(例如伪冒身分)时，本公司将视状况而进行法律诉追。
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        九、本公司为配合相关法令之异动，有权自行修订会员「个人资料保护政策」之内容。
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        十、本政策将长期于本公司网站进行公告，须请会员自行密切注意；本政策进行修订时，亦将以公告或电子邮件方式通知所属全体会员。
                      </div>
                    </section>
                  </div>
                  <div
                    id="contract-wrap"
                    class="contract-wrap"
                    style=""
                    v-show="this.isShow==1? true:false"
                  >
                    <section>
                      <p>
                        欢迎来到ARC PLAY LTD CO.【Tiger777】游戏平台（以下简称本游戏），为保障你的权益，请于注册成为【Tiger777】会员并开始使用本游戏之服务前，详细阅读本使用合约书之所有内容。
                      </p>
                      <p>
                        提醒您，要先行审阅本契约三日以上，再按下【我同意】键。
                      </p>
                      <br />
                      <p>
                        立契约书人<br />
                        消费者（以下简称「甲方」，请依会员注册流程填写）<br />
                      </p>
                      <br />
                      <p>
                        企业经营者名称： ARC PLAY LTD CO.（以下简称「乙方」）<br />代表人：Chiang
                        Po Wei<br />电子邮件：<a href=""
                          >admin@tiger777.com</a
                        ><br />网址：<a href=""
                          >www.tiger777.com</a
                        >
                      </p>
                    </section>
                    <br />
                    <section>
                      <div class="title">第一条、法定代理人</div>
                      <p>
                        甲方为限制行为能力人者，本契约订定时，应经甲方之法定代理人同意，本契约始生效力；甲方为无行为能力人者，本契约之订定，应由甲方之法定代理人代为之。
                      </p>
                      <p>
                        若有限制行为能力人未经同意或无行为能力人未由法定代理人代为付费购买点数致生法定代理人主张退费时，法定代理人得依官网公告流程，备妥证明文件并提出申请，经乙方确认后，退还甲方未使用之游戏费用。
                      </p>
                      <p>
                        乙方应于官网首页、游戏登入页面或购买页面以中文明显标示，若甲方为限制行为能力人或无行为能力人，除应符合第一项规定外，并应于甲方之法定代理人阅读、了解并同意本契约之所有内容后，方得使用本游戏服务，本契约条款变更时亦同。
                      </p>
                    </section>
                    <section>
                      <div class="title">第二条、契约适用之范围</div>
                      <p>
                        乙方提供甲方网络联机游戏服务及其他相关服务（以下简称本游戏服务），甲乙双方关于本游戏服务之权利义务，依本契约条款之约定定之。
                      </p>
                    </section>
                    <section>
                      <div class="title">第三条、契约之内容</div>
                      <p>
                        以下视为本契约之一部分，与本契约条款具有相同之效力：
                      </p>
                      <p class="txt-indent">
                        (一) 乙方有关本游戏服务之广告或宣传内容。
                      </p>
                      <p class="txt-indent">
                        (二) 计费制游戏之费率表及游戏管理规则。
                      </p>
                      <p>本契约条款如有疑义时，应为甲方有利之解释。</p>
                    </section>
                    <section>
                      <div class="title">第四条、名词定义</div>
                      <p>本契约之名词定义如下：</p>
                      <p class="txt-indent">
                        (一)
                        网络联机游戏：系指甲方透过计算机、智能型装置或其他电子化载具，链接因特网至乙方指定之服务器所进行联机游戏。但不包括电子游戏场业管理条例所称电子游戏机、单纯区域联机或其他无需透过网络链接游戏服务器之游戏服务。
                      </p>
                      <p class="txt-indent">
                        (二) 游戏网站：系指由乙方为提供本游戏服务所建置之网站。
                      </p>
                      <p class="txt-indent">
                        (三)
                        游戏管理规则：系指由乙方订立，供为规范游戏进行方式之规则且不影响双方契约上之权利义务者。
                      </p>
                      <p class="txt-indent">
                        (四)
                        游戏历程：系指自甲方登入本游戏起至注销本游戏时止，计算机系统对甲方游戏进行过程所为之纪录。
                      </p>
                      <p class="txt-indent">
                        (五)
                        插件：系指非由乙方提供，以影响或改变乙方网络联机游戏运作为目的之程序。
                      </p>
                    </section>
                    <section>
                      <div class="title">第五条、服务范围</div>
                      <p>
                        本契约所提供之游戏服务，系由乙方指定之服务器，让甲方透过因特网联机登入使用本游戏服务。但不包括甲方向因特网接取服务业者申请接取因特网之服务，及提供上网所需之各项硬设备。
                      </p>
                    </section>
                    <section>
                      <div class="title">第六条、游戏登录</div>
                      <p>
                        甲方申请使用本游戏服务，应依申请流程，于游戏网站登录与身分证明文件相符之个人资料或其他必要信息。为确保甲方使用本游戏服务之权益，甲方提供之数据应可验证身分，若有不正确或已变更时，应立即通知乙方更新。
                      </p>
                      <p>
                        乙方若有为提供本游戏服务与甲方联络之必要，而甲方未提供正确之个人资料或原提供之数据不符合真实且未更新，乙方得于甲方提供真实数据或更新数据前，暂停甲方游戏进行及游戏历程查询之服务。但甲方能证明其为契约当事人者，不在此限。
                      </p>
                    </section>
                    <section>
                      <div class="title">第七条、契约解除权规定</div>
                      <p>
                        甲方得于开始游戏后七日内，以书面告知乙方解除本契约，甲方无需说明理由及负担任何费用。
                      </p>
                      <p>
                        前项情形，甲方得就未使用之付费购买点数向乙方请求退费。
                      </p>
                    </section>
                    <section>
                      <div class="title">第八条、计费方式</div>
                      <p>本游戏服务之收费计算方式为免费制：</p>
                      <p>
                        本游戏服务内（例如：游戏商城、在线商店等）有提供需甲方额外付费购买之点数、商品或其他服务（例如：虚拟货币或宝物、进阶道具等），乙方应在官网首页、游戏登入页面或购买页面公告载明付款方式及商品信息。
                      </p>
                      <p>
                        费率调整时，乙方应于预定调整生效日三十日前于官网首页、游戏登入页面或购买页面公告；若甲方于注册账号时已登录通讯数据者，并依甲方登录之通讯数据通知甲方。
                      </p>
                      <p>
                        费率如有调整时，应自调整生效日起按新费率计收；若新费率高于旧费率时，甲方在新费率生效日前已于官网中登录之付费购买点数或游戏费用应依旧费率计收。
                      </p>
                    </section>
                    <section>
                      <div class="title">第九条、本游戏服务应载明之信息</div>
                      <p>
                        乙方应于官网首页、游戏登入页面或购买页面及游戏套件包装上载明以下事项：
                      </p>
                      <p class="txt-indent">
                        (一)
                        依游戏软件分级管理办法规定标示游戏分级级别及禁止或适合使用之年龄层。
                      </p>
                      <p class="txt-indent">
                        (二) 进行本游戏服务之最低软硬件需求。
                      </p>
                      <p class="txt-indent">
                        (三) 有提供安全装置者，其免费或付费信息。
                      </p>
                      <p class="txt-indent">
                        (四)
                        有提供付费购买之机会中奖商品或活动，其活动内容、奖项及中奖等信息，并应记载「此为机会中奖商品，消费者购买或参与活动不代表即可获得特定商品」等提示。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十条、账号与密码之使用</div>
                      <p>
                        甲方完成注册程序后取得之账号及密码，仅供甲方使用。前项之密码得依乙方提供之修改机制进行变更。乙方人员（含客服人员、游戏管理员）不得主动询问甲方之密码。乙方应于契约终止后三十日内，保留甲方之账号及附随于该账号之电磁纪录。
                      </p>
                      <p>
                        契约非因可归责甲方之事由而终止者，甲方于前项期间内办理续用后，有权继续使用账号及附随于该账号之电磁纪录。
                      </p>
                      <p>
                        第二项期间届满时，甲方仍未办理续用，乙方得删除该账号及附随于该账号之所有数据，但法令另有规定者不在此限。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        第十一条、账号密码遭非法使用之通知与处理
                      </div>
                      <p>
                        当事人一方如发现账号、密码被非法使用时，应立即通知对方并由乙方进行查证，经乙方确认有前述情事后，得暂停该组账号或密码之使用权，更换账号或密码予甲方，立即限制第三人就本游戏服务之使用权利，并将相关处理方式揭载于游戏管理规则。
                      </p>
                      <p>
                        乙方应于暂时限制游戏使用权利之时起，即刻以官网公告、简讯、电子邮件、推播或其他双方约定之方式通知前项第三人提出说明。如该第三人未于接获通知时起七日内提出说明，乙方应直接回复遭不当移转之电磁纪录予甲方，如不能回复时可采其他双方同意之相当补偿方式，并于回复后解除对第三人之限制。但乙方有提供免费安全装置（例如：防盗卡、电话锁等）而甲方不使用或有其他可归责于甲方之事由，乙方不负回复或补偿责任。
                      </p>
                      <p>
                        第一项之第三人不同意乙方前项之处理时，甲方得依报案程序，循司法途径处理。
                      </p>
                      <p>
                        乙方依第一项规定限制甲方或第三人之使用权时，在限制使用期间内，乙方不得向甲方或第三人收取费用。
                      </p>
                      <p>
                        甲方如有申告不实之情形致生乙方或第三人权利受损时，应负一切法律责任。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十二条、游戏历程之保存与查询</div>
                      <p>
                        乙方应保存甲方之个人游戏历程纪录，且保存期间为三十日，以供甲方查询。
                      </p>
                      <p>
                        甲方得以書面、網路，或親至乙方之服務中心申請調閱甲方之個人遊戲歷程，且須提出與身分證明文件相符之個人資料以供查驗，查詢費用如下，由甲方負擔：
                      </p>
                      <p>
                        乙方接获甲方之查询申请，应提供第一项所列之甲方个人游戏历程，并于七日内以储存媒介或书面、电子邮件方式提供数据。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十三条、个人资料</div>
                      <p>关于个人资料之保护，依相关法律规定处理。</p>
                    </section>
                    <section>
                      <div class="title">第十四条、电磁纪录</div>
                      <p>
                        本游戏之所有电磁纪录均属乙方所有，乙方并应维持甲方相关电磁纪录之完整。
                      </p>
                      <p>
                        甲方对于前项电磁纪录有使用支配之权利。但不包括本游戏服务范围外之移转、收益行为。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十五条、信息公开</div>
                      <p>
                        乙方应于游戏网站上提供本游戏服务之服务器可容纳人数、同时上线人数与联机状况等相关信息，并定期更新。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十六条、联机质量</div>
                      <p>
                        乙方为维护本游戏服务相关系统及软硬件设备而预先规划暂停本游戏服务之全部或一部时，应于七日前于官网首页、游戏登入页面或购买页面公告。但因临时性、急迫性或不可归责于乙方之事由者，不在此限。
                      </p>
                      <p>
                        因可归责乙方事由，致甲方不能联机使用本游戏服务时，乙方应立即更正或修复。对于甲方于无法使用期间遭扣除游戏费用或游戏内商品，乙方应返还游戏费用或商品，无法返还时则应提供其他合理之补偿。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十七条、企业经营者及消费者责任</div>
                      <p>
                        乙方应依本契约之规定负有于提供本服务时，维护其自身计算机系统，符合当时科技或专业水平可合理期待之安全性。
                      </p>
                      <p>
                        计算机系统或电磁纪录受到破坏，或计算机系统运作异常时，乙方应于采取合理之措施后尽速予以回复。
                      </p>
                      <p>
                        乙方违反前二项规定或因游戏程序漏洞致生甲方损害时，应依甲方受损害情形，负损害赔偿责任。但乙方能证明其无过失者，得减轻其赔偿责任。
                      </p>
                      <p>
                        乙方计算机系统发生第二项所称情况时，于完成修复并正常运作之前，乙方不得向甲方收取费用。
                      </p>
                      <p>
                        甲方因共享账号、委托他人付费购买点数衍生与第三人间之纠纷，乙方得不予协助处理。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十八条、游戏管理规则</div>
                      <p>
                        为规范游戏进行之方式，乙方应订立合理公平之游戏管理规则，甲方应遵守乙方公告之游戏管理规则。
                      </p>
                      <p>
                        游戏管理规则之变更应依第二十一条之程序为之。游戏管理规则有下列情形之一者，其规定无效：
                      </p>
                      <p class="txt-indent">(一) 抵触本契约之规定。</p>
                      <p class="txt-indent">
                        (二)
                        剥夺或限制甲方之契约上权利。但乙方依第十九条之规定处理者，不在此限。
                      </p>
                    </section>
                    <section>
                      <div class="title">第十九条、违反游戏管理规则之处理</div>
                      <p>
                        除本契约另有规定外，有事实足证甲方于本游戏服务中违反游戏管理规则时，乙方应于官网首页、游戏登入页面或购买页面公告，并依甲方登录之通讯数据通知甲方。
                      </p>
                      <p>
                        甲方第一次违反游戏管理规则，乙方应通知甲方于一定期间内改善。经乙方通知改善而未改善者，乙方得依游戏管理规则，按其情节轻重限制甲方之游戏使用权利。如甲方因同一事由再次违反游戏管理规则时，乙方得立即依游戏管理规则限制甲方进行游戏之权利。
                      </p>
                      <p>
                        乙方依游戏管理规则限制甲方进行游戏之权利，每次不得超过七日
                      </p>
                    </section>
                    <section>
                      <div class="title">第二十条、申诉权利</div>
                      <p>
                        甲方不满意乙方提供之联机质量、游戏管理、费用计费、其他相关之服务质量，或对乙方依游戏管理规则之处置不服时，得于收到通知之翌日起七日内至乙方之服务中心或以电子邮件或书面提出申诉，乙方应于接获申诉后，于十五日内回复处理之结果。
                      </p>
                      <p>
                        乙方应于官网或游戏管理规则中明定服务专线、电子邮件等相关联络信息与二十四小时申诉管道。
                      </p>
                      <p>
                        甲方反映第三人利用插件或其他影响游戏公平性之申诉，依第一项规定办理。
                      </p>
                    </section>
                    <section>
                      <div class="title">第二十一条、契约之变更</div>
                      <p>
                        乙方修改本契约时，应于官网首页、游戏登入页面或购买页面公告之，并依甲方登录之通讯数据通知甲方。
                      </p>
                      <p>
                        乙方未依前项进行公告及通知者，其契约之变更无效。甲方于第一项通知到达后十五日内：
                      </p>
                      <p class="txt-indent">
                        (一)
                        甲方未为反对之表示者，乙方依契约变更后之内容继续提供本游戏服务。
                      </p>
                      <p class="txt-indent">
                        (二) 甲方为反对之表示者，依甲方终止契约方式处理。
                      </p>
                    </section>
                    <section>
                      <div class="title">第二十二条、契约之终止及退费</div>
                      <p>甲方得随时通知乙方终止本契约。</p>
                      <p>
                        乙方得与甲方约定，若甲方逾一年未登入使用本游戏服务，乙方得定相当期限（不得少于三十日）通知甲方登入，如甲方届期仍未登入使用，则乙方得终止本契约。
                      </p>
                      <p>
                        甲方有下列重大情事之一者，乙方依甲方登录之通讯数据通知甲方后，得立即终止本契约：
                      </p>
                      <p class="txt-indent">
                        (一)
                        利用任何系统或工具对乙方计算机系统之恶意攻击或破坏。
                      </p>
                      <p class="txt-indent">
                        (二)
                        以利用插件、病毒程序、游戏程序漏洞或其他违反游戏常态设定或公平合理之方式进行游戏。
                      </p>
                      <p class="txt-indent">
                        (三)
                        以冒名、诈骗或其他虚伪不正等方式付费购买点数或游戏内商品。
                      </p>
                      <p class="txt-indent">
                        (四)
                        因同一事由违反游戏管理规则达一定次数（不得少于三次）以上，经依第十九条第二项通知改善而未改善者。
                      </p>
                      <p class="txt-indent">
                        (五) 经司法机关查获从事任何不法之行为。
                      </p>
                      <p>
                        乙方对前项事实认定产生错误或无法举证时，乙方应对甲方之损害负赔偿责任。
                      </p>
                      <p>
                        契约终止时，乙方于扣除必要成本后，应于三十日内以现金、信用卡、汇票或挂号寄发支票方式退还甲方未使用之付费购买之点数或游戏费用，或依双方同意之方式处理前述点数或费用。
                      </p>
                    </section>
                    <section>
                      <div class="title">第二十三条、停止营运</div>
                      <p>
                        因乙方停止本游戏服务之营运而终止契约者，应于停止终止前三十日公告于官网首页、游戏登录页面或购买页面，并依甲方登录之通讯数据通知甲方。
                      </p>
                      <p>
                        乙方未依前项期间公告并通知，除应退还甲方未使用之付费购买点数或游戏费用且不得扣除必要成本外，并应提供其他合理之补偿。
                      </p>
                    </section>
                    <section>
                      <div class="title">第二十四条、送达</div>
                      <p>
                        有关本契约所有事项之通知，甲方同意乙方依甲方登录之通讯数据为送达。
                      </p>
                      <p>
                        前项登录通讯数据若有变更，甲方应即通知乙方。乙方应依变更后之通讯数据为送达。
                      </p>
                      <p>
                        乙方依甲方登录之通讯数据所为之通知发出后，以书面通知到达甲方，或电子邮件进入甲方之电子邮件服务器中，推定为已送达。
                      </p>
                      <p>
                        因甲方之故意或过失致乙方无法为送达者，乙方对甲方因无法送达所致之损害不负赔偿责任。
                      </p>
                    </section>
                    <section>
                      <div class="title">第二十五条、准据法</div>
                      <p>本契约以台湾法律为准据法。</p>
                    </section>
                    <section>
                      <div class="title">第二十六条、管辖法院</div>
                      <p>
                        因本契约而生之事件，双方合意以台湾台北地方法院为第一审管辖法院。
                      </p>
                    </section>
                  </div>
                  <div
                    id="rules-wrap"
                    class="contract-wrap"
                    style=""
                     v-show="this.isShow==2? true:false"
                  >
                    <section>
                      <p>
                        出现下列违规行为者，经游戏管理员查明属实后，视违反情节，轻微者则强制驱离或禁言亦或停止发话及交易功能，情节重大者则以停权或契约终止。
                      </p>
                      <p>以下为管理与处罚事项：</p>
                      <table cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <th class="guizhe">游戏规章</th>
                            <th class="guizhe">处罚方式</th>
                          </tr>
                          <tr>
                            <td>
                              发言不当（例如：不实言论、不当煽动言论、涉及人身攻击）
                            </td>
                            <td>将【禁言】</td>
                          </tr>
                          <tr>
                            <td>
                              不当游戏行为，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权三日；第二次以上惩处停权七日。
                              情节严重者，将处以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台买卖游戏币，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权三日；第二次惩处停权七日。
                              情节严重者，将处以【终止契约】处置或将【取消赠与服务】。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台买卖道具
                              (非本游戏内所正常使用)，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权三日；第二次惩处停权七日。
                              情节严重者，将处以【终止契约】处置或将【取消赠与服务】。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台散布、宣传具商业广告、或刊登援交色情之资料、网站，或从事中介行为。
                            </td>
                            <td>将处以【终止契约】处置。</td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台买卖、收受、转让
                              游戏账号，含使用本公司服务或藉由本公司服务之行为者。
                            </td>
                            <td>
                              第一次惩处停权七日；第二次将处以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台散布、宣传法令所不允许之言论或引诱人犯罪之言论。
                              （例如：硬的、软的、男生、女生、买卖糖果…等所有贩毒的代名词。）。
                            </td>
                            <td>
                              第一次惩处停权七日；第二次将处以【终止契约】处置。
                              情节严重者，直接处以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              冒充官方人员利用【Tiger777】游戏平台，冒用本公司游戏客服人员或游戏管理员之身分或申请容易造成误认为客服人员或游戏管理员之昵称，与玩家进行任何互动。
                            </td>
                            <td>将处以【终止契约】处置。</td>
                          </tr>
                          <tr>
                            <td>
                              利用【Tiger777】游戏平台，涉及盗用、诈骗违反事实发生时管辖区域法令之行为。
                            </td>
                            <td>
                              将处以【暂时冻结】处置。
                              查证犯罪属实，其违法取得之游戏币、道具等则一并回收(含所有相关账号)。并以【终止契约】处置。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              经司法机关查获或查证乙方疑似从事不法之行为。
                            </td>
                            <td>
                              将处以【暂时冻结】处置。经（检警或相关单位来函要求），其违法取得之游戏币、道具等将暂时冻结若事后查证犯罪属实则一并回收(含所有相关账号)。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              利用游戏之BUG或恶意透过游戏网站程序漏洞，使用插件或擅自修改所获取之不当游戏币及道具。
                            </td>
                            <td>
                              将处以【暂时冻结】处置。回收并删除因利用BUG所得之不当得利及角色数据等纪录。且本公司将采取法律途径处理。(含所有相关账号)
                            </td>
                          </tr>
                          <tr>
                            <td>
                              大量注册账号利用游戏取得不当得益，重大过失不知、明知道具、游戏币违法或不当取得仍为收受之行为。
                            </td>
                            <td>
                              将处以【终止契约】处置。
                              回收所得之不当得利，且本公司将采取法律途径处理。(含所有相关账号)。
                            </td>
                          </tr>
                          <tr>
                            <td>大量新申请账号破坏游戏秩序者。</td>
                            <td>将处以【使用者禁登】或【终止契约】处置。</td>
                          </tr>
                          <tr>
                            <td>
                              恶意申诉回报、辱骂，影响客服人员及客服中心作业，本公司将采取法律途径处理。
                            </td>
                            <td>
                              第一次，惩处停权三日；第二次以上，惩处停权七日。情节严重者，将处以【终止契约】处置。
                              包含Tiger777游戏所有服务平台、游戏公开频道或密频频道。
                            </td>
                          </tr>
                          <tr>
                            <td>
                              使用不当头像图片者（使用未经许可之他人照片、色情猥亵及含煽情淫秽图、人身攻击字样图、不雅字句图、违反社会道德性质、泛政治化、具争议性、商标图、盗用版权图者）
                            </td>
                            <td>
                              第一次惩处锁定头像24小时并强制解除该图片；第二次再违规惩处锁定头像七日并强制解除该图片；第三次违规者直接永久锁定其功能处置并强制解除该图片。
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" class="txt-deep-red">
                              注：以上部份管理与处罚事项，于下方【罚则说明】、【违规事项说明】内详述。
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                    <section>
                      <div class="big-title">罚则说明</div>
                      <p>
                        对于触犯本游戏规范的会员，本公司将视情节轻重适度施以以下处分：
                      </p>
                      <p class="txt-indent">
                        (一)【强制脱机】：藉由系统操作强制使违规者离开游戏。
                      </p>
                      <p class="txt-indent">
                        (二)【禁言】：使违规者在一定时间内无法使用任何方式发言。
                      </p>
                      <p class="txt-indent">
                        (三)【强制关闭频道】：藉由系统操作强制关闭私人创设之频道。
                      </p>
                      <p class="txt-indent">
                        (四)【暂时冻结】：在一定时间内暂时停权违规者对其账号的使用权。
                      </p>
                      <p class="txt-indent">
                        (五)【终止契约】：终止违规者对其账号的使用权利，或将该使用者列为本公司的拒绝往来户，永久停止该账号的使用权及本公司的任何服务。处以终止契约者，同时将游戏内游戏战绩或虚拟物品全数归零。
                      </p>
                      <p class="txt-indent">
                        (六)【使用者禁登】：同一使用者禁止登入Tiger777游戏。
                      </p>
                      <p class="txt-indent">
                        (七)【停权】：同一使用者禁止登入Tiger777游戏。若使用者账号违反上列游戏管理规章遭停权累计达第【三】次者，本公司有权立即终止使用者契约，永久停止该账号的使用权及本公司的任何服务，同时将该使用者账号内于【Tiger777】内之全部虚拟物品及游戏币归零。并列为本公司的拒绝往来户
                      </p>
                    </section>
                    <section>
                      <div class="big-title">违规事项说明</div>
                      <div class="title">不当游戏行为</div>
                      <p>
                        若查明属实确定有以不当方式来进行游戏、使用本公司服务或藉由本公司服务从事非法行为者，造成其他玩家在线虚拟财产（如游戏币）损失或竞赛不公，本公司得于通知本服务使用人，由本公司按其情节轻重限制其游戏使用权利，以维护其他会员权益与【Tiger777】 游戏环境。
                        游戏中禁止贩卖、购买游戏点数卡、虚拟物品。
                        除此之外，所有参与或协助违反本游戏管理规范行为之使用者账号，本公司亦将以相同条例处理之。禁止从事不当游戏行为与违反本公司相关规范，何谓不当游戏行为：
                      </p>
                      <p class="txt-indent">
                        (一)
                        恶意透过游戏系统的漏洞(BUG)，或以任何形式之非游戏所附程序（如：侵入、拦截、破坏、修改游戏数据、封包值）
                        或任何更改原始程序及系统上的锁定与解除锁定系统设定…等不正当方式，来取得游戏中不当游戏战绩、影响游戏公平性者。
                      </p>
                      <p class="txt-indent">
                        (二)
                        以他人账号进行交易、利用游戏获取不当得益或其他违反公平合理之方式使用本服务者。
                      </p>
                      <p class="txt-indent">
                        (三) 利用【Tiger777】游戏平台上或平台上各款游戏中的机制，刻意造成游戏币等游戏资产不当流向。
                      </p>
                      <p class="txt-indent">
                        (四)
                        于游戏中进行买卖游戏币、游戏点数卡或其他相关虚拟物品；【Tiger777】平台提供虚拟游戏币及物品互相赠与功能，但仅提供转换机制正常，不允许买卖的交易行为，且用户不得私下以私下交易结果要求本公司取消已完成转换之虚拟物品、游戏币。
                      </p>
                      <p class="txt-indent">
                        (五) 疑似利用在线储值的方式盗买点数者。
                      </p>
                      <p class="txt-indent">
                        (六) 利用【Tiger777】游戏平台散布、宣传具商业广告或刊登援交色情之资料、网站，或从事中介行为。
                      </p>
                      <p class="txt-indent">
                        (七)
                        从事伤及第三人权益与隐私之行为。（违反个人资料保护法）
                      </p>
                      <p class="txt-indent">
                        (八)
                        干扰游戏或活动进行，且经线上管理人员劝告仍不听从改善。
                      </p>
                      <p class="txt-indent">
                        (九)
                        冒用本公司客服人员或游戏管理员之身分或申请易造成误认为客服人员或游戏管理员之昵称，与玩家进行任何互动。
                      </p>
                      <p class="txt-indent">
                        (十) 利用【Tiger777】游戏平台中的发话机制，以辱骂、诽谤、人身攻击、威胁，或以含淫秽之意（含音似者）、种族歧视之言语攻击其他会员。将【禁言】。
                      </p>
                      (十一) 于游戏大厅中恶意洗频，经【Tiger777】游戏平台会员，拍照检举查询属实。将【禁言】。
                    </section>
                    <section>
                      <div class="title">
                        不当言论 (含游戏内言词、网站平台上留言)
                      </div>
                      <p>
                        为保持游戏的善良风气及所有玩家都可正常观看与使用游戏频道，请大家遵守网络规矩，以维持干净单纯的游戏空间。玩家于Tiger777游戏平台的发言中，包含利用『直接、间接、影射、方言、俚语、错字(注音文)、数字或图形等代替一般的脏话、谐音、解剖学名辞、污辱及这类相关字词的正、反向书写等方式，与文字组合后具有下述定义的字眼与内容皆为不被允许情形』。Tiger777游戏平台上若有以下状况，本公司有权在无事先告知的情况，依各式情形直接进行处分，若于频道上所发表之言论是不被允许，但未被列于以下限制说明，将依道德社会观念之公正认定进行裁决，将【禁言】：
                      </p>
                      <p class="txt-indent">
                        (一) 玩家于【Tiger777】游戏平台上，公开频道中发送含有低级、亵渎、粗鲁、辱骂、诽谤、人身攻击、威胁、挑衅、种族与性别歧视、不雅文字、猥亵及含煽情淫秽、具有色情内容或含意、有违社会善良风俗的惯用词汇之言词内容，影响其他玩家进行游戏之观感。
                      </p>
                      <p class="txt-indent">
                        (二) 玩家于【Tiger777】游戏平台，游戏言词内容假冒官方人员，或是自称官方代表、游戏管理者等。
                      </p>
                      <p class="txt-indent">
                        (三) 蓄意妨碍、辱骂或欺骗官方人员。
                      </p>
                      <p class="txt-indent">
                        (四) 于【Tiger777】游戏平台散布对于公司未经证实或无具体事实根据的不实言论。(包含公开或未公开之讯息(恶意以文字或图片形式)，或是纯属玩家个人揣测等)。企图影响其他玩家进行游戏之观感，若因此造成本公司损害，本公司并保留一切法律追诉之权利。
                      </p>
                      <p class="txt-indent">
                        (五) 于【Tiger777】游戏平台公开频道洗频或重复发言多次，造成玩家无法正常观看频道之情形，例如持续发言无意义的内容(如英数字、乱码、符号、表情、指令、系统默认文字)，
                        或使用相同循环之文字进行重复且有频率的方式发言，皆构成洗频
                        (两人以上即是公开频道) 。
                      </p>
                      <p class="txt-indent">
                        (六)
                        玩家于公开频道上处理私人纠纷或是互相谩骂，以及试图散布并影响其他玩家加入纷争，干扰其他玩家进行游戏。
                      </p>
                      <p class="txt-indent">
                        (七) 于【Tiger777】游戏平台上，违反个人隐私资料的保护，例如：透露其他玩家之Tiger777会员数据。
                      </p>
                      <p class="txt-indent">
                        (八) 于【Tiger777】游戏平台上进行商业广告之行为与内容(如兜售与非游戏相关商品、涉及现实有价物交易之广告行为)。
                      </p>
                      <p class="txt-indent">
                        (九) 于【Tiger777】游戏平台上进行贩卖毒品、枪械等不法物品或涉及刊登援交、色情等不法广告。
                      </p>
                      <p class="txt-indent">
                        (十) 于【Tiger777】游戏平台上散布具有犯罪行为或是教唆犯罪之内容。
                      </p>
                      <p class="txt-indent">
                        (十一) 于【Tiger777】游戏平台上散布、宣传法律所定之不法行为诱人犯罪（例如：言词中含以贩毒之黑话例如：硬的、软的、男生、女生、买卖糖果...等所有贩毒的代名词）。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        不当名称(含游戏内名称、网站平台上昵称)
                      </div>
                      <p>
                        游戏内的角色名称及频道名称为玩家创立时自行输入，角色及频道名称一经设定后将无法任意变更，请玩家妥善为自己心爱的角色及频道命名。
                        玩家角色及频道名称，有违反命名规定的不当名称将在无事先告知的情况下遭到锁定、删除、解散或者变更名称的处置。若有以下状况，本公司有权在无事先告知的情况，依各式情形直接进行处分，但未被列于以下限制说明，将依道德社会观念之公正认定进行裁决。
                      </p>
                      <p class="txt-indent">
                        (一)
                        网站及各式名称/图片不得与官方工作人员名称类似、假冒本公司相关组织名称，以及与工作人员名称混淆之名称，包含中间仅以普通玩家可能无法辨识之特殊字形区隔之以上类似组合。例如：客服、Tiger777、GM等皆属本公司官方人员。
                      </p>
                      <p class="txt-indent">
                        (二)
                        有影射、亵渎、粗鲁、辱骂、诽谤、人身攻击、威胁、挑衅Tiger777游戏公司或从业人员含意之玩家昵称或图片。例如：烂金好运、白痴客服…等。
                      </p>
                      <p class="txt-indent">
                        (三)
                        游戏角色名称/图片含有种族与性别歧视、不雅文字、猥亵及含煽情淫秽、具有色情内容或含意、有违社会善良风俗的惯用词汇之言词。例如：
                        谁要一夜情、援交妹。
                      </p>
                      <p class="txt-indent">
                        (四)
                        游戏角色名称/图片含法律所定之不法行为诱人犯罪文字。例如：硬的、软的、男生、女生、买卖糖果…等所有贩毒的代名词。
                      </p>
                      <p>
                        注：文字(包含全/半型文字、大/小写文字、谐音等皆于限制当中)
                      </p>
                    </section>
                    <section>
                      <div class="title">利用BUG进行游戏(含宣传、散播消息)</div>
                      <p>
                        玩家不可利用游戏中非自然或非刻意之错误BUG或以违反公平合理之方式、手段进行游戏
                        (未公告BUG之部份将以本公司认定为主)或游戏漏洞，甚至造成服务器负担加重或当机等，让自己受惠及利用他人，导致游戏失衡之行为，玩家在发现游戏的BUG后，应及时向游戏管理人员反映。如玩家利用游戏程序的BUG、漏洞或规则不尽完善之处以及其他任何非正常方式，而取得之不当利益暴增等等，导致游戏造成不平衡等损失，与影响其他玩家权益及造成不属于原先设计范围效果，所有关系者经查证属实后之一切数据，处理方式如下：<br />本公司将采取游戏账号【暂时冻结】方式，并回收玩家利用BUG进行游戏而直接、间接获得之非法利益，但若发生之情形过于重大而有无法正确回收非法利益，或该非法利益可能连带产生其他无法回溯之情况，本公司以书面或电子邮件告知后，将暂停其游戏使用权直至用户账号数据修正为止，并且将回溯至正常数据之前的备文件数据。
                      </p>
                    </section>
                    <section>
                      <div class="title">恶意篡改游戏程序</div>
                      <p>
                        用户不得侵入、拦截、破坏游戏程序，或对游戏进行修改、编译、修改游戏程序内存编码或解除游戏程序加密，或以任何方式篡改、复制更改封包及数值…等，来变更游戏程序内容数据，而取得之不当利益暴增等等，而导致游戏造成不平衡等损失，与影响其他玩家权益及造成不属于原先设计范围效果，所有关系者经查证属实后之一切数据，处理方式如下：<br />官方经查证属实者，将回收玩家恶意篡改游戏程序进行游戏而直接、间接获得之非法利益，本公司有权在无事先告知的情况，立即对会员终止契约，其非法所得之游戏币、道具等将一并回收，且本公司将保留法律追溯权。(含所有相关账号)。
                      </p>
                    </section>
                    <section>
                      <div class="title">举发『黑客』、『舞弊』</div>
                      <p>
                        为落实维护游戏公平性与协助本公司取缔可能用『黑客』和『舞弊』行为玩家，您同意Tiger777程序无须对您通知即可从您的计算机及其组件中包括，但不限于获得某些信息，包括您的键盘、鼠标、显示适配器、网络卡、CPU、RAM、IP地址等相关信息，其中包含是否同时有与Tiger777同时运行之『未经许可的第三方程式』。
                      </p>
                      <p class="txt-deep-blue">
                        注：上述信息仅用于保护玩家、维护游戏质量及找出恶意不当或违法行为之玩家等，追溯资料。
                      </p>
                      <p class="txt-deep-blue">
                        注：本文中所称的『未经许可的第三方程式』系指未经本公司同意使用之程序。其他包括但不限于本公司独自判定(1)能进行或提供任何舞弊；(2)能让游戏client端程序修改或侵入游戏接口、环境；(3)拦截、挖掘或以其他方式或通过游戏收集信息的任何第三方软件。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        优质愉快的游戏环境需要大家共同监督维护，若发现任何本公司禁止之违规行为，我们需要您的协力检举、立即回报。
                      </div>
                      <p class="txt-indent">
                        (一) 径行举发<br />为消弭游戏中游戏不公现象，游戏管理员每日针对前一日游戏成绩与相关游戏资产之数额进行安全检查。凡游戏历程有作弊嫌疑或相关游戏资产数量不正常增加之会员，都将列入考核名单，经查证属实，本公司得于通知本服务使用人，立即终止本合约。
                      </p>
                      <p class="txt-indent">
                        (二) 回报／检举告发<br />若有发现疑似违反本游戏规范者，可向官方进行回报或检举告发。<br />官方接获通知后，将立即查明。如查证属实，本公司得于通知本服务使用人，公布Tiger777游戏官网。
                      </p>
                      <ol>
                        <li>
                          进行回报与检举，请附上：
                          <ul>
                            <li>
                              您的昵称（若为检举，请同时附上：您要检举的会员昵称）
                            </li>
                            <li>事由</li>
                            <li>事发时间、地点（游戏区或单元或活动名称）</li>
                            <li>
                              拍下的完整图片或其他可左证之数据
                              请注意：若为检举，受理期限以事发当月起算一个月内，逾时恕不受理。
                            </li>
                          </ul>
                        </li>
                        <li>
                          进行回报与检举方式如下：
                          <ul>
                            <li>
                              Tiger777客户服务信箱（需附加图片者适用）
                            </li>
                            <li>游戏内的『问题回报』</li>
                          </ul>
                        </li>
                      </ol>
                      <p class="txt-indent">
                        (三) 处分申诉<br />请玩家依照申请会员时所签署之「使用者合约」中，「申诉权利」之内容为依据。请至游戏内问题回报或来信<a
                          href='admin@tiger777.com'
                          >admin@tiger777.com</a
                        >，我们将于收到留言或来信后尽速与申诉会员联络。
                      </p>
                    </section>
                    <section>
                      <div class="title">虚拟物品相关规定</div>
                      <p class="txt-indent">
                        (一)
                        游戏中开放使用者账号以点数兑换虚拟物品或游戏币，惟使用者须同意，完成兑换流程后，即不再具有任何实质价值。
                      </p>
                      <p class="txt-indent">
                        (二)
                        游戏中开放使用者账号以点数兑换虚拟物品或游戏币时，Tiger777只提供单向兑换的媒介，无法将其转换成真实点数，若用户账号私下有其他交易行为
                        而造成个人损失，本公司将不负责赔偿或其他法律责任。
                      </p>
                      <p class="txt-indent">
                        (三)
                        游戏中所颁发的虚拟物品，只针对特殊活动与单一账号进行发放，使用者账号不得要求本公司将真实身分中所有的账号与个别虚拟物品集中或转移到特定账号。
                      </p>
                      <p class="txt-indent">
                        (四) Tiger777提供虚拟游戏币及物品相互交易功能，但仅提供转换机制，严禁有买卖游戏币之行为，
                        且用户不得以私下交易的结果要求本公司取消已完成转换之虚拟物品、游戏币。
                      </p>
                      <p class="txt-indent">
                        (五)
                        使用者账号若于现实生活中于本游戏之道具、人物及其他各项电磁记录，与他人交易或互易行为，因此而产生的纠纷与本公司无关。
                      </p>
                      <p class="txt-indent">
                        (六)
                        因天灾、不可抗力或其他非人为因素而导致用户游戏数据的损失，本公司不负赔偿责任。
                      </p>
                      <p class="txt-indent">
                        (七)
                        使用者所购买的点数卡，一经储值后，即表示用户已经确认系统下各项服务之消费；存入使用者账号的游戏点数，将无法转让给第三者。
                      </p>
                      <p class="txt-indent">
                        (八)
                        使用者发现游戏账号遭人非法使用或有任何异常破坏使用安全的情形时，应立即通知本公司；若因可归责于用户而导致账号、密码、游戏数据遭他人非法使用所造成之损失，本公司将不负责处理相关纠纷及赔偿。（请当事者本人循司法程序向盗用者求偿）。
                      </p>
                      <p class="txt-indent">
                        (九)
                        因游戏版本更新，造成部分使用者出现游戏版本不正确或任何因使用者账号个人因素，无法继续进行游戏（同时段内非所有的使用者账号无法登入Tiger777游戏服务器），则本公司将尽力提供咨询服务，协助使用者账号继续使用本公司之服务，但该处理时段内因用户账号个人计算机设备问题或自身、其他第三方或相关电信业者网络系统软硬件设备之故障或失灵造成无法游戏的损失，本公司将不负损害赔偿责任。
                      </p>
                      <p class="txt-indent">
                        (十) 除了Tiger777举办之活动与游戏程序本身之问题外，使用者账号间任何私下交易的结果皆与本公司无关。
                      </p>
                      <p class="txt-indent">
                        (十一)
                        使用者于付费购买本应用程式及／或应用程式套件（包含储值点数、虚拟游戏币或虚拟商品或其组合套件）后7日内，得持未使用之储值序号与购买凭证，向原购买处请求退费，如原购买处不予退费，得洽本公司办理退费。如使用者係于平台业者付费购买/下载本应用程式及／或应用程式套件，应依平台业者规定办理退费。
                      </p>
                    </section>
                    <section>
                      <div class="title">竞赛活动规范</div>
                      <p>
                        举凡本公司与有奖竞赛相关的各活动，无论为常态或不定期举办，会员一旦经由游戏管理员查明属实，确有在各项竞赛活动中从事本游戏管理规范中所明订禁止之行为，或其他未列举而影响游戏公平性的非正当游戏方式，本公司都将按照本规范从严处置，并且判定丧失继续参赛与获奖资格。
                      </p>
                      <p>
                        各竞赛活动若有其他未在本规范订定范围内之条文，将在各竞赛活动之相关网页中另行订定，并自其公告日起生效实施。
                      </p>
                    </section>
                    <section>
                      <div class="title">其他特殊活动办法与管理</div>
                      <p>
                        举凡本公司因功能需求或针对不同主题所举办之特殊活动，本公司会提供该项功能／活动的使用说明与规范，若会员对于新增的服务内容或游戏活动比赛方式有不同意之处，请勿使用该项功能或参与该项活动比赛。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        本公司之客服及游戏管理员(GM)不予受理之事情
                      </div>
                      <p class="txt-indent">
                        (一)
                        在特定活动或竞赛的相关规定期限后，逾期询问虚拟或实体赠品、奖品之兑奖领奖事宜。
                      </p>
                      <p class="txt-indent">
                        (二)
                        点数卡开卡储值后，要求本公司进行回复、转让、更改配点设定。
                      </p>
                      <p class="txt-indent">
                        (三) 本公司禁止会员利用Tiger777会员服务进行任何商业行为。若会员之间有任何私下交易，
                        不得以结果或纠纷要求本公司取消或回复已完成之虚拟游戏币转汇。惟会员违反使用者合约时，本公司将按照合约内容进行处理。
                      </p>
                      <p class="txt-indent">
                        (四)
                        会员之间若于游戏有特殊玩法设定，除了涉及以违反公平合理之方式或手段进行游戏之外，本公司不介入处理。
                      </p>
                      <p class="txt-indent">
                        (五)
                        会员之间私人恩怨、纠纷，本公司不介入处理，但不得于公开频道发送（低级、亵渎、粗鲁、辱骂、诽谤、人身攻击、威胁、挑衅、
                        种族与性别歧视、不雅文字、猥亵及含煽情淫秽、具有色情内容或含意、有违社会善良风俗的惯用词汇之言词内容，影响其他玩家进行游戏之观感。）将【禁言】
                      </p>
                      <p class="txt-indent">
                        (六)
                        询问关于公司内部、系统方面、游戏内部数值设定或是GM私人问题与其他玩家的个人资料等非相关游戏进行的问题，为保守公司内部机密信息公司运作之机密数据，以及保持高质量的服务并保障所有玩家的权益，我们将不受理玩家询问，请玩家配合。
                      </p>
                    </section>
                    <section>
                      <div class="title">本公司不进行损失补偿之情形</div>
                      <p class="txt-indent">
                        (一)
                        会员若因本身网络服务业者网络断线、或自动脱机、或计算机程序错误，发生断线情形，而造成游戏数据，如战绩与点数有所损失。
                      </p>
                      <p class="txt-indent">
                        (一)
                        会员若因本身网络服务业者网络断线、或自动脱机、或计算机程序错误，发生断线情形，而造成游戏数据，如战绩与点数有所损失。
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        相关风险与责任，由会员自行负担之情形
                      </div>
                      <p class="txt-indent">
                        (一) 本公司之各项会员服务可能发生下列情形：
                      </p>
                      <ol>
                        <li>网站设备进行必要之保养。</li>
                        <li>
                          自身、其他第三方或相关电信业者网络系统软硬件设备之故障或失灵。
                        </li>
                        <li>
                          因人为操作上之疏失而造成中断、暂时无法使用、迟延、数据传输或储存上之错误。
                        </li>
                        <li>遭第三人侵入系统篡改或伪造变造数据</li>
                        <li>
                          因战争、天灾、其他不可抗力因素或其他非人为因素，致使本公司设备无法正常运作。
                        </li>
                      </ol>
                      <p>
                        就以上情形，本公司不担保各项服务之正确、完整、安全、可靠、合适、时效、稳定、不会断线及出错。
                        会员需明白使用本服务之所有风险及可能致生之任何损害，不得因此而要求任何补偿或赔偿，并且同意对于会员所传送之电子邮件、档案及其他数据做备份。若因传送过程而造成电子邮件、档案及其他数据之遗失，本公司不负任何担保责任。
                      </p>
                      <p class="txt-indent">
                        (二)
                        会员在本公司网站上传之数据（如谈话、指令等），其内容限制如下：
                      </p>
                      <ol>
                        <li>
                          禁止侵犯任何第三者的知识产权，版权或公众／私人权利。
                        </li>
                        <li>禁止违反任何法律或善良风俗。</li>
                        <li>
                          禁止任何毁谤他人，性骚扰，种族歧视或对孩童有不良影响的内容。
                        </li>
                      </ol>
                      <p>
                        以上均属于会员的个人行为，一旦发生，会员须自行负担相关法律责任。
                      </p>
                      <p class="txt-indent">
                        (三) 交易或购买使用非法储值序号：<br />在线购买来路不明的游戏序号是不安全的，会员不得与他人私下进行游戏点数交易，若因而购买到利用在线付费机制（如信用卡、电信账号代为支付）盗刷而得的游戏储值序号，本公司将对该会员施以暂时冻结处分，直到该会员完成付款动作后，始予以复权。而在线付费机制盗刷的相关法律责任也将由该账号之使用会员自行担负，本公司亦会配合司法单位进行调查。
                      </p>
                      <p class="txt-indent">
                        (四) 本公司禁止会员利用Tiger777会员服务进行任何商业行为。若会员之间有任何私下交易，其结果或纠纷本公司一概不负责任。
                      </p>
                      <p class="txt-indent">
                        (五)会员有义务妥善保管在Tiger777之账号与密码，不泄露、出借、转让，或提供予第三人知悉。
                        若发现账号或密码遭人偷盗、非法使用或有任何异常破坏使用安全之情形，应立即通知本公司，以利本公司采取相关措施。但不得将本公司所采取之措施解释为本公司对你有明示或默示担保或赔偿责任。<br />对于你的账号及密码遭人非法使用，本公司不负任何赔偿责任，但可申请游戏历程至事实发生时管辖区域警政单位报案，依照法律程序起诉处理。本公司将依法提供相关资料，配合案件之协助调查。
                      </p>
                    </section>
                    <section>
                      <div class="title">条款变更权利声明</div>
                      <p>
                        于首页进因应法律之变动或提供游戏服务之必要，本公司保留新增、修改或删除本管理规章之全部或局部条文之权利，并于修改时行公告，不再另行个别通知，
                        玩家不得因此而要求任何补偿或赔偿，并且自该修订条文于本网站公告之时起受其约束。玩家一旦于公告后继续使用本公司各项服务，即视为已经同意该修订条款。
                      </p>
                    </section>
                    <section>
                      <div class="title">网络犯罪报案协助</div>
                      <p>
                        依个人资料保护法规定，本公司在政府司法单位没有介入调查并来函通知配合后续处理前，依法不能涉入该纠纷及做协助或处置，若遇到疑似诈骗或盗取玩家账号等事件，需由事实发生时管辖区域警政单位协助您进行处理。目前针对网络游戏上玩家遭盗用或疑似诈骗事件时，司法单位在实行网络犯罪报案程序时会要求提供游戏历程、账号持有证明等报案必备数据。
                      </p>
                      <p>
                        本公司依法恕不能主动为您提出网络犯罪相关的控诉，由于大部分的行为是诱骗玩家以交易方式达成目的，以达到留下银货两讫的确认交换动作，在官方以记录判断的立场上难以处理双方各说各话的纠纷，更无法依照单方面说词而强制取回财物，或者告知对方数据，因此无法对此类问题予以裁夺，请玩家特别注意。
                      </p>
                      <p>
                        如玩家不幸发生诈欺事件，因上述行为产生涉及法律行为之纠纷，被害者可尽快与客服联系依循流程申请后，取得相关报案必备资料，至邻近县市警察局报案，当本公司收到相关机关发送协助调查的公文时，本公司将依法提供司法单位所需之数据数据，以供查询左证，尽力协助警方侦办，将不肖玩家于现实社会中绳之以法。
                      </p>
                    </section>
                    <section>
                      <div class="title">玩家申请游戏历程说明与注意事项</div>
                      <p>
                        玩家账号遭盗用或游戏中被诈骗欲报警处理的玩家，需由本公司提供游戏历程，事实发生时管辖区域警政单位才会受理。报案流程如下：
                      </p>
                      <p class="txt-indent">
                        (一)
                        请您至官方网站→【客服专区】→【问题回报】→【留言内容】→载明您欲申请游戏历程的缘由。
                      </p>
                      <p class="txt-indent">
                        (二)
                        本公司在收到您的留言，核对身分资料及审核内容皆无误后，即会通知付费，申请游戏历程所需之服务费用需自行汇款至客服中心所提供的银行账号内，待付费完成后，与客服专员确认完毕后，即转交相关部门为您调阅历程。将于七个工作天（不含例假日）内，以挂号或电子邮件寄出
                        『游戏历程』、『账号证明书』给您，并在数据寄出后由客服专员以联络方式通知。
                      </p>
                      <p class="txt-indent">
                        (三)
                        请您持『游戏历程』、『账号证明书』至事实发生时管辖区域警政单位报案，完成报案程序后，本公司将在警方来函后提供详细资料配合检调侦查，故请在完成报案流程后，向警方侦办单位确认办案进度。
                      </p>
                      <p class="txt-indent">
                        (四)
                        提醒玩家注意！若提出的申诉案件中，涉及玩家账号遭盗用，或涉及私人之间的诈欺、纠纷等计算机犯罪事件时，依据隐私权政策，本公司在政府司法单位没有介入调查并来函通知本公司配合后续处理前，依法不能涉入该件纠纷及协助或处置。
                      </p>
                      <p class="txt-indent">
                        (五)
                        受限于电磁数据保管义务，每份历程仅提供最多一个月的记录，账号申请调阅之记录仅提供查询申请日起算的前３个月。<span
                          class="txt-deep-blue"
                          >(注：若账号要申请近三个月的游戏历程记录，则必须申请三份游戏历程。) </span
                        >请尽早申请方便作业，超过受理期限，恕不接受办理，敬请注意。
                      </p>
                      <p class="txt-indent">
                        (六)
                        申请游戏历程前，请确定您登录于本公司会员数据库中的个人资料，本公司只能让于会员数据库中该账号数据中之原始登录人查询所属账号内之数据，非本人则不提供查询。
                      </p>
                      <p class="txt-indent">
                        (七)
                        申请【游戏历程】仅受理查询单组账号之游戏历程纪录，超过一组或多组游戏账号申请时，请分别填写申请书提出申请。
                      </p>
                    </section>
                    <section>
                      <div class="title">案例倡导</div>
                      <p>
                        下面有些网络游戏中较常发生的案例，提醒您多多留意，保护您及其他玩家的权利：
                      </p>
                      <p class="txt-indent">
                        (一)
                        小明在游戏进行时，看到有其他玩家在公开频道广播要便宜卖出大量游戏币，小明一见机不可失，马上密语对方表示要购买。之后小明依对方指示购买游戏点数卡，并告知对方点数卡的序号密码。没想到之后对方人间蒸发，小明不但没有收到约定好的游戏币，点数卡序号也被使用，才惊觉受骗。
                        <br />
                        <span class="txt-deep-blue"
                          >※小提醒：网络诈骗多，请记得不要随意与陌生的玩家进行交易，避免造成损失。</span
                        >
                      </p>
                      <p class="txt-indent">
                        (二)
                        小伟与阿亮是一起玩在线游戏的好友。有一天，小伟出国，将账号密码交给阿亮，交待阿亮在他出国期间帮忙参加游戏举办的活动。之后阿亮果然幸运的帮小伟获得活动奖励，但阿亮一时心生贪念，把虚拟宝物移转到自己的账号占为己有。
                        <br />
                        <span class="txt-deep-blue"
                          >※小提醒：为了自己的权益，及避免之后求偿的困难，请记得不要将账号密码告知或交由任何人使用喔。</span
                        >
                      </p>
                      <p class="txt-indent">
                        (三)
                        小君與小高是大學室友，有天小君經過小高位置時看到了鍵盤下壓著記錄遊戲帳號密碼的紙條，想到小高整天吹噓自己遊戲角色多厲害，一時好奇心起，偷偷登入了小高帳號查看角色裝備屬性，但並未加以移轉或做任何動作。
                      </p>
                    </section>
                    <section>
                      <div class="title">条款变更权利声明</div>
                      <p>
                        因应法律之变动或提供游戏服务之必要，本公司保留新增、修改或删除本管理规范之全部或局部条文之权利，并于修改时于首页进行公告，且不另行个别通知，玩家不得因此而要求任何补偿或赔偿，并且自该修订条文于本网站公告之时起受其约束。玩家一旦于公告后继续使用本公司各项服务，即视为已经同意该修订条款。
                      </p>
                    </section>
                  </div>
                  <div
                    id="policy-wrap"
                    class="contract-wrap"
                    style=""
                    v-show="this.isShow==3? true:false"
                  >
                    <section>
                      <div class="title">
                        ※有关您在【Tiger777】的隐私权
                      </div>
                      <p>
                        Tiger777重视你在网络上的隐私权。为了让你更了解当你使用本产品各项服务时，
                        关于我们在搜集、管理你个人信息方面的
                        作法及你享有之权利，在此提供 你以下说明，
                        请仔细阅读。若你无法同意我们的做法，请暂时不要使用我们网站上的服务或活动，
                        我们竭诚欢迎你与我们的客服人员联络，作进一步询问或者告诉我们你的想法。
                      </p>
                    </section>
                    <section>
                      <div class="title">※隐私权保护政策适用范围</div>
                      <p>
                        一、本隐私权保护政策内容： <br /><span
                          >本隐私权保护政策内容，包括本产品如何管理在用户使用网站
                          服务时收集到的身份识别数据，也包括本产品如何管理在商业伙伴与本产品合作时分享的任何身份识别资料。</span
                        >
                      </p>
                      <p>
                        二、不适用范围： <br /><span
                          >隐私权保护政策不适用于本产品以外的公司，也不适用于非本产品所雇用或管理的人员。</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        ※【Tiger777】如何搜集您的资料
                      </div>
                      <p>
                        一、由你提供： <br /><span
                          >你要加入会员时、使用本公司的产品或服务、浏览产品网页、参加宣传活动或赠奖游戏时，我们会依需求请你填写一些必须的个人资料。</span
                        >
                      </p>
                      <p>
                        二、记录保留： <br /><span
                          >本产品也自动保留你浏览器上的服务器数值，包括互联网协议地址
                          (IP Address)
                          、本产品Cookie中的数据及你要求取用的网页纪录。</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        ※【Tiger777】搜集之个人资料类别
                      </div>
                      <p>本公司于服务所搜集之个人资料，将包括下列事项：</p>
                      <p>
                        一、必要搜集项目，所搜集之数据主要用于客户服务、营销与内部统计调查分析使用：
                      </p>
                      <ul>
                        <li>登入时间</li>
                        <li>IP登入位置</li>
                        <li>装置机种、装置机码</li>
                        <li>装置操作系统与版本</li>
                        <li>使用Facebook账号登入者，将搜集Facebook ID</li>
                      </ul>
                      <p>
                        二、非必要选填项目，所提供之数据得以左证是否为账号持有者证明之一：
                      </p>
                      <ul>
                        <li>
                          辨识个人者：如姓名、地址、电话、相片、电子邮件等。
                        </li>
                        <li>
                          政府资料中之辨识者：如身分证统一编号、护照号码等。
                        </li>
                        <li>个人描述：如年龄、性别、出生年月日等信息。</li>
                        <li>执照或其他许可：如驾驶执照等。</li>
                        <li>辨识财务者：如银行帐户之号码等。</li>
                        <li>联络信息：如手机号码、住址等。</li>
                      </ul>
                    </section>
                    <section>
                      <div class="title">
                        ※【Tiger777】对个人资料之使用
                      </div>
                      <p>一、揭露、租借或转售：</p>
                      <p class="txt-indent">
                        （一）对于你个人资料之使用，仅在搜集之特定目的及相关法令规定之范围内为之。除非经由你的同意或其他法令之特别规定，绝不会将你所登录的个人信息揭露、
                        租借或转售给第三者，或是将你的数据使用于未事先告知你的其他用途。
                        为遵守上述规定，本产品可在以下情况或本隐私政策所述的其他情况，与他方共享关于您的数据：
                        <br /><span
                          >與代表本公司進行工作而需取用該等資料的我方員工、附屬機構、關係企業、賣方、顧問和第三方服務供應商共享關於您的資料（包括：例如，付款處理商、網站主機服務，或資料存儲及處理服務供應商）。</span
                        >
                        <br /><span
                          >在遵照適用法律、規則或規例的規定或在其規定必須披露資料的情況下，回應法律程序或索取資料的要求（包括：例如，政府或管制機構、執法機構或法庭）。</span
                        >
                        <br /><span>在您同意或指示下。</span>
                      </p>
                      <p class="txt-indent">
                        （二）虽已向你作上述之保证，绝不在未经你同意的状况下将你的个人信息任意揭露，但在以下（但不限于）状况下，我们将无法再提供你前述保证：
                        <br /><span
                          >当你在本网站的行为，违反产品的服务条款或可能损害或妨碍产品权益或导致任何人遭受损害，而我们相信揭露你的个人资料是为了辨识、联络或采取法律行动之必要。</span
                        >
                        <br /><span
                          >司法单位或其他有权机关因公众安全，要求本公司公开特定个人资料时，本公司需在司法单位合法正式的程序，及对产品所有用户安全之考虑下，做可能必要的配合。</span
                        >
                        <br /><span
                          >基于善意相信揭露你的个人资料为法律所需要。</span
                        >
                      </p>
                      <p>二、数据提供之事前说明：</p>
                      <p>
                        若为了提供你其他服务或优惠权益，需要与提供该服务或优惠之第三者共享你的数据时，一定会在活动进行前给予你充分的说明，让你有机会了解并决定是否接受该特定服务或优惠。
                        如因上述需要有必要提供第三者你的数据时时，本公司亦会严格要求其遵守保密义务，并且采取必要检查程序以确定其将确实遵守。
                      </p>
                      <p>三、数据搜集目的及使用：</p>
                      <p class="txt-indent">
                        （一）数据搜集目的在于进行客户管理、会员管理、会员联系、客户满意调查及营销与内部的统计调查与分析。搜集方式其一将于玩家第一次登入游戏主动显示其相关搜集条款内容，并在玩家确认同意后，由产品游戏进行搜集．其二将透过会员填写电子或书面各项服务窗体等方式进行个人资料之搜集。
                      </p>
                      <p class="txt-indent">
                        （二）本产品可接受其他人代为提供分析服务，在我们的服务范围内提供广告。该等公司可运用技术自动收集有关您所用装置和使用我们服务的数据，包括IP地址、装置标识符，以及在我们服务内的网页的浏览时间长短和曾点击的连结。本产品和其他人可用这些数据来（其中包括）维持、提升和分析我们的服务功能，提供您可能感兴趣的与网页内容有关联或针对性的广告。这些第三方使用您数据的行为将受其各自隐私政策的规限，且我们不对第三方隐私惯例进行控制或对其负责。
                      </p>
                      <p class="txt-indent">
                        （三）经您事先同意，本公司某些服务将参与游戏和分析信息与从本游戏以及其他第三方来源的游戏结合起来，用于分析游戏和货币化趋势，创建各类别玩家的个人资料以及新游戏和服务，并进行其他分析服务。本公司还使用某些从我们的游戏中收集的信息，在游戏外进行广告宣传。这包含藉由结合您的数据和我们广告合作伙伴的信息，以建立玩家类型的配置文件、将该数据提供给我们广告公司和广告平台，以在此游戏外进行我们的定向广告，以及进行其他广告分析和作为效能标准。
                      </p>
                    </section>
                    <section>
                      <div class="title">※个人资料的修改与删除</div>
                      <p>
                        当你在本产品加入游戏后，你可以联系我们协助更改你原先提供的任何数据（地址、电话、电子邮件信箱等等…）。
                        不过，你所能修改的数据，并不包括你以往在本网站之服务内容记录。
                        另外，当你账号停权后，你曾参与过的各项服务之活动纪录并不会随着账号的停权而一并消失。
                      </p>
                    </section>
                    <section>
                      <div class="title">※连结网页的使用</div>
                      <p>
                        当你使用本产品各项服务时，可能会需要使用网页超链接功能。例如：当你使用某项由第三者所提供的服务，或阅读某则本产品所提供的信息，而该项信息包括其他网页的链接功能时，
                        很抱歉将无法继续提供你连结至其他网站后的隐私权保护，但我们诚挚提醒你，在你离开本产品、进入其他网站时，请记得先阅读该网站所提供的隐私权条款，再决定你是否继续接受该网站的服务。
                      </p>
                    </section>
                    <section>
                      <div class="title">※关于Cookie的使用</div>
                      <p>
                        「Cookies」是一种小小的记录软件，当你拜访设有「Cookies」装置的网站时，该网站的Server便会自动送出「Cookies」至你的计算机中。
                        「Cookies」的功能是，
                        帮助网站区别到访者的身份，记录并储存到访者的使用习惯或选择等等...，并且撷取到访者的IP地址。
                        一般采会员制的网站，会利用「Cookies」来储存用户的ID名称与密码、
                        个人网页、并记录到访者所参观过的网页等，好为每位会员建立一份上网参观或
                        购物的历史清单。但网站并不能利用「Cookies」修改任何到访者本身的计算机内容。
                        在此提醒你，大部分的浏览器会自动接受「Cookies」的储存，然而你若不愿于浏览过的网站上留下痕迹，现有多数浏览器的设计均允许你变更
                        「Cookies」功能。
                        若你关闭你浏览器的「Cookies」功能，仍能阅读产品网页的内容；但若你是会员，使用Cookies将对你在拜访产品时增加许多使用上的便利；换句话说，
                        若你关闭「Cookies」的功能，则往后你每次拜访产品时我们将无法认出你来，可能便因此失去提供你更多贴心服务的机会。
                      </p>
                    </section>
                    <section>
                      <div class="title">※隐私权之自我保护措施</div>
                      <p>
                        在本公司对你的隐私权提供上述保护时，也要在此提醒你，请妥善保管自己的账号密码及或任何个人资料，勿将它们，尤其是密码，提供给任何人。
                        在你完成交易、使用个人服务等程序后，务必记得注销。若你与他人共享计算机或使用公共计算机，也别忘记关闭浏览器窗口，以防止他人读取你的个人资料或信件。
                      </p>
                    </section>
                    <section>
                      <div class="title">※隐私权保护政策之修正</div>
                      <p>
                        Tiger777隐私权保护政策将因应需求随时进行修正，以落实保障你隐私权之立意。修正后的条款将刊登于本产品官网上供您前往点选阅读。
                      </p>
                    </section>
                  </div>
                </div>
                <div v-show="isEn">
                  <div
                    id="privacy-wrap"
                    v-show="this.isShowEn == 0 ? true:false"
                    class="contract-wrap"
                    style="display: block"
                  >
                    <!-- <h3>個人資料保護政策</h3> -->
                    <p>
                      Thank you for applying for the membership of Tiger777 (hereinafter referred to as the Company). Please read
                      the entire message and select [Agree] to access the
                      service. Please be advised that by clicking [Agree], you
                      shall be deemed as having agreed to exercise your right to
                      indicate consent via electronic messages according to the
                      law. This action shall be equally binding as written
                      consent.
                    </p>
                    <p>
                      In order to ensure that personal information and privacy
                      of the members and consumer rights are protected, the
                      Company may use the personal information in the future and
                      hereby discloses the following information in accordance
                      with the Privacy Policy:
                    </p>
                    <section>
                      <div class="title">
                        1. Purpose and method of data collection
                      </div>
                      <p>
                        The Company collects data for the purposes of customer
                        management, membership management and marketing, and
                        internal data collection and analysis. Personal
                        information will be collected via electronic or print
                        forms completed by members.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        2. Types of personal information to be collected
                      </div>
                      <p>
                        The personal information to be collected by the Company
                        in the service will include the following:
                      </p>
                      <p class="txt-indent">
                        (1)Necessary items for which information collected is
                        mainly used for providing services to customers,
                        marketing, and internal statistical analysis:
                      </p>
                      <ul>
                        <li>Login time</li>
                        <li>Login IP</li>
                        <li>Device type and device serial number</li>
                        <li>Device operating system and version</li>
                        <li>
                          Social media account ID such as Facebook ID of users
                          that log in with social media accounts
                        </li>
                      </ul>
                      <p class="txt-indent">
                        (2)Optional items for which information provided is used
                        to prove whether the user is the owner of the account:
                      </p>
                      <ul>
                        <li>
                          Information that identifies an individual: e.g. name,
                          address, telephone, photo, email.
                        </li>
                        <li>
                          Identification by government data: e.g. ID, Serial
                          Number of ID Card, passport number.
                        </li>
                        <li>
                          Personal description: e.g. age, sex, date of birth.
                        </li>
                        <li>
                          Licenses or other permits: e.g. driver's license.
                        </li>
                        <li>
                          Information that identifies personal finance: e.g.
                          bank account number.
                        </li>
                        <li>
                          Contact Information: e.g. mobile phone number and
                          address.
                        </li>
                      </ul>
                    </section>
                    <section>
                      <div class="title">
                        3. Period, region, counterparty, and method of
                        utilization
                      </div>
                      <p class="txt-indent">
                        (1) Period: For as long as the Company continues to
                        operate.
                      </p>
                      <p class="txt-indent">
                        (2) Area: Personal information of the members will be
                        used in Taiwan and Malaysia.
                      </p>
                      <p class="txt-indent">
                        (3) Counterparty and method: In addition to enquiries
                        for membership management and customer management
                        purposes, members' personal information that is
                        collected will be used in the following ways:
                      </p>
                      <ol>
                        <li>
                          Collecting physical items: When a product is entrusted
                          to be delivered, the information will be given to the
                          logistics and mailing services providers to complete
                          the delivery.
                        </li>
                        <li>
                          Promoting games: The Company will use the addresses,
                          email addresses, and telephone numbers for marketing
                          purposes on behalf of the Company or its partners.
                        </li>
                        <li>
                          When the government or competent authorities request
                          information for the prevention, investigation,
                          detection, or prosecution of crimes or to implement
                          criminal penalties, the Company shall provide
                          information in accordance with such requests.
                        </li>
                        <li>
                          Rights and obligations arising from other contracts
                          between the Company and its members.
                        </li>
                      </ol>
                    </section>
                    <section>
                      <div class="title">
                        4. Member rights regarding personal information
                      </div>
                      <p>
                        Members may exercise the following rights regarding
                        their own personal information submitted to the Company
                        (unless otherwise specified by the law):
                      </p>
                      <p class="txt-indent">(1) Enquire or request to view.</p>
                      <p class="txt-indent">(2) Request for a copy.</p>
                      <p class="txt-indent">
                        (3) Request to make supplement or correction.
                      </p>
                      <p class="txt-indent">
                        (4) Request to stop collecting, processing, or accessing
                        information.
                      </p>
                      <p class="txt-indent">
                        (5) Request to delete or cease the use of information.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        5. Protection of personal information of members
                      </div>
                      <p>
                        The Company shall take appropriate security measures
                        including technical and organizational measures to
                        process personal information to effectively prevent
                        unauthorized or illegal processing, loss, destruction,
                        or damage to personal information.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        6. An application may be submitted to the Company's
                        customer services if a member wishes to exercise any of
                        the aforementioned rights. The e-mail is
                        admin@tiger777.com. In order to protect member
                        rights, the Company shall be entitled to require members
                        to complete applications and provide relevant
                        identification. If a third party is appointed as an
                        agent, the appropriate proxy form and identifications
                        for both individuals shall be presented. The Company may
                        charge an administrative fee if needed.
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        7. The Company has taken reasonable and necessary
                        preventive measures to protect the rights of its members
                        in order to prevent potential unauthorized disclosure,
                        damage, and alteration of personal information and other
                        situations that may damage member rights.
                      </div>
                    </section>

                    <section>
                      <div class="title">
                        8. In order to avoid future disputes over member rights,
                        please enter correct personal information. Should any
                        dispute arise from incorrect information (e.g. identity
                        theft) in the future, the Company shall pursue legal
                        actions as needed.
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        9. The Company is entitled to unilaterally amend the
                        Privacy Policy in response to applicable legislation
                        changes.
                      </div>
                    </section>
                    <section>
                      <div class="title">
                        10. This policy shall be disclosed permanently on the
                        Company's website, and the members shall have the
                        responsibility to stay informed. Any amendment to this
                        policy shall also be disclosed publicly or be sent to
                        all members via email.
                      </div>
                    </section>
                  </div>
                  <div
                    id="contract-wrap"
                    v-show="this.isShowEn ==1 ? true:false"
                    class="contract-wrap"
                    style="display: block"
                  >
                    <section>
                      <p>
                        Welcome to the ARC PLAY LTD CO. [Tiger777] game
                        platform (henceforth referred to as the Game). To
                        protect your interests, please register as a [Tiger777] member and carefully read all contents of the
                        User Contract before using the services of the Game.。
                      </p>
                      <p>
                        We remind you to review the Contract for more than three
                        days before clicking the [I agree] button.
                      </p>
                      <br />
                      <p>
                        Parties to the Contract<br />
                        The consumer (henceforth referred to as Party A; please
                        fill out information in accordance with the member
                        registration procedures)<br />
                      </p>
                      <br />
                      <p>
                        Name of corporate operator: ARC PLAY LTD CO. (henceforth
                        referred to as Party B)<br />Representative: Chiang Po
                        Wei<br />E-mail：<a
                          href='"mailto:admin@tiger777.com"'
                          >admin@tiger777.com</a
                        ><br />URL：<a href='"www.tiger777.com"'
                          >www.tiger777.com</a
                        >
                      </p>
                    </section>
                    <br />
                    <section>
                      <div class="title">Article I. Legal representative</div>
                      <p>
                        If Party A is limited in his/her capacity to carry out
                        juridical acts, Party A shall be required to obtain
                        approval from his/her legal representative before the
                        Contract is effected; If Party A is an individual with
                        no capacity, the establishment of the Contract shall be
                        performed by Party A's legal representative on his/her
                        behalf.
                      </p>
                      <p>
                        Where an individual with limited capacity to carry out
                        juridical acts purchases points without the legal
                        representative's approval or where an individual with no
                        capacity fails to purchases points through a legal
                        representative who acts on his/her behalf and the legal
                        representative claims a refund, the legal representative
                        may prepare related certification documents and file an
                        application in accordance with procedures announced on
                        the official website. After Party B's confirmation, it
                        shall refund fees for the game that are unused by Party
                        A.
                      </p>
                      <p>
                        Party B shall provide clear statements on the home page
                        of the official website, game login page, or purchase
                        page in Chinese. If Party A is limited in his/her
                        capacity to carry out juridical acts or an individual
                        with no capacity, it shall meet conditions specified in
                        Paragraph 1 and Party A may only use Game Services after
                        Party A's legal representative reads, understands, and
                        agrees to all terms of the Contract. The same shall
                        apply for changes to the terms of the Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article II. Applicable scope of the Contract
                      </div>
                      <p>
                        Party B shall provide Party A with online game services
                        and other related services (henceforth referred to as
                        Game Services). The parties' rights and obligations
                        related to the Game Services shall be specified in
                        accordance with the terms of the Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article III. Contents of the Contract
                      </div>
                      <p>
                        The following items shall be regarded as integral parts
                        of the Contract and shall have the same validity as the
                        Contract:
                      </p>
                      <p class="txt-indent">
                        (1) Advertisement or announcements regarding the Game
                        Services provided by Party B.
                      </p>
                      <p class="txt-indent">
                        (2) Rates for paid games and management guidelines.
                      </p>
                      <p>
                        Any ambiguity regarding the terms of the Contract shall
                        be construed in favor of Party A.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article IV. Terms and definitions</div>
                      <p>
                        The terms used in the Contract are defined as follows:
                      </p>
                      <p class="txt-indent">
                        (1) Online game: An online game refers to Party A's
                        connection to Party B's server for online gaming through
                        the Internet with computers, smart devices, or other
                        digital devices. It does not include electronic game
                        machines specified in the Electronic Game Arcade
                        Business Regulation Act, simple regional connections, or
                        other Game Services that do not require Internet
                        connection to a game server.
                      </p>
                      <p class="txt-indent">
                        (2) Game website: The game website refers to the website
                        established by Party B to provide the Game Service.
                      </p>
                      <p class="txt-indent">
                        (3) Management guidelines: The management guidelines
                        refer to rules established by Party B that govern the
                        progression of the Game and do not affect the rights and
                        obligations of the parties in the Contract.
                      </p>
                      <p class="txt-indent">
                        (4) Game log: The game log refers to the records of
                        Party A's gaming from logging into the game and logging
                        out of the game that are kept by the computer system.
                      </p>
                      <p class="txt-indent">
                        (5) Plug-ins: A plug-in refers to programs that are not
                        provided by Party B and are designed for the purpose of
                        affecting or changing Party B's online game operations.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article V. Scope of services</div>
                      <p>
                        The Game Services provided in the Contract refers to the
                        use of Game Services by Party A by a connection via the
                        Internet for logging into Party B's designated servers.
                        However, it does not include the Internet access service
                        that Party A applies for with the Internet service
                        provider or the hardware equipment required for Internet
                        access.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article VI. Game login</div>
                      <p>
                        Party A shall register personal information or other
                        necessary information on the game website in accordance
                        with the application procedures to apply for the use of
                        the Game Services. To ensure that Party A's rights and
                        interest in the use of the Game Services, information
                        provided by Party A shall be used to verify Party A's
                        identity. If it is incorrect or if it is changed, Party
                        A shall notify Party B to update such information
                        immediately.
                      </p>
                      <p>
                        Where Party B deems it necessary to contact Party A for
                        providing the Game Services and Party A fails to provide
                        correct personal information or where the information
                        previously provided is not factual and is not updated,
                        Party B may suspend Party A's progression of the game
                        and game log inquiry services before Party A provides
                        valid information or updates the information. However,
                        such conditions shall not apply if Party A can prove
                        that it is the party to this Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article VII. Contract termination rights
                      </div>
                      <p>
                        Party A may notify Party B in writing to terminate the
                        Contract within seven days of commencing the game
                        without the needs to explain the reason or bear any
                        cost.
                      </p>
                      <p>
                        Under such conditions, Party A may request a refund for
                        unused points it purchased from Party B.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article VIII. Payment calculation method
                      </div>
                      <p>
                        The payment calculation method for the Game Services is
                        free of charge:
                      </p>
                      <p>
                        Where Party A is required to pay additional fees for
                        points, products, or other services (e.g. virtual
                        currencies, precious items, or advanced items) in the
                        Game Services (e.g. game mall or online game stores),
                        Party B shall announce the payment method and product
                        information on the homepage of the official website or
                        the game login page.
                      </p>
                      <p>
                        Where the rate is adjusted, Party B shall make the
                        announcement thirty days before the scheduled adjustment
                        date on the home page of the official website, game
                        login page, or purchase page. Where Party A has
                        registered contact information when it registered its
                        account, Party B shall notify Party A based on the
                        contact information registered by Party A.
                      </p>
                      <p>
                        In the event of an adjustment of the rate, it shall
                        apply on the date the adjustment becomes valid; if the
                        new rate is higher than the old rate, the points or game
                        fees paid for by Party A before the effective date of
                        the new rate shall be calculated based on the old rate.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article IX. Information to be specified in the Game
                        Services
                      </div>
                      <p>
                        Party B shall specify the following items on the
                        homepage of the official website, game login page,
                        purchase page, and the game packaging:
                      </p>
                      <p class="txt-indent">
                        (1) The restricted or suitable age group for the game
                        rating based on the Game Software Rating Regulations.
                      </p>
                      <p class="txt-indent">
                        (2) Minimum software and hardware requirements for the
                        use of the Game Service.
                      </p>
                      <p class="txt-indent">
                        (3) Free usage or payment information if safety devices
                        are provided.
                      </p>
                      <p class="txt-indent">
                        (4) Where lucky draw prizes or events are provided for
                        paid purchases the event content, prizes, and award
                        information shall be provided. Party B shall also
                        specify reminders such as "This is an opportunity for
                        winning an item. Consumers' purchase or participation in
                        the event does not guarantee the award of a specific
                        item."
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article X. Use of accounts and passwords
                      </div>
                      <p>
                        The account and password obtained by Party A after
                        completing registration procedures shall be provided for
                        Party A's use only. The password in the preceding
                        paragraph may be changed in accordance with the
                        mechanisms for changes provided by Party B. Party B's
                        personnel (including customer service personnel and game
                        administrators) may not actively inquire Party A's
                        password. Party B shall retain Party A's account and the
                        electromagnetic recording of account for thirty days
                        after the termination of the Contract.
                      </p>
                      <p>
                        Where the Contract is terminated for reasons
                        unattributable to Party A and Party A applies for
                        renewed application of the Contract within the preceding
                        period, it shall retain the right to continue its use of
                        the account and the electromagnetic recording of
                        account.
                      </p>
                      <p>
                        However, where Party A fails to renew the Contract upon
                        the expiry of the period in Paragraph 2, Party B may
                        delete the account and all information associated with
                        the account. However, that this rule shall not apply if
                        otherwise specified in laws and regulations.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XI. Notification and procedures for illegal use
                        of account and password
                      </div>
                      <p>
                        Once a party discovers illegal use of an account or
                        password, it shall notify the other party immediately
                        and Party A shall verify such use. Once Party B verifies
                        of the occurrence of such incident, Party B may suspend
                        the usage rights of the account or password provide a
                        new account or password to Party A. It shall immediately
                        restrict the third party's usage rights for the Game
                        Services and disclose related processing methods in the
                        management guidelines.
                      </p>
                      <p>
                        Party B shall use announcements on the official website,
                        SMS, email, push notifications, or other methods agreed
                        by the parties to notify the third party specified in
                        the preceding paragraph to provide an explanation. Where
                        the third party fails to provide an explanation within
                        seven days of receiving the notice, Party B shall
                        directly restore the electromagnetic recording that was
                        illegally transferred to Party A. If the electromagnetic
                        recording cannot be restored, other equivalent
                        compensation methods agreed by both parties may be
                        adopted and restrictions implemented on the third party
                        shall be lifted after the restoration. However, where
                        Party B has provided a free security device (e.g.
                        anti-theft card or telephone lock) and Party A does not
                        use such device or where there are other reasons
                        attributable to Party A, Party B shall not be
                        responsible for restoration or compensation.
                      </p>
                      <p>
                        If the third party described in Paragraph 1 does not
                        agree to Party B's processing procedures described in
                        the preceding paragraph, Party A may seek legal
                        resolution in accordance with legal procedures.
                      </p>
                      <p>
                        When Party B restricts Party A or a third party's usage
                        rights in accordance with terms in Paragraph 1, Party B
                        may not collect fees from Party A or the third party in
                        the restriction period.
                      </p>
                      <p>
                        Party A shall be liable for all legal responsibilities
                        if it makes false reports and causes damage to the
                        rights of Party B or a third party.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XII. Game log retention and inquiries
                      </div>
                      <p>
                        Party B shall retain Party A's personal game log for
                        thirty days for Party A's inquiry.
                      </p>
                      <p>
                        Party A may apply for its personal game logs by filing
                        applications in writing or online or visiting Party B's
                        service center. Party A shall provide personal
                        information that meets its identification certificates
                        for verification. The fees for the inquiries shall be
                        borne by Party A.
                      </p>
                      <p>
                        After Party B receives Party A's inquiry application, it
                        shall provide Party A's personal game logs listed in
                        Item 1 and provide information in storage media, in
                        writing, or through email within seven days.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XIII. Personal information
                      </div>
                      <p>
                        The protection of personal information shall be
                        processed in accordance with related laws.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XIV. Electromagnetic recording
                      </div>
                      <p>
                        All electromagnetic recording of the Game belongs to
                        Party B. Party B shall also maintain the integrity of
                        Party A's related electromagnetic recordings.
                      </p>
                      <p>
                        Party A retains the right to control the electromagnetic
                        recording specified in the preceding paragraph. Such
                        rights do not include transfers or profitable actions
                        outside the scope of the Game Services.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XV. Information disclosure
                      </div>
                      <p>
                        Party B shall provide information on the number of
                        people that can be supported by the server of the Game
                        Services on the game website. In addition, the number of
                        people online, connection status, and related
                        information shall also be provided and regularly
                        updated.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XVI. Connection quality</div>
                      <p>
                        Party B shall announce planned suspensions of all or a
                        part of the Game Services for the maintenance of related
                        system and hardware/software equipment related to the
                        Game Services on the homepage of the official website,
                        game login page, or purchase page seven days in advance.
                        However, this restriction shall not apply to temporary
                        or emergency conditions or reasons unattributable to
                        Party B.
                      </p>
                      <p>
                        Party B shall immediately rectify or conduct repairs if
                        Party A is prevented from connection to and usage of the
                        Game Services due to reasons attributable to Party B.
                        Where Party A is deducted of gaming fees or items in the
                        game due to the period in which it cannot use the Game
                        Services, Party B shall return gaming fees or products;
                        where they cannot be returned, Party B shall provide
                        other reasonable compensation.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XVII. Responsibilities of the corporate operator
                        and consumers
                      </div>
                      <p>
                        Party B shall be responsible for the maintenance of its
                        computer system when providing the Service based on the
                        terms of the Contract and maintain reasonably expected
                        security levels based on prevailing technology and
                        professional standards.
                      </p>
                      <p>
                        If the computer system or electromagnetic recording is
                        damaged or if the computer system malfunctions, Party B
                        shall take appropriate measures and respond as quickly
                        as possible.
                      </p>
                      <p>
                        If Party B violates the terms in the two preceding
                        paragraphs or if a loophole in the game program and
                        causes damage to Party A, Party B shall be liable for
                        compensation based on the damage suffered by Party A.
                        However, Party B's liabilities for compensation may be
                        reduced if it could prove that it is not at fault.
                      </p>
                      <p>
                        In the event that Party B's computer systems exhibit
                        conditions specified in Paragraph 2, Party B may not
                        collect fees from Party A before restoration is
                        completed and normal operations are resumed.
                      </p>
                      <p>
                        Party B shall not be required to assist in processing
                        disputes between Party A and third parties derived from
                        the shared use of an account or requests for others to
                        purchase points.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XVIII. Management guidelines
                      </div>
                      <p>
                        Party B shall establish reasonable and fair management
                        guidelines to ensure the ongoing management of the Game.
                        Party A shall comply with the management guidelines
                        announced by Party B.
                      </p>
                      <p>
                        Changes to the management guidelines shall be
                        implemented in accordance with procedures set forth in
                        Article XXI. The management guidelines shall be voided
                        under any of the following conditions:
                      </p>
                      <p class="txt-indent">
                        (1) Where they conflict with the terms of this Contract.
                      </p>
                      <p class="txt-indent">
                        (2) Where they deprive Party A of its rights in the
                        Contract or restrict such rights. However, this rule
                        does not apply if Party B implements procedures in
                        accordance with Article XIX.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XIX. Breach of management guidelines
                      </div>
                      <p>
                        Except otherwise specified in the Contract, where there
                        is sufficient proof of Party A's violation of the
                        management guidelines in the Game Services, Party B
                        shall issue announcements on the home page of the
                        official website, game login page, or purchase page and
                        notify Party A based on the contact information
                        registered by Party A.
                      </p>
                      <p>
                        Where Party A violates the management guidelines for the
                        first time, Party B shall notify Party A to make
                        improvements within a certain period of time. Where
                        Party A fails to make improvements after Party B's
                        notice, Party B may, pursuant to the management
                        guidelines, restrict Party A's usage rights for the Game
                        based on the severity of the violation. Where Party A
                        commits the same violation of the management guidelines,
                        Party B may immediately restrict Party A's right to the
                        Game in accordance with the management guidelines.
                      </p>
                      <p>
                        Party B's restriction of Party A's rights to the Game in
                        accordance with the management guidelines shall not
                        exceed seven days in each penalty.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XX Right to complaint</div>
                      <p>
                        In the event that Party A is dissatisfied with the
                        connection quality, game management, payment
                        calculation, or the quality of other related services
                        provided by Party B, or if Party A objects to Party B's
                        methods for processing issues based on the management
                        guidelines, it may file a complaint to Party B's service
                        center or submit a complaint through email or in writing
                        within seven days immediately following the date the
                        notice was received. Party B shall provide a response to
                        the processing of the complaint within fifteen days of
                        receiving the complaint.
                      </p>
                      <p>
                        Party B shall specify the service hotline, email, and
                        other related contact information and 24-hour complaint
                        channels on the official website or management
                        guidelines.
                      </p>
                      <p>
                        Party A's complaints regarding third parties' use of
                        plug-ins or other actions that affects the fairness of
                        the Game shall be processed in accordance with Paragraph
                        1.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XXI. Contract amendment</div>
                      <p>
                        Party B shall announce amendments of the Contract on the
                        home page of the official website, game login page, or
                        purchase page and notify Party A based on the contact
                        information registered by Party A.
                      </p>
                      <p>
                        The amendments to the Contract shall not be valid if
                        Party B fails to issue an announcement or notification
                        in accordance with the preceding paragraph. Party A's
                        actions within fifteen days of the delivery of the
                        notification specified in Paragraph 1:
                      </p>
                      <p class="txt-indent">
                        (1) If Party A does not object, Party B shall continue
                        to provide Game Services in accordance with the amended
                        Contract.
                      </p>
                      <p class="txt-indent">
                        (2) If Party A objects, the objection shall be processed
                        as Party A's termination of the Contract.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XXII. Contract termination and refund
                      </div>
                      <p>
                        Party A may notify Party B to terminate the Contract at
                        any time.
                      </p>
                      <p>
                        Party B may enter an agreement with Party A to specify
                        that if Party A fails to log in and use the Game
                        Services for more than one year, Party B may specify a
                        certain period (no less than thirty days) to notify
                        Party A to log in. If Party A fails to log in before the
                        specified period, Party A may terminate the Contract.
                      </p>
                      <p>
                        Party B may terminate the Contract immediately with the
                        contact information registered by Party A if Party A is
                        found to be in any of the following material
                        circumstances:
                      </p>
                      <p class="txt-indent">
                        (1) Use of any system or tool to conduct malicious
                        attacks or destruction of Party B's computer system;
                      </p>
                      <p class="txt-indent">
                        (2) Use plug-ins, viruses, game program loopholes, other
                        actions that affect the normal settings of the Game, or
                        unfair or unreasonable methods to progress the game;
                      </p>
                      <p class="txt-indent">
                        (3) Impersonation of others or use of fraud or other
                        false and illegitimate methods for purchasing points or
                        products in the Game.
                      </p>
                      <p class="txt-indent">
                        (4) Where Party A violates the management guidelines
                        over a certain number of times (no less than three
                        times) for the same reason and fails to make
                        improvements pursuant to notices for improvements issued
                        in accordance with Article XIX, Paragraph 2.
                      </p>
                      <p class="txt-indent">
                        (5) Found by judicial authorities to be conducting any
                        illegal activity.
                      </p>
                      <p>
                        If Party B makes an error in the determination of the
                        aforementioned facts or fails to provide evidence, Party
                        B shall be liable for compensation for the damage caused
                        to Party A.
                      </p>
                      <p>
                        Upon the termination of the Contract, Party B shall
                        deduct necessary costs and use cash, credit card, wire
                        transfer, or a mailed check to return unused points or
                        game fees paid by Party A within thirty days or process
                        the aforementioned points or fees with methods agreed by
                        the parties.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XXIII. Suspension of operations
                      </div>
                      <p>
                        Where the Contract is terminated due to Party B's
                        suspension of its operations in the Game Services, it
                        shall announce the suspension of operations on the home
                        page of the official website, game login page, or
                        purchase page and notify Party A based on the contact
                        information registered by Party A.
                      </p>
                      <p>
                        Where Party B fails to issue announcements within the
                        aforementioned period based on the preceding paragraph,
                        it shall refund Party A the unused points or game fees
                        paid by Party A and it may not deduct the necessary
                        costs. It shall also provide other reasonable
                        compensation.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XXIV. Delivery</div>
                      <p>
                        Party A agrees that notices regarding all items in the
                        Contract shall be deemed as delivered if Party B
                        delivers the notices with the contact information
                        registered by Party A.
                      </p>
                      <p>
                        Party A shall immediately notify Party B of changes in
                        the aforementioned registered contact information. Party
                        B shall deliver notices based on the changed contact
                        information.
                      </p>
                      <p>
                        Notices issued by Party B based on the contact
                        information registered by Party A shall be deemed as
                        delivered once a written notice is delivered to Party A
                        or once an email enters Party A's email server.
                      </p>
                      <p>
                        Where the delivery fails due to Party A's deliberate or
                        negligent actions, Party B shall not be liable for
                        compensating the losses incurred for a failed delivery.
                      </p>
                    </section>
                    <section>
                      <div class="title">Article XXV. Governing law</div>
                      <p>
                        The Contract shall be governed by the laws of Taiwan.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Article XXVI. Court with jurisdiction
                      </div>
                      <p>
                        The parties herein agree that disputes arising from this
                        Contract shall be submitted to the jurisdiction of
                        Taiwan Taipei District Court which shall serve as the
                        court of first instance.
                      </p>
                    </section>
                  </div>
                  <div
                    id="rules-wrap"
                    v-show="this.isShowEn == 2 ? true:false"
                    class="contract-wrap"
                    style=""
                  >
                    <section>
                      <p>
                        In the event of the following violation that is
                        investigated and verified by the gamemaster, violators
                        shall be punished based on the severity of the
                        violation. Users with minor violations shall be removed,
                        banned, or subject to suspension of their communication
                        and transaction functions; users with gross violations
                        shall be suspended or subject to contract termination.
                      </p>
                      <p>The management items and penalties are as follows:</p>
                      <table cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr>
                            <th>Game Rules</th>
                            <th>Penalties</th>
                          </tr>
                          <tr>
                            <td>
                              Inappropriate comments (Examples include: false
                              statements, inappropriate inflammatory speech, or
                              personal attacks)
                            </td>
                            <td>Violators shall be [banned]</td>
                          </tr>
                          <tr>
                            <td>
                              Inappropriate gaming actions including actions
                              conducted through the use of the Company's
                              services or with the Company's services.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation and
                              each subsequent violation. For gross violations,
                              the violator shall be subject to [contract
                              termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              purchase or sell game coins including actions
                              conducted through the use of the Company's
                              services or with the Company's services.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation. For
                              gross violations, the violator shall be subject to
                              [contract termination] or [cancellation of the
                              gift service].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              purchase or sell items (those that are outside the
                              scope of normal use in the game) including actions
                              conducted through the use of the Company's
                              services or with the Company's services.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation. For
                              gross violations, the violator shall be subject to
                              [contract termination] or [cancellation of the
                              gift service].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              disseminate or publish commercial ads, publish
                              prostitution or pornographic information or
                              websites, or conduct intermediary actions for the
                              above.
                            </td>
                            <td>
                              The violator shall be subject to [contract
                              termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              purchase, sell, accept, or transfer game accounts
                              including actions conducted through the use of the
                              Company's services or with the Company's services.
                            </td>
                            <td>
                              A seven-day suspension for the first violation.
                              the violator shall be subject to [contract
                              termination] for the second violation.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform to
                              disseminate or publish comments that are not
                              permissible by the laws or comments that incite
                              criminal activities. (Examples include: hard,
                              soft, boy, girl, sales of candy, and other
                              synonyms for drug trafficking.).
                            </td>
                            <td>
                              A seven-day suspension for the first violation.
                              the violator shall be subject to [contract
                              termination] for the second violation. For gross
                              violations, the violator shall be subject to
                              direct [contract termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Posing as official personnel by using the
                              [Tiger777] gaming platform to pose as the
                              Company's customer service personnel or gamemaster
                              or applying for nicknames that may cause others to
                              believe that the violator is a customer service
                              staff member or gamemaster and conducting any
                              interactions with players.
                            </td>
                            <td>
                              The violator shall be subject to [contract
                              termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of the [Tiger777] gaming platform for
                              actions that involve illegal use or fraud
                              <span class="txt-deep-blue"
                                >which violate the laws of the jurisdiction when
                                they occurred.</span
                              >
                            </td>
                            <td>
                              The violator shall be subject to [temporary
                              freeze]. Once the crime is verified, the game
                              coins and items illegally obtained by the violator
                              shall be confiscated (including all related
                              accounts). The violator shall also be subject to
                              [contract termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Party B is verified or investigated by judicial
                              authorities for suspected illegal activities.
                            </td>
                            <td>
                              The violator shall be subject to [temporary
                              freeze]. Once a claim is verified (letter of
                              request from the prosecutorial, police, or related
                              unit), the game coins and items illegally obtained
                              by the violator shall be temporarily frozen; if
                              criminal activities are verified in subsequent
                              investigations, they shall be confiscated
                              (including all related accounts).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of a bug in the game or malicious abuse of a
                              loophole in the game website by using plug-ins or
                              correction of game coins and items that are
                              inappropriately obtained.
                            </td>
                            <td>
                              The violator shall be subject to [temporary
                              freeze]. The Company shall confiscate and delete
                              unjust enrichment and character information
                              obtained through the use of bugs and other
                              records. In addition, the Company shall take legal
                              actions against such violations (including all
                              related accounts).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Registration of large numbers of accounts and
                              using the game to obtain unjust profits or gross
                              negligence or deliberate negligence in accepting
                              items or game coins known to be illegal or
                              inappropriate.
                            </td>
                            <td>
                              The violator shall be subject to [contract
                              termination]. Unjust profits shall be confiscated
                              and the Company shall take legal actions against
                              such violations. (including all related accounts).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Creation of large numbers of accounts and damage
                              the order in the game.
                            </td>
                            <td>
                              The violator shall be subject to [user login ban]
                              or [contract termination].
                            </td>
                          </tr>
                          <tr>
                            <td>
                              The Company shall take legal actions against
                              malicious reports, insults, or affecting the
                              operations of customer service and the customer
                              service center.
                            </td>
                            <td>
                              A three-day suspension for the first violation; a
                              seven-day suspension for the second violation and
                              each subsequent violation. For gross violations,
                              the violator shall be subject to [contract
                              termination]. The scope of penalties includes all
                              service platforms of the Tiger777 game,
                              open game channels, and private channels.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Use of inappropriate profile image (unauthorized
                              use of others' images, pornographic, obscene, or
                              erotic images, images that contain personal
                              attacks or obscene phrases, images that violate
                              social morals, overtly political, controversial,
                              trademarks, or copyright violations).
                            </td>
                            <td>
                              The penalty for the first violation shall include
                              locking the profile image for 24 hours and forced
                              removal of the image; the penalty for the second
                              violation shall include locking the profile image
                              for 7 days and forced removal of the image; the
                              penalty for the third violation shall include
                              locking the profile image permanently and forced
                              removal of the image.
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" class="txt-deep-red">
                              Note: The aforementioned management items and
                              penalties are described in the [Description of
                              Penalties] and [Description of Violations] below.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                    <section>
                      <div class="big-title">Description of Penalties</div>
                      <p>
                        The Company shall implement the following penalties for
                        members that violate the Game Rules in accordance with
                        the severity of their violations:
                      </p>
                      <p class="txt-indent">
                        (1) [Compulsory logout]: Use of system operations to
                        force the violator out of the game.
                      </p>
                      <p class="txt-indent">
                        (2) [Ban]: Ban the violator from posting any message in
                        any form for a certain amount of time.
                      </p>
                      <p class="txt-indent">
                        (3) [Compulsory channel closure]: Use of system
                        operations to force the closure of a privately-created
                        channel.
                      </p>
                      <p class="txt-indent">
                        (4) [Temporary freeze]: Suspend the violator's right to
                        use its account for a certain amount of time.
                      </p>
                      <p class="txt-indent">
                        (5) [Contract termination] Terminate the violator's
                        right to use its account or blacklist the user.
                        Permanently suspend the usage right of the account and
                        all services provided by the Company. All gaming records
                        or virtual items of users that are subject to contract
                        termination shall be deleted.
                      </p>
                      <p class="txt-indent">
                        (6) [User login ban]: The user is prohibited from
                        logging into the Tiger777 game.
                      </p>
                      <p class="txt-indent">
                        (7) [Suspension]: The user shall be prohibited from
                        logging into the Tiger777 game.If the user's
                        account violates the aforementioned Game Rules and is
                        suspended for the [third] time, the Company has the
                        right to immediately terminate the user contract,
                        permanently suspend the usage right of the account and
                        all services provided by the Company and delete all
                        virtual items and game coins of the user account in
                        [Tiger777]. The user shall also be blacklisted
                        by the Company.
                      </p>
                    </section>
                    <section>
                      <div class="big-title">Description of Violations</div>
                      <div class="title">Inappropriate actions in games</div>
                      <p>
                        Where a user is verified to be playing the game through
                        inappropriate means or engaging in illegal actions
                        through the use of the Company's services or with the
                        Company's services, thereby causing damage of other
                        players' online virtual property (e.g. game coins) or
                        unfair competition, the Company shall notify the user of
                        the service and the Company shall restrict the user's
                        right to the game based on the severity of the violation
                        to protect the rights and interest of other members and
                        the gaming environment of [Tiger777]. It is
                        prohibited to sell or purchase game point cards or
                        virtual items in the game. In addition, the Company
                        shall also apply the same penalties to all user accounts
                        that participate or assist in the violation of the Game
                        Rules. It is prohibited to engage in inappropriate
                        actions in games and violate the Company's related
                        regulations. Inappropriate actions in games are defined
                        as follows:
                      </p>
                      <p class="txt-indent">
                        (1) Malicious exploitation of a bug in the gaming system
                        or use of any form of program not included in the game
                        (e.g. invasion, interception, destruction, or
                        modification of game information or package value), any
                        modification of original programs, locking and unlocking
                        of system settings, or other inappropriate methods to
                        obtain inappropriate gaming records and affect the
                        fairness of the game.
                      </p>
                      <p class="txt-indent">
                        (2) Use of others' accounts for transactions, abuse of
                        the game to gain unjust profits, or other unfair or
                        unreasonable methods in the game.
                      </p>
                      <p class="txt-indent">
                        (3) Use of mechanisms on the [Tiger777] gaming
                        platform or other games on the platform to deliberately
                        cause inappropriate flow of game coins and other game
                        assets.
                      </p>
                      <p class="txt-indent">
                        (4) Sales or purchase of game coins, game point cards,
                        or other related virtual items in the game; The
                        [Tiger777] platform provides functions for
                        gifting virtual game coins and items but it only
                        provides conversion mechanisms for regular transactions
                        and does not allow sales or purchase transactions. Users
                        may not request the Company to cancel converted virtual
                        items or game coins in private based on the results of
                        private transactions.
                      </p>
                      <p class="txt-indent">
                        (5) Actions that are suspected to involve using online
                        purchases to buy points illegally.
                      </p>
                      <p class="txt-indent">
                        (6) Use of the [Tiger777] gaming platform to
                        disseminate or publish commercial ads, publish
                        prostitution or pornographic information or website, or
                        conduct intermediary actions for the above.
                      </p>
                      <p class="txt-indent">
                        (7) Actions that harm the rights, interest, or privacy
                        of a third party (violation of the Personal Information
                        Protection Act).
                      </p>
                      <p class="txt-indent">
                        (8) Interference with the progression of the game or an
                        event and failure to make improvements after receiving
                        warning from online management personnel.
                      </p>
                      <p class="txt-indent">
                        (9) Pose as the Company's customer service personnel or
                        gamemaster or applying for nicknames that may cause
                        others to believe that the violator is a customer
                        service staff member or gamemaster and conducting any
                        interactions with players.
                      </p>
                      <p class="txt-indent">
                        (10) Use of the speaking function on the [Tiger777] gaming platform for insults, slandering,
                        personal attacks, threats, or use language with obscene
                        (or obscene-sounding) meaning or racist language to
                        attack other members. Violators shall be [banned].
                      </p>
                      (11) Malicious spams in the game lobby that is
                      photographed by a member of the [Tiger777] gaming
                      platform and verified. Violators shall be [banned].
                    </section>
                    <section>
                      <div class="title">
                        Inappropriate comments (including comments made in the
                        game and messages posted on the website platform)
                      </div>
                      <p>
                        To maintain a healthy atmosphere in the game and allow
                        all players to watch and use the game channels normally,
                        please abide by Internet etiquette and maintain a clean
                        and simple game space. If the player uses direct
                        indirect, allusive, dialectic, slang, erroneous words
                        (Zhuyin Fuhao), numbers, or images in place of regular
                        curse words, or homonyms, anatomical terms, or insult or
                        the direct or reverse writing of such terms to form word
                        combinations with the following specific meanings on the
                        Tiger777 gaming platform, such usage shall not
                        be permitted. Under the following conditions on the
                        Tiger777 gaming platform, the Company has the
                        right to implement direct penalties without prior
                        notice. If a comment posted on a channel is not
                        permitted but not listed in the following description of
                        restrictions, the comment shall be processed in
                        accordance with social morals in a just manner and the
                        violator shall be [banned]:
                      </p>
                      <p class="txt-indent">
                        (1) Where the player posts comments with low-class,
                        obscene, rude, insulting, slandering, personal attacks,
                        threatening, provocative, racial or gender
                        discrimination, profanity, lewd, erotic, pornographic
                        contents or meanings, or phrases on the [Tiger777] gaming platform that violate good social morals
                        and affect the gaming experience of other players;
                      </p>
                      <p class="txt-indent">
                        (2) Where the player uses phrases in the game to pose as
                        official personnel on the [Tiger777] gaming
                        platform or claims to be an official representative or
                        gamemaster;
                      </p>
                      <p class="txt-indent">
                        (3) Where the player deliberately obstructs the actions
                        of official personnel or insults or deceives official
                        personnel;
                      </p>
                      <p class="txt-indent">
                        (4) Where the player uses [Tiger777] gaming
                        platform to disseminate or publish comments about the
                        Company that have not been verified or have no factual
                        basis (including information that has been publicly
                        disclosed or not public disclosed (malicious use of text
                        or image format) or mere speculations by the player,
                        etc.); Where the player attempts to affect the gaming
                        experience of other players; where such actions causes
                        damage to the Company, the Company shall retain all
                        rights for legal prosecution for such violations;
                      </p>
                      <p class="txt-indent">
                        (5) Where the player spams public channels or speaks
                        repeatedly on public channels on the [Tiger777]
                        gaming platform and prevents players from viewing
                        channels normally; examples include continuous posts
                        with meaningless content (e.g. English or numerals,
                        garbled code, symbols, emojis, expressions, commands, or
                        system default text) or posting text with the same cycle
                        at a certain frequency, it shall constitute spamming (a
                        channel with more than two persons shall be deemed as an
                        open channel);
                      </p>
                      <p class="txt-indent">
                        (6) Where the player processes personal disputes or
                        where players slander each other on open channels and
                        attempt to disseminate information and cause other
                        players to join the dispute, thereby affecting the
                        gaming experience of other players;
                      </p>
                      <p class="txt-indent">
                        (7) Where the player violates regulations on the
                        protection of personal private information on the
                        [Tiger777] gaming platform; examples include:
                        disclosing membership information of other Tiger777 players;
                      </p>
                      <p class="txt-indent">
                        (8) Where the player uses the [Tiger777] gaming
                        platform for commercial advertisement in terms of
                        actions or providing content (e.g. selling products
                        unrelated to the game or advertisement for transactions
                        of physical products);
                      </p>
                      <p class="txt-indent">
                        (9) Where the player uses the [Tiger777] gaming
                        platform for selling drugs, guns, or other illegal items
                        or publishing illegal ads for prostitution or
                        pornography;
                      </p>
                      <p class="txt-indent">
                        (10) Where the player uses the [Tiger777] gaming
                        platform to disseminate information that involves
                        criminal activities or incites crimes;
                      </p>
                      <p class="txt-indent">
                        (11) Where the player uses the [Tiger777] gaming
                        platform to disseminate or publish comments that are
                        deemed by the laws as illegal or those that incite
                        crimes (e.g. using gangster terms for drug trafficking
                        such as hard, soft, boy, girl, sales of candy, and other
                        synonyms).
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Inappropriate names (including names used in the game
                        and nicknames on the website platform)
                      </div>
                      <p>
                        The names of avatars and channels are entered by the
                        player when they are created. Once the names of avatars
                        and channels are entered, they cannot be changed. The
                        player should exercise proper care for naming their
                        cherished avatars and channels. In the event that the
                        name of a player's avatar or channel contains an
                        inappropriate name that violates the regulations, the
                        avatar or channel shall be blocked, deleted, dissolved,
                        or changed without prior notice. Under the following
                        conditions, the Company has the right to implement
                        direct penalties without prior notice. However, if an
                        item is not listed in the following description of
                        restrictions, the item shall be processed in accordance
                        with social morals in a just manner.
                      </p>
                      <p class="txt-indent">
                        (1) The user may not use names and images the website
                        that are similar to the official personnel, adopt a name
                        of the Company's related organization, or use names that
                        may be confused with staff members including using
                        special characters that may not be distinguished by
                        regular players to separate the aforementioned
                        combinations. Examples include: customer service,
                        Tiger777, and GM shall be restricted to official
                        personnel of the Company.
                      </p>
                      <p class="txt-indent">
                        (2) Nicknames or images with allusive, obscene, rude,
                        insulting, slandering, personal attacks, threatening, or
                        provocative against the Tiger777 game company or
                        its employees. Examples include: " Tiger777
                        sucks", "idiot customer service", etc.
                      </p>
                      <p class="txt-indent">
                        (3) A name/image of an avatar in the game that contains
                        racial or gender discrimination, profanity, lewd,
                        erotic, pornographic contents or meanings, or phrases
                        that violate good social morals. Examples include: "Who
                        wants a one night stand" or "prostitute".
                      </p>
                      <p class="txt-indent">
                        (4) A name/image of an avatar in the game that is deemed
                        by the laws as illegal or those that incite crimes.
                        Examples include: hard, soft, boy, girl, sales of candy,
                        and other synonyms for drug trafficking.
                      </p>
                      <p>
                        Note: Text (full/half-size text, uppercase/lowercase
                        text, and homonyms are all restricted).
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Using bugs to play the game (including for advertising
                        and dissemination of information)
                      </div>
                      <p>
                        The player may not use unnatural or unintentional errors
                        or bugs in the game, methods or means that violate the
                        principles of fairness and reasonableness for gaming
                        (unpublished bugs shall be determined by the Company),
                        or loopholes in the game to increase the load of the
                        server, crash the server, create benefits for the
                        player, use others, and cause imbalances in the game.
                        The player shall immediately report to the gamemaster if
                        the player discovers a bug in the game. If the player
                        uses a bug or loophole in the game, imperfection in the
                        rules, or any other irregular method to obtain
                        exponentially unlawful interest, cause imbalances in the
                        game or other losses, affect the rights and interest of
                        other players, and cause effects beyond the scope of the
                        original design, all information of all related parties
                        shall be processed as follows after verification:
                        <br />The Company shall implement a [temporary freeze]
                        on the game accounts and confiscate the illegal interest
                        directly and indirectly obtained by the player through
                        the bug. However, where the conditions are severe and
                        the illegal interest cannot be correctly confiscated or
                        where the illegal interest may cause other irreversible
                        conditions, the Company shall issue a notice in written
                        format or email and suspend the player's usage rights of
                        the game till the data in the user account is corrected.
                        The account shall be restored based on the backup data
                        under normal conditions.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Malicious alteration of the game program
                      </div>
                      <p>
                        The user may not invade, intercept, or damage the game
                        program, modify or compile the game, modify the game
                        program memory code, remove the encryption of the game
                        program, or use any method to alter, duplicate, or
                        change the packages and values, etc. to change the
                        contents and data of the game program to obtain
                        exponentially unlawful interest. If such actions cause
                        imbalances in the game or other losses, affect the
                        rights and interest of other players, and cause effects
                        beyond the scope of the original design, all information
                        of all related parties shall be processed as follows
                        after verification:<br />Once such actions are verified
                        by the Company, the Company shall confiscate the illegal
                        interests directly or indirectly obtained through the
                        player's malicious alteration of the game program. The
                        Company has the right to immediately terminate the
                        contract with the player and confiscate all game coins
                        and items the player has illegally obtained without
                        notice. The Company shall also retain the right to take
                        legal actions (including all related accounts).
                      </p>
                    </section>
                    <section>
                      <div class="title">Reporting "hackers" and "frauds"</div>
                      <p>
                        To implement and maintain the fairness in the game and
                        assist the Company in cracking down on players suspected
                        of using "hacking" and "fraud", you agree that the
                        Tiger777 program may obtain certain information
                        including related information from your computer and its
                        components including but not limited to your keyboard,
                        mouse, graphics card, network card, CPU, RAM, and IP
                        address without prior notice. Such information shall
                        include whether there are "unauthorized third-party
                        programs" that operate simultaneously with Tiger777.
                      </p>
                      <p class="txt-deep-blue">
                        Note: The aforementioned information shall only be used
                        to protect players, maintain the quality of the game,
                        uncover players who conduct malicious, inappropriate, or
                        legal actions, and trace data.
                      </p>
                      <p class="txt-deep-blue">
                        Note: The "unauthorized third-party programs" refers to
                        programs used without the approval of the Company.
                        Others include without limitation those that can be
                        independently determined by the Company as (1) able to
                        facilitate or provide any fraud; (2) allow the game
                        client program to modify or invade the game interface
                        and environment; (3) third-party software that
                        intercepts, uncovers, or uses other methods to collect
                        information from the game.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        We need you to supervise and maintain a high-quality and
                        happy gaming environment. If you discover any violation
                        prohibited by the Company, we need you to help us and
                        report the violation immediately.
                      </div>
                      <p class="txt-indent">
                        (1) Direct reports<br />To eliminate unfairness in the
                        game, the gamemaster conducts a daily security
                        inspection on the scores of the game and amounts of
                        related game assets on the previous day. All members
                        suspected of cheating and those with irregular increase
                        in the amount of related game assets shall be listed in
                        the evaluation list. Once verified, the Company may
                        immediately terminate the contract with a notice to the
                        service user.
                      </p>
                      <p class="txt-indent">
                        (2) Report/complaint<br />A player may file a report or
                        complaint if the player discovers a suspected violation
                        of the Game Rules.<br />The Company shall immediately
                        conduct investigations after receiving notice. Once
                        verified, the Company may notify the service user and
                        publish the violation on the Tiger777 game
                        website.
                      </p>
                      <ol>
                        <li>
                          To file a report or complaint, please include:
                          <ul>
                            <li>
                              Your nickname (for complaints, please also include
                              the member nickname for your complaint)
                            </li>
                            <li>Reason</li>
                            <li>
                              Time and place of occurrence (Game zone or area or
                              activity name)
                            </li>
                            <li>
                              The full image(s) taken or other information that
                              can be used as evidence. Attention: Complaints
                              shall be accepted within one month of the month of
                              occurrence. Overdue complaints shall not be
                              accepted.
                            </li>
                          </ul>
                        </li>
                        <li>
                          Methods for filing a report or complaint:
                          <ul>
                            <li>
                              Tiger777 Customer Service Mailbox
                              (Applicable for cases where images are provided)
                            </li>
                            <li>The "Feedback" function in the game.</li>
                          </ul>
                        </li>
                      </ol>
                      <p class="txt-indent">
                        (3) Appeals against penalties<br />The player's rights
                        shall be the contents under "right of appeal" in the
                        "User Contract" signed by the player for the membership
                        application. Please report an issue in the game or send
                        a letter to
                        <a href='"mailto:admin@tiger777.com"'
                          >admin@tiger777.com</a
                        >，We shall contact the member as quickly as possible
                        after receiving the message or email.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Related regulations on virtual items
                      </div>
                      <p class="txt-indent">
                        (1) The game allows user accounts to use points to
                        exchange for virtual items or game coins. The user's
                        approval is required and the credit points will lose all
                        substantive value after the exchange procedures are
                        completed.
                      </p>
                      <p class="txt-indent">
                        (2) The game allows user accounts to use points to
                        exchange for virtual items or game coins. Tiger777 only provides a medium for one-way exchange and
                        cannot convert the items into actual points. If other
                        transactions conducted in private with user accounts
                        cause losses to individuals, the Company shall not be
                        responsible for compensation or bear other legal
                        liabilities.
                      </p>
                      <p class="txt-indent">
                        (3) The virtual items given in the game are only
                        distributed for special events and individual accounts.
                        User accounts may not request the Company to concentrate
                        or transfer all accounts and individual virtual items of
                        a user's true identity to a specific account.
                      </p>
                      <p class="txt-indent">
                        (4) Tiger777 provides functions for exchanging
                        virtual game coins and items but it only provides
                        conversion mechanisms for regular transactions and
                        strictly prohibits sales or purchase of game coins.
                        Users may not request the Company to cancel converted
                        virtual items or game coins in private based on the
                        results of private transactions.
                      </p>
                      <p class="txt-indent">
                        (5) The Company shall not be involved in disputes
                        derived from transactions or acts of transactions of
                        items and characters in the game and other
                        electromagnetic recording between user accounts and
                        other individuals in real life.
                      </p>
                      <p class="txt-indent">
                        (6) The Company shall not be liable for compensation of
                        any damage of the user's game data caused by natural
                        disasters, force majeure factors, or other non-human
                        factors.
                      </p>
                      <p class="txt-indent">
                        (7) Once the value in the point cards purchased by the
                        user is stored, the user shall be deemed as having
                        confirmed the purchase of various services in the
                        system. Game points stored in a user account may not be
                        transferred to a third party.
                      </p>
                      <p class="txt-indent">
                        (8) Where the user discovers illegal use or any
                        irregular damage in the secure use of its game account,
                        it shall notify the Company immediately. The Company
                        shall not be responsible for processing related disputes
                        or compensation for losses caused by illegal use of the
                        account, password, or game data by others for reasons
                        attributable to the user (the user is requested to claim
                        compensation from the illegal user through judicial
                        procedures).
                      </p>
                      <p class="txt-indent">
                        (9) Where an update of the game causes incorrect
                        versions of the game for certain users or where a user
                        cannot continue the game due to personal factors of user
                        accounts (where not all user accounts can log into the
                        Tiger777 game server at the same time), the
                        Company shall endeavor to provide consulting services to
                        the best of its abilities and help user accounts
                        continue the use of the Company's services. However, the
                        Company shall not be responsible for losses due to the
                        inability to access the game that are caused by issues
                        of the user's personal computer or failure or
                        malfunction of the software/hardware equipment of the
                        user, other suppliers, or related telecom operators.
                      </p>
                      <p class="txt-indent">
                        (10) Except for events organized by Tiger777 and
                        issues in the game program itself, the Company shall not
                        be involved in results of any private transactions
                        between user accounts.
                      </p>
                      <p class="txt-indent">
                        (11) When player purchased our APP or application
                        Package (Includes game points, game coins or other game
                        merchandise and package). Within 7 days, players can
                        provide the purchased receipt and refund it from the
                        place they purchased. If the purchased place won’t
                        refund it, you can also contact our company for a
                        refund. If player purchased/ downloaded our APP/ or
                        application package from the platform, then they should
                        follow the platform’s rule for a refund.
                      </p>
                    </section>
                    <section>
                      <div class="title">Contest regulations</div>
                      <p>
                        In events organized by the Company that involve prizes
                        and contests, regardless of whether they are organized
                        on a regular or irregular basis, once a member is
                        verified by the gamemaster to have conducted actions
                        expressly prohibited in the Game Rules in the contest
                        events or conduct other irregular gaming actions that
                        are unspecified but affect the fairness of the game, the
                        Company shall strictly enforce the Game Rules and
                        disqualify the member from continuing participation and
                        cancel award-winning qualifications.
                      </p>
                      <p>
                        Terms and conditions that are not established within the
                        scope of the Regulations shall be specified separately
                        in related webpages of the contests and they shall be
                        effected and implemented on the date of announcement.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Guidelines and management of other special events
                      </div>
                      <p>
                        The Company shall provide guidelines and regulations for
                        functions and special events organized for functional
                        requirements or different themes. If the member
                        disagrees with the new service content or the methods of
                        contest events, please do not use the function or
                        participate in the contest event.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Items not accepted by the Company's customer service and
                        gamemaster (GM)
                      </div>
                      <p class="txt-indent">
                        (1) Questions regarding the collection of virtual or
                        physical gifts and prizes raised after the prescribed
                        deadline specified in related regulations for specific
                        events or contests.
                      </p>
                      <p class="txt-indent">
                        (2) Requests for the Company to restore, transfer, or
                        reassign point allocation settings after the point cards
                        are used and the value is stored.
                      </p>
                      <p class="txt-indent">
                        (3) The Company prohibits members from using Tiger777 member services for any commercial activity. The
                        members may not request the Company to cancel or restore
                        completed virtual coin exchanges for any private
                        transaction based on the results thereof or disputes.
                        However, the Company shall process members' violation of
                        the User Contract in accordance with the Contract.
                      </p>
                      <p class="txt-indent">
                        (4) Except for the use of unfair or unreasonable methods
                        or means for gaming, the Company shall not intervene in
                        other special gaming rules established between members
                        for the game.
                      </p>
                      <p class="txt-indent">
                        (5) The Company shall not be involved in personal
                        grievances or disputes between members. However, members
                        may not post comments on public channels (that contain
                        low-class, obscene, rude, insulting, slandering,
                        personal attacks, threatening, provocative, racial or
                        gender discrimination, profanity, lewd, erotic,
                        pornographic contents or meanings, or phrases that
                        violate good social morals and affect the gaming
                        experience of other players). Violators shall be
                        [banned]
                      </p>
                      <p class="txt-indent">
                        (6) To protect the Company's internal confidential
                        information and the Company's operations for maintaining
                        high-quality services and protecting the interests of
                        all players, we shall not accept questions regarding the
                        internal configuration of the Company, system, and game,
                        personal questions regarding GMs or other players, and
                        other questions unrelated to the game. Players are
                        requested to cooperate.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Conditions for which the Company does not provide
                        compensation for losses
                      </div>
                      <p class="txt-indent">
                        (1) Where a member's Internet connection is interrupted
                        due to an interruption, automatic logout, or computer
                        programming error in the network of its Internet service
                        provider that causes losses in gaming data such as
                        records and points;
                      </p>
                      <p class="txt-indent">
                        (1) Where a member's Internet connection is interrupted
                        due to an interruption, automatic logout, or computer
                        programming error in the network of its Internet service
                        provider that causes losses in gaming data such as
                        records and points;
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Related risks and liabilities to be borne solely by the
                        member
                      </div>
                      <p class="txt-indent">
                        (1) The Company's member services may be subject to the
                        following conditions:
                      </p>
                      <ol>
                        <li>Necessary maintenance for website equipment.</li>
                        <li>
                          Failure or malfunction of the software/hardware
                          equipment of the user, other suppliers, or related
                          telecom operators.
                        </li>
                        <li>
                          Interruption, temporary unavailability, delay, errors
                          in data transmission or storage caused by negligence
                          in human operations.
                        </li>
                        <li>
                          Third-party invasion of the system that results in
                          alteration, forgery, or falsification of data.
                        </li>
                        <li>
                          War, natural disasters, other force majeure factors,
                          or other non-human factors that prevent the Company's
                          equipment from normal operations.
                        </li>
                      </ol>
                      <p>
                        Under the aforementioned conditions, the Company shall
                        not guarantee the accuracy, integrity, security,
                        reliability, appropriateness, timeliness, stability, and
                        free of disconnections or errors in its services. The
                        member is required to understand all risks and all
                        possible damage that may be caused by the use of the
                        service and the member may not seek any compensation or
                        reparation. The member also agrees to the use of emails,
                        files, and other data transmitted by the member as
                        backup data. The Company shall not be liable for the
                        loss of emails, files, and other data in the
                        transmission process.
                      </p>
                      <p class="txt-indent">
                        (2) The following restrictions shall apply to
                        information uploaded by the member (such as discussions
                        and instructions) to the Company's website:
                      </p>
                      <ol>
                        <li>
                          The member is not allowed to infringe on the
                          intellectual property rights or copyright of any third
                          party or the rights of the public or individuals.
                        </li>
                        <li>
                          The member is not allowed to violate any laws or moral
                          standards.
                        </li>
                        <li>
                          The member is not allowed to slander others or publish
                          contents that involve sexual harassment, racial
                          discrimination, or negative effects on children.
                        </li>
                      </ol>
                      <p>
                        The above items are personal actions of members and the
                        member shall be required to bear related legal
                        responsibilities when they occur.
                      </p>
                      <p class="txt-indent">
                        (3) Trade or purchase of illegal value storage serial
                        numbers: <br />It is not safe to purchase game serial
                        numbers from unknown sources online. Members may not
                        conduct transactions in game points with others in
                        private. The Company shall implement a temporary freeze
                        on a member that uses game value storage serial numbers
                        purchased through illegal use of online payment
                        mechanisms (e.g. payment through credit cards and
                        telecommunication accounts). The member's rights shall
                        only be restored after the member completes the payment.
                        The related legal liabilities for illegal use of online
                        payment mechanisms shall also be borne by the member who
                        uses the account. The Company shall also cooperate with
                        judicial agencies in investigations.
                      </p>
                      <p class="txt-indent">
                        (4) The Company prohibits members from using Tiger777 member services for any commercial activity. The
                        Company shall bear no responsibility for the results or
                        disputes in any personal transaction between members.
                      </p>
                      <p class="txt-indent">
                        (5) Members are obligated to safely store their accounts
                        and passwords on Tiger777 and they may not
                        disclose, loan, transfer or provide them to a third
                        party. Where the member discovers illegal use or any
                        irregular damage in the secure use of its account, it
                        shall notify the Company immediately for the Company to
                        take related response measures. However, the measures
                        taken by the Company shall not be construed as the
                        Company's explicit or implicit guarantee or
                        responsibility for compensation.<br />The Company shall
                        not be liable for compensation for illegal use of your
                        account and password. However, you may request a game
                        log and report to the police unit in the jurisdiction
                        <span class="txt-deep-blue"
                          >where such violation occurred
                        </span>
                        and file a suit in accordance with legal procedures. The
                        Company shall provide related information in accordance
                        with laws and assist in the investigation of the case.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Statement of rights for amendments of the terms
                      </div>
                      <p>
                        The Company reserves the right to add, alter, or delete
                        all or part of the terms in the Management Regulations
                        to respond to changes in laws or necessities for provide
                        gaming services. The amendments shall be announced and
                        the Company shall not issue individual notices. The
                        player not seek any compensation or reparation and shall
                        be bound by the amended terms after they are announced
                        on the Company's website. By continuing to use the
                        Company's services after the announcements, the player
                        shall be deemed as having agreed to the amended terms.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Assistance in reporting online crimes
                      </div>
                      <p>
                        According to the Personal Information Protection Act,
                        the Company may not be involved in disputes, provide
                        assistance, or implement measures before the government
                        or judicial authorities intervene in the investigation
                        and issues an official letter to the Company to
                        cooperate in the procedures. In the event of suspected
                        fraud or theft of players' accounts, you must ask the
                        police unit in the jurisdiction
                        <span class="txt-deep-blue"
                          >where such violation occurred</span
                        >
                        for assistance. Judicial authorities currently request
                        the provision of game logs, certification of ownership
                        of accounts, and other necessary information for the
                        online crime report procedures when they investigate
                        theft or suspected fraud of players in online games.
                      </p>
                      <p>
                        The Company is prevented by law to actively provide you
                        with related information for filing suits against online
                        crimes. As most actions are conducted by deceiving
                        players to complete transactions to confirm the item and
                        payment transaction, it is difficult for the Company to
                        process disputes that involve different claims from two
                        parties based on its records. The Company also cannot
                        enforce the forceful retrieval of property based on
                        unilateral claims or provide a party with the other
                        party's information. Therefore, the Company cannot
                        render judgments on such issues and players are advised
                        to pay attention to such transactions.
                      </p>
                      <p>
                        In the event of an unfortunate case of fraud that
                        involves the player and legal disputes derived from such
                        actions, the victim is advised to contact customer
                        service and file an application in accordance with
                        procedures to obtain the information necessary for
                        filing a police report. The victim should report to a
                        nearby county or city police department. When the
                        Company receives an official letter issued by a related
                        authority to request assistance, the Company shall
                        provide the judicial authority with all data required
                        for use as evidence. The Company shall assist the police
                        in investigations and bring unlawful players to justice
                        in the real world.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Instructions for players' application of game logs
                      </div>
                      <p>
                        A player whose account is stolen or subject to fraud in
                        the game and wishes to call the police shall be required
                        to obtain game logs from the Company before the police
                        unit
                        <span class="txt-deep-blue"
                          >in the jurisdiction where such violation
                          occurred</span
                        >
                        would accept the report. The procedures for reporting a
                        case are as follows:
                      </p>
                      <p class="txt-indent">
                        (1) Please proceed to the official website → [Customer
                        Service] → [Feedback] →[Message] → and specify the
                        reason for your application of the game log.
                      </p>
                      <p class="txt-indent">
                        (2) After the Company receives your message and verifies
                        the identity information and assesses the content, it
                        shall issue a notice for payment. You must pay the
                        required service fees for the application of the game
                        log to the bank account provided by the customer service
                        center. After you complete the payment and completes the
                        confirmation with the customer service specialist, your
                        application shall be transferred to the related
                        department which shall provide you with the game log.
                        The Company shall mail the "game log" and "account
                        certification statement" via registered mail or email
                        within seven working days (excluding holidays). The
                        customer service specialist shall notify you based on
                        your contact method after the information is mailed.
                      </p>
                      <p class="txt-indent">
                        (3) Please use the "game log" and "account certification
                        statement" to report to the police unit
                        <span class="txt-deep-blue"
                          >in the jurisdiction where such violation
                          occurred</span
                        >
                        and complete report procedures, the Company shall
                        provide detailed information based on the official
                        letter from the police and cooperate with the
                        prosecution and investigation. Please confirm the case
                        progress with the police investigation unit after you
                        complete case report procedures.
                      </p>
                      <p class="txt-indent">
                        (4) Warning to players! If a complaint filed by the
                        player involves the illegal use of the player's account
                        or fraud, disputes, or other computer crimes, the
                        Company is prevented by law to be involved in disputes,
                        provide assistance, or implement measures before the
                        government or judicial authorities intervene in the
                        investigation and issues an official letter to the
                        Company to cooperate in the procedures.
                      </p>
                      <p class="txt-indent">
                        (5) Based on the Company's obligation for safeguarding
                        electromagnetic recording, the Company can only provide
                        up to one month of records for each game log. The
                        records provided for account applications only includes
                        the three months preceding the application date.<span
                          class="txt-deep-blue"
                        >
                          (Note: If you wish to apply for game records for the
                          past three months, you must file three game log
                          applications.)</span
                        >Please begin application procedures in advance. Please
                        note that applications filed past the acceptance date
                        will not be processed.
                      </p>
                      <p class="txt-indent">
                        (6) Before Applying for the game log, please confirm
                        your person information registered in the Company's
                        member database. The Company only provides account
                        information in the member database to the original
                        registrant and no information shall be provided to
                        individuals that do not own the accounts.
                      </p>
                      <p class="txt-indent">
                        (7) The Company only accepts applications for game logs
                        of one account in each [game log] application. If you
                        wish to apply for game logs of more than one account,
                        please fill out the application form to apply.
                      </p>
                    </section>
                    <section>
                      <div class="title">Examples of cases</div>
                      <p>
                        The following are common cases that occur in online
                        games. Please pay attention to such cases to protect
                        your rights and those of other players:
                      </p>
                      <p class="txt-indent">
                        (1) Hsiao-Ming saw another player broadcasting on public
                        channels to sell massive amounts of game coins at low
                        cost. Hsiao-Ming took the opportunity and sent a private
                        message to the player for a purchase. Hsiao-Ming later
                        followed the other party's instructions and purchased a
                        game point card. He informed the other party of the
                        serial number of the game point card. The other party
                        unexpected disappeared. Hsiao-Ming did not receive the
                        agreed game coins and the serial number of the point
                        card was also used. He then discovered that he was
                        defrauded.
                        <br />
                        <span class="txt-deep-blue"
                          >※Reminder: Online fraud occurs often. To prevent
                          losses, do not conduct transactions with players you
                          do not know.</span
                        >
                      </p>
                      <p class="txt-indent">
                        (2) Hsiao-Wei and Ah-Liang are good friends and they
                        play online games together. One day, Hsiao-Wei went
                        abroad and gave his account and password to Ah-Liang and
                        instructed Ah-Liang to help him participate in an event
                        organized in the game when he was abroad. Ah-Liang was
                        later lucky enough to win an event reward for Hsiao-Wei
                        but he became greedy and transferred the virtual item to
                        his own account for his personal use.
                        <br />
                        <span class="txt-deep-blue"
                          >※Reminder: To protect your interest and avoid
                          difficulties in claiming compensation, do not tell
                          anyone your account and password or give them to
                          anyone for use.</span
                        >
                      </p>
                      <p class="txt-indent">
                        (3) Hsiao-Chun and Hsiao-Kao are roommates in a
                        university. One day, Hsiao-Chun passes by Hsiao-Kao's
                        desk and saw a note under the keyboard that contained
                        the account and password for the game. He recalled how
                        Hsiao-Kao has always boasted how great his game
                        character is and became consumed by curiosity. He
                        secretly logged into Hsiao-Kao's account to inspect the
                        character's equipment and attributes but did not
                        transfer anything or perform any action.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        Statement of rights for amendments of the terms
                      </div>
                      <p>
                        The Company reserves the right to add, alter, or delete
                        all or part of the terms in the Management Regulations
                        to respond to changes in laws or necessities for provide
                        gaming services. The amendments shall be announced and
                        the Company shall not issue individual notices. The
                        player not seek any compensation or reparation and shall
                        be bound by the amended terms after they are announced
                        on the Company's website. By continuing to use the
                        Company's services after the announcements, the player
                        shall be deemed as having agreed to the amended terms.
                      </p>
                    </section>
                  </div>
                  <div
                    id="policy-wrap"
                   v-show="this.isShowEn == 3 ? true:false"
                    class="contract-wrap"
                    style=""
                  >
                    <section>
                      <div class="title">※About your privacy in JINJINJIN</div>
                      <p>
                        ARC PLAY LTD CO., Ltd. (JINJINJIN) values your privacy
                        on the internet. In order to provide services with this
                        product, we would like to provide this privacy policy to
                        inform you how we collect and manage your personal
                        information and the rights you deserve. Please take a
                        moment reading it. If you do not agree to any of these
                        terms, please do not use the services and events. Your
                        contact is welcomed to leave some feedback and
                        suggestions.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Application</div>
                      <p>
                        I. Our privacy policy applies to: <br /><span
                          >How this product manages any identification collected
                          as user using our services and how we share
                          identification to our business partners.</span
                        >
                      </p>
                      <p>
                        II. Our privacy policy does not apply to: <br /><span
                          >Any other company or individual which this product
                          does not corporate with or hire.</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">※How we collect your information</div>
                      <p>
                        I. Information you give us: <br /><span
                          >Before playing, using services, browsing website or
                          applying for event of JINJINJIN, we will ask you to
                          register and fill out personal information.</span
                        >
                      </p>
                      <p>
                        II. Information we get from your use of our services:
                        <br /><span
                          >JINJINJIN may automatically collect log information,
                          IP address, cookies and data caches.</span
                        >
                      </p>
                    </section>
                    <section>
                      <div class="title">※Collected Information</div>
                      <p>
                        The personal data collected by the company will include
                        the following:
                      </p>
                      <p>
                        I. It is necessary to collect this information, the
                        collected information is mainly used for customer
                        service, marketing and internal statistical analysis.
                      </p>
                      <ul>
                        <li>Login Time</li>
                        <li>IP Login Location</li>
                        <li>Device model and code</li>
                        <li>Device operating system and version</li>
                        <li>
                          If you are using Facebook account login, will collect
                          Facebook ID
                        </li>
                      </ul>
                      <p>
                        II. Optional information, the information provided is
                        evidence of whether it is proof of the account holder.
                      </p>
                      <ul>
                        <li>
                          Identify individuals: such as name, address, phone
                          number, photo, email, etc.
                        </li>
                        <li>
                          The identifier in the government data: such as the ID
                          card number, passport number, etc.
                        </li>
                        <li>
                          Personal description: such as age, gender, date of
                          birth, etc.
                        </li>
                        <li>License: such as a driver's license.</li>
                        <li>
                          Financial identification: such as the number of the
                          bank account.
                        </li>
                        <li>
                          Contact information: such as mobile phone number,
                          address, etc.
                        </li>
                      </ul>
                    </section>
                    <section>
                      <div class="title">※Use of Personal Data</div>
                      <p>I. Reveal, Rent or Sell:</p>
                      <p class="txt-indent">
                        (1) JINJINJIN use your information only on specific
                        purpose. Your personal information will not be revealed,
                        rented or sold to third party unless you agree to. In
                        addition, we will not use your information on any other
                        purpose without informing you in advance. To comply with
                        the above, we may share information about you with
                        others in the following situations or other
                        circumstances described in this Privacy Policy:
                        <br /><span
                          >Share information about you with our employees,
                          affiliates, related companies, sellers, consultants,
                          and third-party service providers who work on behalf
                          of the company (including, for example, payment
                          dealer, web hosting services and or services
                          supplier).</span
                        >
                        <br /><span
                          >Respond to legal proceedings or requests for
                          information (including, for example, government or
                          regulatory agencies, law enforcement agencies or
                          courts) in compliance with applicable laws, rules or
                          regulations or where disclosure is required.</span
                        >
                        <br /><span>Subject to your consent or direction.</span>
                      </p>
                      <p class="txt-indent">
                        (2) Regarding to the content above, JINJINJIN will not
                        reveal your personal information without your agreement.
                        However, we are not able to guarantee under the
                        conditions below: <br /><span
                          >When your behavior violates the terms of service or
                          may influence the rights of JINJINJIN to damage any
                          individual, we believe that it is required to reveal
                          your personal information for recognition, contact or
                          legal pursue.</span
                        >
                        <br /><span
                          >Due to public safety, if government organization asks
                          JINJINJIN to reveal certain personal information,
                          JINJINJIN will follow legal procedure to
                          corporate.</span
                        >
                        <br /><span
                          >JINJINJIN believes it is required to reveal your
                          personal information for legal purpose based on
                          goodwill.</span
                        >
                      </p>
                      <p>II. Before using our services:</p>
                      <p>
                        JINJINJIN will offer full description of our services
                        and how we use your information. You may decide to agree
                        or disagree before using our services. If it is
                        necessary to offer your information to third party,
                        JINJINJIN will request for non-disclosure agreement on
                        your information and make sure the third party execute
                        certainly.
                      </p>
                      <p>III. Data collection purpose and use:</p>
                      <p class="txt-indent">
                        (1) The purpose of data collection is to conduct
                        customer management, membership management, membership
                        contact, customer satisfaction survey and marketing and
                        internal statistical investigation and analysis. The
                        collection method will firstly display the content of
                        the relevant collection terms when the player first logs
                        in to the game, after the player confirms the consent it
                        will start collecting. The second is to collect personal
                        data by means of members filling out electronic or
                        written service forms.
                      </p>
                      <p class="txt-indent">
                        (2) This product is acceptable for others to provide
                        analytical services and to provide advertising within
                        our services. These companies can use technology to
                        automatically collect information about your device and
                        the use of our services, including the IP address,
                        device identification number, and the length of time and
                        clicks on the pages of our services. This product and
                        others may use this information to maintain, enhance and
                        analyze our service features, and to provide
                        advertisements that may be of interest or relevance to
                        the content of the webpage that may be of interest to
                        you. The use of your materials by these third parties
                        will be subject to their respective privacy policies and
                        we will not control or be responsible for third party
                        privacy practices.
                      </p>
                      <p class="txt-indent">
                        (3) With your prior consent, certain services of the
                        company will participate in game and analysis
                        information combined with games from this game and other
                        third-party sources to analyze game and monetization
                        trends, create profiles for each category of players, as
                        well as new games and services, and also perform other
                        analysis services. The company also uses some of the
                        information we collect from our games to advertise
                        outside the game. This includes creating a player-type
                        profile by combining your profile with our advertising
                        partners, providing this information to our advertising
                        agencies and advertising platforms to conduct our
                        targeted advertising outside of this game, as well as
                        other ad analysis and as a performance standard.
                      </p>
                    </section>
                    <section>
                      <div class="title">
                        ※Edit or delete personal information
                      </div>
                      <p>
                        When playing games of JINJINJIN, feel free to contact us
                        for assistance in editing your personal information
                        (address, phone number, email…etc). The information that
                        you may edit does not include the records of using our
                        services. Moreover, although your account has been
                        banned, your records of using our services will still be
                        reserved.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Links</div>
                      <p>
                        When using our services, other site links may be
                        activated. For instance, while using the services from
                        the third party or reading an information providing by
                        JINJINJIN, there might be other site links. JINJINJIN
                        cannot guarantee your privacy on other sites. Therefore,
                        it is recommended to read privacy policy on other sites
                        before leaving JINJINJIN games.
                      </p>
                    </section>
                    <section>
                      <div class="title">※About Cookies</div>
                      <p>
                        Cookie is a small file of letters and numbers downloaded
                        on to your computer when you access certain websites.
                        When you use your browser to visit a website, cookies
                        will keep track of your movements, habits or selection
                        within the site and IP address. Websites with membership
                        usually use cookies to store user ID, password, personal
                        websites and browsing history. With all this data,
                        websites can build a list of shopping and browsing of
                        every user but they can not modify any content of
                        visitor’s computer. Please notice that most of browsers
                        automatically accept cookies. If you are not willing to
                        store your data on the website you browsed, you may
                        change the setting about cookies on most of browsers.
                        While disabling cookies, you can still using JINJINJIN
                        services. If you are a member of JINJINJIN, enabling
                        cookies will bring you much more convenience. Therefore,
                        while disabling cookies, we are not able to recognize
                        you on your every visit and bring you more services.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Self-protection</div>
                      <p>
                        With all the protection above, we would like to remind
                        you of keeping your account, password and any other
                        personal information safe. Please do not reveal to any
                        individual. After completing any online transaction or
                        services on other sites, make sure you log out. If you
                        share the computer with someone else or use public
                        computer, please close browsing windows after using to
                        avoid others loading your personal information or
                        emails.
                      </p>
                    </section>
                    <section>
                      <div class="title">※Changes</div>
                      <p>
                        JINJINJIN Privacy Policy may change from time to time.
                        We will post revised privacy policy on official website
                        page of each product and welcome your visiting.
                      </p>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          
    </div>
    <Footer></Footer>
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      isShow:0,
      isShowEn:0,
      isEn: true,
      isZh: false,
      isbuyIconEn: true,
      isbuyIconZh: false,
      isPrivacyZh: false,
      isPrivacyEn: false,
      isRulesZh: false,
      isRulesEn: false,
      isContractZh: false,
      isContractEn: false,
      isPersonalPolicyZh: true,
      isPersonalPolicyEn: true,
      active: 0,
      visible: false,
      isLoginShow: true,
    };
  },
  created() {
    this.changeIcon();
  },
  mounted() {},
  computed: {
    ...mapState({
      hasLogin(state) {
        return state.hasLogin;
      },
      isApp(state) {
        return state.isApp;
      },
    }),
    amtList() {
      return [
        {
          title: this.$t("agreement.protection"),
        },
        {
          title: this.$t("agreement.userAmt"),
        },
        {
          title: this.$t("agreement.gameAmt"),
        },
        {
          title: this.$t("agreement.policy"),
        },
      ];
    },
  },
  methods: {
    changColor(index) {
      this.active = index;
      let lang = localStorage.getItem("lang");
      //中文时做点击切换
      if (lang == "zh") {
        if (index == 0) {
          this.isShow = 0
        }
        if (index == 1) {
          this.isShow = 1
        
        }
        if (index == 2) {
          this.isShow = 2
       
        }
        if (index == 3) {
        this.isShow = 3
         
        }
      }
      //英文时做点击切换
      if (lang == "en") {
       
        if (index == 0) {
          this.isShowEn=0
        }
        if (index == 1) {
          this.isShowEn=1
        }
        if (index == 2) {
          this.isShowEn=2
        }
        if (index == 3) {
          this.isShowEn=3
        }
      }
    },
    changeIcon() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        this.isbuyIconEn = true;
        this.isbuyIconZh = false;
        this.isEn = true;
        this.isZh = false;
      }
      if (lang == "zh") {
        this.isbuyIconEn = false;
        this.isbuyIconZh = true;
        this.isEn = false;
        this.isZh = true;
      }
    },
    goDown(){
     this.$router.push('/Down')
    }
  },
};
</script>
<style lang="less" scoped="">
.content {
  width: 100%;
  background: #ad0000 url("../assets/index/bg-pc-head.jpg") center top no-repeat;
  background-size: 100% auto;
}
.main_content {
  width: 75%;
  float: right;
}
.big_bod {
  width: 55.5rem;
  background-color: rgb(188, 152, 30);
  border: 0.125rem solid white;
  border-radius: 0.3125rem;
}
.small_bod {
  background-color: rgb(215, 206, 176);
  width: 96%;
  margin: 0 auto;
  padding: 0.3125rem;
  border-radius: 0.3125rem;
  margin-bottom: 0.625rem;
  margin-top: 0.625rem;
}
.small_bod_small {
  background-color: rgb(215, 206, 176);
  width: 94%;

  margin: 0 auto;
  padding: 0.3125rem;
  border-radius: 0.3125rem;
  margin-bottom: 0.625rem;
  margin-top: 0.625rem;
}
.useramt {
  margin: 0.3125rem auto;
  color: #6b1c00;
  text-shadow: none;
  text-align: center;
  background-image: linear-gradient(
    90deg,
    transparent 0%,
    #e5dfca 25%,
    #e5dfca 75%,
    transparent 100%
  );
  padding: 1rem;
}
.changeamt {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.isapp_changeamt{
  margin-top: 1.25rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.changeamt_item_sub {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  border-radius: 0.8125rem;
  width: 22%;
  background-image: linear-gradient(
    #3ab2cd 0%,
    #1d67be 25%,
    #203eac 50%,
    #2553b3 75%,
    #297bc7 100%
  );
  border: solid 0.125rem #5d797a;
}
.changeamt_item {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  border-radius: 0.8125rem;
  width: 22%;
  background-image: linear-gradient(
    #a0bab7 0%,
    #6a8387 20%,
    #404c58 50%,
    #4e5f69 75%,
    #7a999b 100%
  );
  border: solid 0.125rem #5d797a;
}
.isapp_changeamt_item {
  margin-bottom: 0.625rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  border-radius: 0.8125rem;
  width: 45%;
  background-image: linear-gradient(
    #a0bab7 0%,
    #6a8387 20%,
    #404c58 50%,
    #4e5f69 75%,
    #7a999b 100%
  );
  border: solid 0.125rem #5d797a;
}
.isapp_changeamt_item_sub {
  margin-bottom: 0.625rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  border-radius: 0.8125rem;
  width: 45%;
  background-image: linear-gradient(
    #3ab2cd 0%,
    #1d67be 25%,
    #203eac 50%,
    #2553b3 75%,
    #297bc7 100%
  );
  border: solid 0.125rem #5d797a;
}
.contract-wrap {
  text-align: left;
  color: #222;
}
.contract-wrap p {
  color: rgb(63, 62, 62);
}
.title {
  color: #222;
  margin: 0.4rem 0;
  font-size: 1rem;
}
a {
  color: #b22024;
  text-decoration: none;
  font-size: 1rem;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  border: solid 0.0625rem #222;
}
.privacy {
  border: solid 0.0625rem #222;
}
.contract-wrap table td {
  border: solid 0.0625rem #222;
  padding: 0.3125rem 0.125rem;
  font-size: 0.9375rem;
}
.contract-wrap table th {
  border: solid 0.0625rem #222;
  color: rgb(58, 57, 57);
}
.guizhe {
  text-align: center;
}
p{
  font-size: 1rem;
}
.xia_left_center img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xia_left_btm img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xiazaitu{
 width: 5.9375rem;
  height: 1.9375rem;
}
</style>
